var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRalewayMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Sat Feb  6 03:10:52 2016\n By Aleksey,,,\nCopyright (c) 2010 - 2013, Matt McInerney (matt@pixelspread.com), Pablo Impallari (impallari@gmail.com), Rodrigo Fuenzalida (hello@rfuenzalida.com) with Reserved Font Name \"Raleway\"\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Raleway-Medium",
    horizAdvX: 591
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Raleway Medium",
    fontWeight: 500,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 6 3 3 1 1 6 0 3",
    ascent: 800,
    descent: -200,
    xHeight: 522,
    capHeight: 710,
    bbox: "-212 -225 1311 930",
    underlineThickness: 50,
    underlinePosition: -150,
    unicodeRange: "U+0020-FB06"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 601,
    d: "M531 664q-28 0 -47.5 -11.5t-32 -29.5t-18.5 -41t-6 -46v-14h157v-69h-157v-453h-88v453h-152v-453h-88v453h-71v69h71v4q1 34 11.5 66t31 56.5t51 39t70.5 14.5q36 0 65.5 -8t52.5 -19q22 29 54.5 47t79.5 18q44 0 69.5 -12.5t41.5 -19.5l-22 -65q-12 8 -28 14.5 t-45 6.5zM339 522q0 19 4 44.5t12 41.5q-16 11 -37.5 14.5t-38.5 3.5q-50 0 -70.5 -29.5t-21.5 -69.5v-5h152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_i",
    unicode: "fi",
    horizAdvX: 525,
    d: "M99 453h-71v69h71v11q0 39 12 76t36 66t60 47t85 18q56 0 97.5 -17.5t66.5 -34.5l-38 -65q-20 17 -52 29t-69 12q-29 0 -49.5 -11.5t-34 -29.5t-20 -41t-6.5 -46v-14h267v-522h-88v453h-179v-453h-88v453z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_l",
    unicode: "fl",
    horizAdvX: 606,
    d: "M609 12q-1 -1 -10 -4t-24 -6.5t-33 -6t-37 -2.5q-53 0 -82 29.5t-29 70.5v460q0 19 -5 39t-16.5 36t-31 26t-49.5 10q-55 0 -79 -37t-26 -96v-9h103v-69h-103v-453h-88v453h-71v69h71v18q0 91 48.5 145.5t143.5 54.5q48 0 84 -12.5t59.5 -35t35.5 -53t12 -67.5v-439 q0 -10 3 -21t10 -20t16.5 -14.5t23.5 -5.5q19 0 38.5 6t20.5 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_i",
    unicode: "ffi",
    horizAdvX: 765,
    d: "M99 453h-71v69h71v4q0 32 10.5 63.5t31.5 56.5t51.5 40.5t70.5 15.5q36 0 65.5 -8t52.5 -19q24 29 61.5 47t88.5 18q53 0 95.5 -17.5t69.5 -34.5l-38 -65q-19 17 -51.5 29t-67.5 12q-30 0 -51.5 -11.5t-35 -29.5t-19.5 -41t-6 -46v-14h267v-522h-88v453h-179v-453h-88 v453h-152v-453h-88v453zM339 522q0 19 4 44.5t12 41.5q-16 11 -37.5 14.5t-38.5 3.5q-25 0 -42.5 -8.5t-28.5 -22.5t-16 -32t-5 -36v-5h152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l",
    unicode: "ffl",
    horizAdvX: 849,
    d: "M748 -7q-53 0 -82.5 29.5t-29.5 70.5v460q0 19 -5 39t-16.5 36t-31 26t-48.5 10t-48.5 -11t-32.5 -30t-18.5 -44t-5.5 -53v-4h102v-69h-102v-453h-88v453h-155v-453h-88v453h-71v69h71v4q0 34 11.5 66t33.5 56.5t53.5 39t70.5 14.5q37 0 63.5 -8t49.5 -19q50 65 153 65 q48 0 83.5 -12.5t59 -35t35.5 -53t12 -67.5v-439q0 -10 3 -21t10 -20t16.5 -14.5t23.5 -5.5q19 0 38.5 6t21.5 6l14 -72q0 -1 -9.5 -4t-24 -6.5t-33 -6t-36.5 -2.5zM342 522q0 21 2.5 47t9.5 40q-16 11 -34 14t-35 3q-24 0 -42.5 -8.5t-31 -22.5t-18.5 -31.5t-6 -34.5v-7 h155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 253
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 262,
    d: "M87 240v477h88v-477h-88zM87 0v124h88v-124h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 324,
    d: "M67 502v216h76v-216h-76zM181 502v216h76v-216h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 692,
    d: "M655 447h-134l-43 -178h133v-68h-149l-49 -201h-73l50 201h-168l-49 -201h-73l50 201h-113v68h129l43 178h-128v64h144l48 199h73l-49 -199h168l48 199h73l-49 -199h118v-64zM406 269l43 178h-168l-43 -178h168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 622,
    d: "M508 561q-12 13 -30 25.5t-41.5 23t-50.5 17t-57 7.5v-237l13 -3q55 -12 99.5 -27.5t76 -38.5t48 -56t16.5 -81q0 -50 -19 -87t-52 -61t-78.5 -36.5t-97.5 -13.5v-100h-44v101q-146 9 -256 99l43 76q15 -15 37 -30.5t50.5 -28.5t61.5 -22.5t69 -12.5v239l-15 4 q-54 13 -95 28t-68.5 36t-41.5 51t-14 72q0 48 17 85.5t47.5 64t72.5 41.5t92 18v101h44v-101q66 -3 119.5 -24t95.5 -56zM486 182q0 26 -10.5 44.5t-30.5 33t-49 25.5t-67 21v-232q75 0 116 27t41 81zM155 519q0 -25 8.5 -43t25.5 -31t44 -22.5t63 -18.5v230 q-73 -4 -107 -34t-34 -81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 733,
    d: "M191 428q-32 0 -60 11.5t-49 31t-33 46.5t-12 57t12 57t33 46.5t49 31t60 11.5t60 -11.5t49 -31t33 -46.5t12 -57t-12 -57t-33 -46.5t-49 -31t-60 -11.5zM191 476q19 0 35.5 8t28.5 21.5t19 31t7 37.5t-7.5 38t-19.5 31.5t-28.5 21t-34.5 7.5q-19 0 -35.5 -8t-28.5 -21.5 t-19 -31.5t-7 -37q0 -20 7 -38t19.5 -31.5t29 -21t34.5 -7.5zM542 -10q-32 0 -60 11.5t-49 31t-33 46.5t-12 57t12 57t33 46.5t49 31t60 11.5t60 -11.5t49 -31t33 -46.5t12 -57t-12 -57t-33 -46.5t-49 -31t-60 -11.5zM542 38q19 0 35.5 8t28.5 21.5t19 31t7 37.5t-7.5 38 t-19.5 31.5t-28.5 21t-34.5 7.5q-19 0 -35.5 -8t-28.5 -21.5t-19 -31.5t-7 -37q0 -20 7 -38t19.5 -31.5t29 -21t34.5 -7.5zM71 33l280 337l268 345l43 -37l-277 -335l-272 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 681,
    d: "M560 0l-74 77q-43 -42 -96.5 -64.5t-114.5 -22.5q-49 0 -91 15t-73 41.5t-48.5 62.5t-17.5 79q0 35 11.5 65t31 55t44.5 46.5t53 40.5q-24 27 -41 49t-27.5 41.5t-15.5 37t-5 36.5q0 34 14 63.5t38.5 51t58 33.5t72.5 12q36 0 67.5 -10t55 -29t37 -46t13.5 -60 q0 -30 -11.5 -56t-31 -48.5t-46.5 -42.5t-57 -40l181 -190q19 36 29.5 78.5t10.5 90.5h73q-1 -65 -16.5 -121t-44.5 -102l137 -143h-116zM284 60q45 0 84 18t70 50l-202 213q-47 -34 -76.5 -70.5t-29.5 -83.5q0 -30 13 -54t34.5 -40t49 -24.5t57.5 -8.5zM177 561 q0 -11 3.5 -21.5t12 -24t23.5 -32t39 -43.5q52 33 84 63.5t32 68.5q0 35 -26 57.5t-66 22.5q-45 0 -73.5 -26.5t-28.5 -64.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 210,
    d: "M67 501v217h76v-217h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 283,
    d: "M42 346q0 51 11 101t30.5 99.5t45 98.5t55.5 99l68 -30q-19 -29 -41.5 -72t-41.5 -93t-32 -103.5t-13 -102.5q0 -79 34 -169.5t92 -181.5l-65 -34q-63 94 -103 192.5t-40 195.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 283,
    d: "M241 346q0 -97 -40 -195.5t-103 -192.5l-65 34q58 91 92 181.5t34 169.5q0 49 -13 102.5t-32 103.5t-41.5 93t-41.5 72l68 30q30 -50 55.5 -99t45 -98.5t30.5 -99.5t11 -101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 329,
    d: "M84 538l44 65l-69 22l13 42l70 -27l-3 74h51l-3 -74l70 27l13 -42l-69 -22l45 -65l-38 -25l-43 67l-44 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 416,
    d: "M366 391v-72h-118v-128h-80v128h-118v72h118v128h80v-128h118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 211,
    d: "M74 -81l20 89h-30v104h83v-104l-30 -89h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 423,
    d: "M64 233v80h295v-80h-295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 202,
    d: "M64 0v112h74v-112h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 633,
    d: "M605 710l-480 -710h-98l479 710h99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 614,
    d: "M560 293q0 -66 -19 -121.5t-53 -96t-80.5 -63t-100.5 -22.5q-55 0 -101.5 22.5t-80 63t-52.5 96t-19 121.5t19 121.5t52.5 96t80 63.5t101.5 23q54 0 100.5 -23t80.5 -63.5t53 -96t19 -121.5zM471 293q0 49 -12 90t-34 70.5t-52 45.5t-66 16q-37 0 -67.5 -16t-52 -45.5 t-33.5 -70.5t-12 -90q0 -50 12 -90.5t33.5 -69.5t52 -45t67.5 -16q36 0 66 16t52 45t34 69.5t12 90.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 450,
    d: "M426 80v-80h-359v80h142v390q-9 -12 -28 -25.5t-42.5 -25t-48.5 -19.5t-44 -8v84q22 0 49 12.5t51.5 29t42 32t20.5 21.5h90v-491h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 535,
    d: "M43 0q0 40 6.5 75t24.5 67t49.5 61t82.5 58q30 16 61 31.5t56.5 33t42 37.5t16.5 47q0 17 -8 34t-23 30t-37.5 21t-51.5 8q-30 0 -54.5 -8.5t-43.5 -21t-33 -26.5t-23 -25l-57 64q8 9 27 24.5t48 31.5t67 27.5t85 11.5q46 0 83 -12.5t62.5 -34.5t39.5 -51.5t14 -62.5 q0 -39 -17 -68t-41.5 -51t-52.5 -37.5t-50 -26.5t-49.5 -26.5t-52.5 -35t-43.5 -43.5t-23.5 -52h341v-80h-445z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 540,
    d: "M358 236q64 -11 101.5 -59t37.5 -119q0 -46 -17 -84t-48.5 -65t-75.5 -41.5t-98 -14.5q-76 0 -133.5 28.5t-89.5 80.5l59 59q23 -41 62 -64.5t102 -23.5q69 0 108.5 31t39.5 94t-42.5 100.5t-123.5 37.5h-26v74h28q72 0 110.5 34.5t38.5 87.5t-37 79t-93 26 q-55 0 -96.5 -23.5t-64.5 -65.5l-54 56q13 25 35.5 45.5t52 35.5t64 23t72.5 8q47 0 86.5 -13t68 -36t44 -56t15.5 -73q0 -30 -8.5 -57t-25 -49t-40 -36.5t-52.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 558,
    d: "M345 -127v169h-321v78l349 451h60v-449h88v-80h-88v-169h-88zM115 122h239v313z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 548,
    d: "M281 314q49 0 91.5 -16.5t73.5 -46.5t49 -72t18 -92q0 -53 -19.5 -96.5t-53.5 -74.5t-80 -48t-98 -17q-76 0 -137 36t-92 96l55 48q28 -46 74.5 -74t100.5 -28q34 0 63.5 11.5t51 32t33.5 49.5t12 64q0 33 -12 61t-32.5 48t-48.5 31t-60 11q-43 0 -80.5 -19t-61.5 -54 h-79q1 5 5 25.5t10 50t13 65.5t14 73q17 86 38 193h345v-81h-280l-43 -226q22 23 55 36.5t75 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 606,
    d: "M562 235q0 -51 -19.5 -95.5t-54 -78t-80.5 -52.5t-100 -19q-57 0 -104.5 21t-81.5 60.5t-52.5 96t-18.5 128.5q0 105 19 183.5t54 131t84 78.5t109 26q69 0 125.5 -33t88.5 -93l-54 -53q-22 47 -65 74.5t-96 27.5q-41 0 -74 -18.5t-57 -54.5t-37 -87.5t-14 -117.5 q22 52 71 83t112 31q51 0 96 -18.5t78 -51t52 -76t19 -93.5zM309 66q34 0 65 13.5t54 36.5t36.5 53.5t13.5 65.5q0 34 -13.5 65t-36.5 53.5t-54 36t-65 13.5q-35 0 -65.5 -13.5t-53.5 -36t-36.5 -53.5t-13.5 -65q0 -35 13.5 -65.5t36.5 -53.5t53.5 -36.5t65.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 535,
    d: "M392 502h-365v81h504l-357 -710h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 598,
    d: "M549 201q0 -48 -20.5 -86.5t-55 -65.5t-80 -42t-96.5 -15q-53 0 -98.5 16.5t-78.5 45t-52 67.5t-19 84q0 33 12 61t30.5 50t42.5 38.5t48 25.5q-22 9 -42 23.5t-35 33t-23.5 40.5t-8.5 47q0 45 20.5 79.5t53 58.5t72.5 36t80 12t80.5 -12t73 -35.5t53 -58t20.5 -79.5 q0 -50 -33 -88t-78 -57q27 -11 51.5 -28t42.5 -39.5t29 -50.5t11 -61zM460 207q0 32 -14.5 57.5t-37.5 43t-52 26.5t-58 9q-30 0 -58.5 -9.5t-51 -27.5t-36 -43.5t-13.5 -56.5q0 -32 14.5 -57t37.5 -42t51.5 -26.5t57.5 -9.5q30 0 58.5 10t51 28t36.5 43t14 55zM162 521 q0 -27 12.5 -47.5t32.5 -34.5t44 -21t48 -7t48 7.5t44 21.5t32.5 35t12.5 48q0 25 -11.5 45t-30.5 34t-44 21.5t-52 7.5t-51.5 -7.5t-43 -22t-30 -35t-11.5 -45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 589,
    d: "M36 326q0 51 19.5 95.5t54 78t80.5 52.5t100 19q57 0 104.5 -21t81.5 -60.5t52.5 -96t18.5 -128.5q0 -105 -19 -183.5t-54 -131t-84 -78.5t-109 -26q-69 0 -125.5 33t-88.5 93l54 53q22 -47 65 -74.5t96 -27.5q82 0 131 73t51 205q-22 -52 -71 -83t-112 -31 q-51 0 -96 18.5t-78 50.5t-52 76t-19 94zM289 495q-35 0 -65.5 -13.5t-53.5 -36.5t-36.5 -53.5t-13.5 -65.5t13.5 -65.5t36.5 -53t53.5 -36t65.5 -13.5t65.5 13.5t53.5 36t36.5 53t13.5 65.5q0 34 -13.5 65t-36.5 54t-54 36.5t-65 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 201,
    d: "M64 406v112h73v-112h-73zM64 0v112h73v-112h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 221,
    d: "M69 406v112h73v-112h-73zM79 -81l20 89h-30v104h83v-104l-30 -89h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 510,
    d: "M33 280l420 253v-94l-292 -180l292 -177v-98l-420 250v46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 439,
    d: "M67 179v60h305v-60h-305zM67 313v60h305v-60h-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 510,
    d: "M477 234l-420 -250v98l292 177l-292 180v94l420 -253v-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 479,
    d: "M144 211q0 54 19 94.5t65 69.5q18 12 41.5 25t44.5 30.5t35.5 42t14.5 58.5q0 28 -10.5 49.5t-27.5 36t-39 22t-46 7.5q-25 0 -47.5 -7.5t-41.5 -20.5t-34 -30.5t-25 -36.5l-59 39q13 31 35 55t50 40.5t59.5 25t64.5 8.5q37 0 73 -11.5t64 -35.5t45 -60t17 -85 q0 -38 -10.5 -65t-27.5 -47t-40 -35t-48 -29q-18 -10 -36 -21t-31.5 -26.5t-22 -37.5t-8.5 -55h-74zM146 0v116h74v-116h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 840,
    d: "M419 603q74 0 140.5 -27t117 -76.5t80 -120t29.5 -157.5q0 -14 -1.5 -37.5t-6.5 -49.5t-14.5 -53t-26.5 -49t-41.5 -35.5t-58.5 -13.5q-26 0 -42 7.5t-25.5 20t-13.5 28.5t-6 33q-29 -30 -73 -50.5t-97 -20.5q-73 0 -112.5 38.5t-39.5 97.5q0 39 16.5 66t43.5 43t60.5 23 t66.5 7q43 0 75 -8.5t48 -14.5q0 33 -5.5 60.5t-19 47t-37 30.5t-59.5 11q-40 0 -75 -12.5t-63 -33.5l-20 49q36 24 77.5 37.5t88.5 13.5q58 0 92 -19t51 -49t21.5 -66.5t4.5 -71.5v-119q0 -22 1.5 -41t6.5 -33t15.5 -22t27.5 -8q30 0 49 21t30.5 51.5t15.5 64t4 59.5 q0 72 -24.5 133.5t-68.5 107.5t-104 72t-130 26q-69 0 -129 -25t-104.5 -69t-70 -105.5t-25.5 -133.5q0 -70 24 -131t67 -106.5t102 -72t129 -26.5q45 0 81 10.5t73 27.5l14 -38q-41 -20 -83.5 -30t-85.5 -10q-75 0 -141 28t-115.5 78t-78 119t-28.5 151q0 86 31 155 t82.5 117.5t119 74.5t140.5 26zM476 76q39 18 50 43.5t11 51.5v37q-13 2 -45.5 12t-77.5 10q-26 0 -49 -4.5t-41 -15t-28.5 -27t-10.5 -41.5q0 -38 27 -63t72 -25q24 0 48.5 6.5t43.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 677,
    d: "M301 710h76l290 -710h-96l-84 208h-298l-83 -208h-96zM467 278l-128 328l-132 -328h260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 671,
    d: "M630 183q0 -41 -16.5 -75t-45 -58t-66 -37t-80.5 -13h-337v710h353q37 0 67 -16t51 -41.5t32.5 -58t11.5 -65.5q0 -53 -26.5 -98t-75.5 -67q61 -18 96.5 -66.5t35.5 -114.5zM539 199q0 24 -8.5 46.5t-23 39.5t-34.5 27t-44 10h-254v-244h247q25 0 46 10t37 26.5t25 38.5 t9 46zM175 632v-237h226q24 0 44 9.5t34.5 25.5t23 37.5t8.5 45.5q0 25 -8 47t-21.5 38t-33 25t-41.5 9h-232z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 682,
    d: "M39 360q0 64 22.5 127.5t66 114t106.5 81.5t143 31q95 0 163 -43t101 -112l-71 -46q-16 34 -38.5 57t-49 37t-54.5 20t-55 6q-59 0 -104.5 -24.5t-76.5 -64t-46.5 -89t-15.5 -99.5q0 -56 18.5 -106.5t51.5 -89.5t78 -62t98 -23q28 0 57.5 7t56.5 22.5t50.5 39t38.5 56.5 l75 -41q-17 -40 -47.5 -70.5t-69 -51.5t-81.5 -32t-84 -11q-73 0 -134 32t-105.5 83.5t-69 117t-24.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 716,
    d: "M85 0v710h246q85 0 149.5 -28t107.5 -76t64.5 -112.5t21.5 -137.5q0 -81 -24 -146.5t-69 -112t-108.5 -72t-141.5 -25.5h-246zM583 356q0 60 -16.5 110.5t-49 86.5t-79.5 56.5t-107 20.5h-156v-550h156q61 0 108.5 21t79 58t48 87.5t16.5 109.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 605,
    d: "M567 80v-80h-482v710h473v-80h-383v-230h333v-75h-333v-245h392z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 583,
    d: "M85 0v710h469v-80h-379v-237h319v-75h-319v-318h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 714,
    d: "M586 96q-94 -101 -216 -101q-71 0 -131.5 31t-104.5 81.5t-69.5 115.5t-25.5 134q0 72 25 136.5t69 114t105 78.5t132 29q103 0 169.5 -43t101.5 -112l-69 -48q-32 62 -85 92t-119 30q-54 0 -98 -23.5t-75 -62t-48 -89t-17 -104.5q0 -57 19 -107.5t52 -89t78 -60.5 t98 -22q116 0 209 112v98h-153v68h229v-354h-76v96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 741,
    d: "M656 710v-710h-90v323h-391v-323h-90v710h90v-307h391v307h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 260,
    d: "M85 0v710h90v-710h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 485,
    d: "M35 106q20 -14 54 -25t77 -11q51 0 81 18t45.5 53.5t20.5 87.5t5 120v361h90v-361q0 -81 -7.5 -147.5t-33 -113.5t-73 -73t-128.5 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 652,
    d: "M85 0v709h90v-392l366 393h97l-285 -313l301 -397h-98l-258 345l-123 -128v-217h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 584,
    d: "M85 0v710h90v-630h396v-80h-486z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 874,
    d: "M699 0v549l-236 -421h-51l-237 421v-549h-90v710h95l257 -461l258 461h94v-710h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 770,
    d: "M175 542v-542h-90v710h70l440 -553v552h90v-709h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 748,
    d: "M373 -5q-75 0 -136.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q75 0 136 -31.5t105 -82.5t68 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-106 -79t-133.5 -29.5zM130 355q0 -54 17.5 -104.5t49.5 -89.5t77 -62t100 -23 q57 0 102 24.5t76.5 64t48 89.5t16.5 101q0 54 -17.5 104.5t-50 89t-77 61.5t-98.5 23q-57 0 -102 -24t-76.5 -63t-48.5 -89t-17 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 623,
    d: "M85 0v710h296q47 0 86.5 -19.5t68 -52t44.5 -73t16 -82.5q0 -44 -15 -85t-42.5 -73t-66 -51t-85.5 -19h-212v-255h-90zM175 335h207q28 0 50.5 11.5t38.5 32t25 47.5t9 57q0 31 -10.5 58t-28 47t-41 31t-49.5 11h-201v-295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 746,
    d: "M563 58q-40 -29 -88 -46t-102 -17q-75 0 -136.5 31t-105.5 81t-68 115t-24 133q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q75 0 136 -31.5t105 -82.5t68 -115.5t24 -131.5q0 -72 -25.5 -136.5t-70.5 -114.5l89 -103h-88zM374 76q39 0 73 12t62 33l-95 111h88l54 -63 q29 39 45 87t16 99q0 54 -17.5 104.5t-50 89.5t-77 62t-98.5 23q-57 0 -102 -24t-76.5 -63.5t-48.5 -89.5t-17 -102q0 -54 17.5 -104.5t49.5 -89.5t77 -62t100 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 657,
    d: "M85 0v710h304q47 0 86.5 -19.5t68 -52t44.5 -73t16 -82.5q0 -37 -10.5 -71.5t-30 -62.5t-47 -48t-61.5 -29l172 -272h-102l-162 255h-188v-255h-90zM175 335h215q28 0 50.5 12t38.5 32.5t25 47.5t9 56q0 30 -10.5 56.5t-28 47t-41 32t-49.5 11.5h-209v-295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 609,
    d: "M502 561q-12 14 -32 27t-45 23.5t-54.5 17t-61.5 6.5q-83 0 -121.5 -31t-38.5 -85q0 -29 11 -48t34.5 -32.5t58.5 -23.5t83 -21q55 -12 99.5 -27.5t76 -38.5t48 -56t16.5 -81q0 -51 -20 -88.5t-54.5 -62t-81.5 -36t-102 -11.5q-82 0 -155.5 25.5t-133.5 74.5l43 76 q16 -17 41.5 -34t58 -30.5t70 -22t78.5 -8.5q76 0 118 27t42 81q0 30 -13.5 50.5t-39.5 35.5t-64.5 26.5t-87.5 23.5q-54 13 -95 28t-68.5 36t-41.5 51t-14 72q0 51 19 90t53 66t81 40.5t102 13.5q72 0 130 -22t103 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 614,
    d: "M597 630h-245v-630h-90v630h-245v80h580v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 755,
    d: "M377 76q62 0 103 24t65.5 62.5t34.5 88t10 100.5v359h90v-359q0 -72 -16.5 -136.5t-52.5 -113.5t-93.5 -77.5t-139.5 -28.5q-85 0 -143 30t-93.5 79.5t-51 114t-15.5 132.5v359h90v-359q0 -53 10.5 -102.5t35 -87.5t65 -61.5t101.5 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 680,
    d: "M105 710l235 -597l234 597h95l-290 -710h-78l-291 710h95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1049,
    d: "M345 706h85l94 -247l95 247h85l-123 -309l122 -293l240 606h98l-297 -710h-78l-141 335l-142 -335h-78l-296 710h97l241 -606l121 293z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 637,
    d: "M103 710l216 -296l216 296h99l-267 -360l259 -350h-99l-208 286l-208 -286h-100l259 350l-267 360h100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 655,
    d: "M112 710l215 -370l217 370h98l-270 -451v-259h-90v261l-269 449h99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 631,
    d: "M32 70l458 560h-449v80h554v-70l-450 -560h450v-80h-563v70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 270,
    d: "M84 -40v780h140v-72h-58v-636h58v-72h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 590,
    d: "M127 710l435 -710h-98l-436 710h99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 270,
    d: "M46 -40v72h58v636h-58v72h140v-780h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 553,
    d: "M42 303l198 407h74l197 -407h-75l-159 328l-162 -328h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 503,
    d: "M63 -80v80h377v-80h-377z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 232,
    d: "M48 730h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 554,
    d: "M205 -10q-37 0 -69 12.5t-55.5 34.5t-37 51.5t-13.5 64.5q0 36 16 65.5t45.5 50.5t70 33t88.5 12q38 0 77 -7t69 -19v42q0 64 -36 100.5t-102 36.5q-79 0 -166 -61l-29 57q101 68 203 68q103 0 160.5 -55t57.5 -155v-213q0 -31 28 -32v-76q-14 -2 -23 -3t-19 -1 q-26 0 -41.5 15.5t-18.5 37.5l-2 37q-35 -47 -88.5 -71.5t-114.5 -24.5zM228 56q47 0 87.5 17.5t61.5 46.5q19 19 19 39v77q-64 25 -133 25q-66 0 -107.5 -28t-41.5 -73q0 -22 8.5 -41t24 -33t36.5 -22t45 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 623,
    d: "M339 -10q-61 0 -111 30t-79 78v-98h-78v730h88v-312q33 51 81 82t112 31q54 0 97 -23t73.5 -60.5t47 -87t16.5 -101.5q0 -55 -19 -104t-52 -85.5t-78.5 -58t-97.5 -21.5zM317 66q39 0 72 16t57 43t37 61.5t13 72.5t-12.5 73.5t-35 62.5t-54 43.5t-69.5 16.5 q-28 0 -53 -10t-46.5 -26.5t-38 -38.5t-28.5 -47v-151q5 -25 21.5 -46t39 -36.5t48 -24.5t49.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 554,
    d: "M36 262q0 55 19 104t54 85.5t83.5 58t108.5 21.5q78 0 134.5 -34.5t85.5 -92.5l-86 -27q-20 37 -56 57.5t-80 20.5q-36 0 -68 -14.5t-55 -40.5t-36.5 -61t-13.5 -77q0 -41 14 -77t37.5 -62.5t55 -41.5t67.5 -15q23 0 45.5 6.5t41 17.5t32.5 25.5t20 31.5l86 -26 q-12 -29 -33.5 -53t-50.5 -41t-64.5 -27t-74.5 -10q-59 0 -108 22t-84 59t-54.5 86.5t-19.5 104.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 629,
    d: "M286 -10q-54 0 -100 22t-79 59t-51.5 86t-18.5 103q0 55 17.5 104.5t49 86.5t75 58.5t95.5 21.5q63 0 112.5 -33t78.5 -80v312h88v-622q0 -31 28 -32v-76q-14 -2 -22.5 -3t-16.5 -1q-26 0 -45.5 17.5t-19.5 40.5v44q-31 -51 -82.5 -79.5t-108.5 -28.5zM307 66 q24 0 49.5 9t48 25t39 37.5t21.5 45.5v150q-9 25 -27 47.5t-40.5 39t-48 26t-50.5 9.5q-39 0 -70.5 -16.5t-54 -44t-34.5 -63t-12 -72.5q0 -39 14 -74.5t38 -61.5t56.5 -41.5t70.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    d: "M302 -10q-59 0 -108 21.5t-84 58.5t-54.5 86.5t-19.5 104.5t19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21 q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 343,
    d: "M99 0v453h-71v69h71v11q0 97 43 152t117 55q31 0 61 -8.5t54 -23.5l-22 -65q-14 10 -34.5 16t-40.5 6q-44 0 -67 -33t-23 -96v-14h139v-69h-139v-453h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 624,
    d: "M279 -6q-53 0 -97.5 22t-76.5 59t-49.5 85t-17.5 100q0 55 17.5 104.5t49.5 86.5t76.5 58.5t98.5 21.5q66 0 114 -32t81 -81v104h78v-516q0 -56 -21 -98.5t-57 -71.5t-84.5 -44t-103.5 -15q-89 0 -144.5 30.5t-92.5 84.5l51 45q31 -46 80 -69t106 -23q36 0 68.5 10 t56.5 30t38.5 50t14.5 71v92q-15 -24 -35.5 -43.5t-44.5 -33t-51 -20.5t-55 -7zM306 66q28 0 54 10t48 26.5t37 37.5t20 43v150q-11 27 -28.5 49t-39.5 38.5t-47.5 25.5t-51.5 9q-40 0 -71.5 -17t-53.5 -45t-34 -63.5t-12 -71.5q0 -39 14 -74t38 -61t56.5 -41.5t70.5 -15.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 590,
    d: "M524 0h-88v292q0 81 -28 120.5t-82 39.5q-26 0 -52 -10.5t-48.5 -28.5t-40 -43t-26.5 -55v-315h-88v730h88v-320q31 57 84 89t116 32q46 0 78 -17t51 -46t27.5 -69.5t8.5 -86.5v-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 230,
    d: "M71 0v522h88v-522h-88zM71 620v110h88v-110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 237,
    d: "M4 -186q-35 0 -65.5 10t-54.5 32l41 59q14 -13 32.5 -18t36.5 -5q16 0 31 6.5t27 17.5t19 27t7 34v545h88v-539q0 -37 -13.5 -68t-36 -53.5t-51.5 -35t-61 -12.5zM78 620v110h88v-110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 539,
    d: "M439 0l-180 255l-100 -94v-161h-88v730h88v-480l268 271h97l-208 -216l218 -305h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 286,
    d: "M73 730h88v-595q0 -29 15.5 -45.5t43.5 -16.5q11 0 26 3.5t28 8.5l14 -71q-22 -9 -52 -15t-53 -6q-51 0 -80.5 29t-29.5 81v627z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 924,
    d: "M858 0h-88v292q0 82 -26.5 121t-78.5 39q-54 0 -96.5 -38.5t-60.5 -99.5v-314h-88v292q0 84 -26 122t-78 38q-53 0 -96 -37.5t-61 -99.5v-315h-88v522h80v-112q32 58 83 89.5t115 31.5q66 0 104.5 -35.5t47.5 -91.5q70 127 199 127q45 0 75.5 -16.5t48.5 -46t26 -69.5 t8 -87v-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 590,
    d: "M524 0h-88v292q0 84 -25.5 122t-77.5 38q-27 0 -54 -10.5t-51 -28.5t-42 -43t-27 -55v-315h-88v522h80v-112q31 55 89.5 88t127.5 33q45 0 75 -16.5t48 -46t25.5 -69.5t7.5 -87v-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 599,
    d: "M299 -10q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59t54 -86t19.5 -104q0 -54 -19 -103t-54 -86t-83.5 -59t-107.5 -22zM126 259q0 -41 13.5 -76t37 -61t55 -41t67.5 -15t67.5 15t55.5 41.5t37.5 62t13.5 76.5 q0 40 -13.5 75.5t-37.5 62t-55.5 41.5t-67.5 15t-67.5 -15.5t-55 -42t-37 -62t-13.5 -76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 623,
    d: "M352 -10q-65 0 -114.5 32t-78.5 81v-316h-88v735h78v-98q31 48 80.5 77.5t109.5 29.5q54 0 99 -22t78 -59.5t51.5 -86.5t18.5 -102q0 -56 -17 -105.5t-48 -86t-74 -58t-95 -21.5zM325 66q39 0 70.5 16.5t54 44t34.5 62.5t12 72q0 39 -14 74.5t-38 62t-56.5 42t-70.5 15.5 q-24 0 -49.5 -9.5t-48 -25t-39 -37t-21.5 -45.5v-149q11 -26 28 -48.5t39 -39t47 -26t52 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 623,
    d: "M271 -10q-52 0 -95 22t-74 59.5t-48 86.5t-17 103q0 55 19 104t52.5 86t78.5 58.5t97 21.5q61 0 111 -30t79 -78v99h78v-623q0 -31 28 -32v-76q-24 -3 -47 -3q-28 0 -48.5 20.5t-20.5 49.5v245q-72 -113 -193 -113zM301 66q56 0 96.5 32.5t66.5 79.5v150q-5 25 -21 48.5 t-38.5 40.5t-49 27.5t-52.5 10.5q-39 0 -71 -16.5t-55.5 -44t-36.5 -63t-13 -72.5q0 -39 13 -74.5t36 -61.5t55 -41.5t70 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 363,
    d: "M347 445q-66 -2 -116.5 -34t-71.5 -89v-322h-88v522h82v-121q27 54 71 87.5t94 37.5h17t12 -1v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 494,
    d: "M254 -10q-63 0 -124 19.5t-105 56.5l38 59q46 -35 92 -52.5t97 -17.5q57 0 90.5 22.5t33.5 63.5q0 19 -9 32.5t-27 23.5t-46 18t-65 17q-47 12 -81 23t-56 26t-32 36t-10 52q0 39 15.5 69.5t42.5 51t63.5 31t78.5 10.5q59 0 110 -19t86 -50l-40 -53q-33 29 -74 43.5 t-84 14.5q-48 0 -81.5 -20.5t-33.5 -65.5q0 -18 6.5 -30t21.5 -21t38.5 -16t56.5 -15q52 -12 90.5 -24.5t64 -29.5t38 -40t12.5 -56q0 -73 -56 -116t-151 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 352,
    d: "M341 26q-8 -4 -21 -9.5t-29.5 -11t-36 -9t-40.5 -3.5q-48 0 -83 26.5t-35 82.5v351h-71v69h71v174h88v-174h117v-69h-117v-324q2 -29 19 -42t40 -13q26 0 47.5 8.5t29.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 601,
    d: "M232 -10q-82 0 -124 55t-42 164v313h88v-296q0 -160 111 -160q54 0 101.5 34.5t70.5 94.5v327h88v-414q0 -31 28 -32v-76q-15 -2 -23.5 -2.5t-16.5 -0.5q-26 0 -43.5 15.5t-18.5 38.5l-2 61q-35 -59 -92 -90.5t-125 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 538,
    d: "M222 0l-206 522h91l165 -445l166 445h84l-206 -522h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 821,
    d: "M725 522h85l-222 -522h-73l-105 255l-104 -255h-73l-222 522h84l180 -435l88 217l-90 217h73l64 -167l64 167h73l-89 -217l88 -217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 513,
    d: "M105 522l143 -192l8 -16l9 16l142 192h93l-195 -262l196 -260h-93l-143 191l-9 15l-8 -15l-143 -191h-93l196 260l-195 262h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 545,
    d: "M95 -142q13 -2 26 -3t20 -1q12 0 21.5 5.5t19 21.5t21.5 44.5t30 74.5l-221 522h91l178 -443l162 443h84l-254 -659q-14 -35 -46.5 -61.5t-89.5 -26.5q-9 0 -18.5 1t-23.5 4v78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 493,
    d: "M30 57l334 401h-325v64h419v-57l-332 -401h333v-64h-429v57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 271,
    d: "M169 668v-244q0 -14 -6.5 -32t-22.5 -32q15 -14 22 -32t7 -32v-255h55v-72h-112q-8 0 -15.5 6.5t-7.5 23.5v271q0 22 -11.5 39t-30.5 20v64q10 0 18 6t13.5 15t8 18.5t2.5 17.5v260q0 19 9 24.5t14 5.5h112v-72h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 240,
    d: "M82 -130v905h76v-905h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 271,
    d: "M47 668v72h112q5 0 14 -5.5t9 -24.5v-260q0 -8 2.5 -17.5t8 -18.5t13 -15t18.5 -6v-64q-20 -3 -31 -20t-11 -39v-271q0 -17 -8 -23.5t-15 -6.5h-112v72h55v255q0 14 6.5 32t22.5 32q-16 14 -22.5 32t-6.5 32v244h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 532,
    d: "M65 237q0 6 6 24t20 37.5t36 35t55 15.5q24 0 45 -9t40.5 -19.5t39 -19.5t40.5 -9q19 0 32.5 7.5t21.5 16.5t11.5 17.5t3.5 10.5h52q0 -3 -6 -20t-20 -36.5t-37.5 -35t-58.5 -15.5q-26 0 -47.5 8.5t-41.5 19t-38.5 19.5t-37.5 9q-18 0 -30.5 -8.5t-20 -19t-10.5 -19 t-3 -9.5h-52v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 253
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 260,
    d: "M174 474v-477h-88v477h88zM174 714v-124h-88v124h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 570,
    d: "M276 -120v111q-51 4 -94 28.5t-74 61.5t-48.5 83t-17.5 94q0 51 16 97.5t46 83t73.5 61t98.5 30.5v115h44v-115q73 -2 125.5 -35t81.5 -91l-85 -27q-20 36 -52 54.5t-70 20.5v-384q18 1 37.5 7.5t37.5 16.5t32 24t19 31l86 -26q-13 -33 -37.5 -57.5t-54.5 -41 t-61.5 -24.5t-58.5 -8v-110h-44zM132 258q0 -33 10.5 -64t30 -56t45.5 -42.5t58 -23.5v377q-34 -4 -61 -22t-45.5 -44.5t-28 -59t-9.5 -65.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 512,
    d: "M53 375h87q-10 21 -21 41t-20.5 40t-15.5 41.5t-6 44.5q0 36 15 67.5t40.5 55t60 37t73.5 13.5q57 0 107 -28t82 -77l-49 -54q-24 39 -63 62.5t-79 23.5q-23 0 -42 -8.5t-33.5 -22.5t-22.5 -34t-8 -42q0 -20 6.5 -39.5t16 -39t21 -39.5t21.5 -42h179v-68h-157 q2 -11 3 -21.5t1 -21.5q0 -49 -22 -93t-76 -102q37 10 74 10q40 0 72.5 -9t67.5 -9q20 0 39.5 4.5t45.5 13.5l22 -67q-26 -13 -54.5 -20t-56.5 -7q-23 0 -43.5 4t-41.5 8.5t-42.5 8.5t-44.5 4q-25 0 -56 -5t-58 -13l-22 64q64 61 91.5 108t27.5 96q0 24 -6 47h-113v68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 538,
    d: "M160 486q22 17 49.5 26t59.5 9t59 -9t50 -26l71 72l41 -41l-72 -72q33 -47 33 -108q0 -60 -34 -108l73 -72l-36 -36l-74 69q-22 -17 -50 -26.5t-61 -9.5t-61 9.5t-51 26.5l-73 -69l-36 36l72 72q-16 23 -24.5 50.5t-8.5 57.5q0 62 32 108l-71 72l41 41zM159 336 q0 -26 8.5 -48t23.5 -38t35 -25.5t43 -9.5t43 9.5t35 26t23.5 39t8.5 48.5t-8.5 48t-23.5 38.5t-35 25.5t-43 9t-43 -9.5t-35 -26t-23.5 -39t-8.5 -48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 687,
    d: "M454 377h81v-60h-114l-34 -58v-28h149v-60h-149v-171h-90v171h-147v60h147v30l-32 56h-115v60h83l-204 333h98l215 -370l217 370h99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 242,
    d: "M159 273v-403h-76v403h76zM159 775v-403h-76v403h76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 517,
    d: "M430 201q43 -29 43 -104q0 -48 -20 -83t-50.5 -57.5t-67 -33.5t-70.5 -11q-36 0 -67.5 9t-57 23t-45.5 31t-34 32l57 54q35 -34 69.5 -49.5t74.5 -15.5q22 0 43.5 6.5t38.5 19t27.5 31t10.5 41.5q0 25 -10 40.5t-26.5 23.5t-36.5 11.5t-39 4.5q-45 3 -81.5 14.5 t-62.5 32.5t-40.5 51t-14.5 69q0 28 7.5 49t16.5 33q-19 15 -33.5 45t-14.5 70q0 38 17 70.5t44.5 56t63.5 37t75 13.5t69.5 -9.5t54 -24.5t40.5 -33.5t29 -36.5l-68 -32q-17 31 -51 44t-69 13q-23 0 -43.5 -6.5t-37 -19.5t-26 -31t-9.5 -40q0 -26 9 -43t24.5 -27.5t37 -15 t46.5 -4.5q36 0 73 -8.5t66 -27.5t47.5 -49t18.5 -74q0 -29 -8.5 -52.5t-19.5 -36.5zM157 330q0 -42 21.5 -60t52 -25.5t63 -9t54.5 -10.5q12 10 19 27.5t7 35.5q0 25 -11.5 42.5t-28.5 27.5t-38 14.5t-40 4.5q-46 0 -77 13q-10 -10 -16 -26.5t-6 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 368,
    d: "M66 624v102h74v-102h-74zM228 624v102h74v-102h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 836,
    d: "M416 -7q-80 0 -147.5 27.5t-116.5 76t-77 114.5t-28 144q0 77 28 143t77 114t116.5 75.5t147.5 27.5t148.5 -27.5t118.5 -75.5t78 -114t28 -143q0 -78 -28 -144t-78 -114.5t-118.5 -76t-148.5 -27.5zM416 31q70 0 130.5 23.5t105.5 66t70.5 101.5t25.5 131 q0 69 -25 128.5t-69.5 103t-105 68t-132.5 24.5q-71 0 -131 -24.5t-104 -68t-69 -102.5t-25 -128t25 -128t69 -102.5t104 -68t131 -24.5zM424 121q-49 0 -92.5 17t-76 48t-51.5 74t-19 95q0 43 14.5 85t43.5 75.5t73 54t103 20.5q70 0 123.5 -30t77.5 -86l-85 -27 q-9 20 -23.5 33t-30 20.5t-32 10.5t-30.5 3q-36 0 -63 -13.5t-45 -36t-27 -51t-9 -58.5q0 -38 13.5 -67.5t34.5 -49.5t47 -30.5t51 -10.5q35 0 69.5 18.5t50.5 51.5l85 -26q-8 -20 -26 -41.5t-44 -39t-59.5 -28.5t-72.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 438,
    d: "M165 344q-25 0 -47 8.5t-38 23.5t-25 35t-9 44q0 50 41.5 81t107.5 31q26 0 51 -4.5t45 -12.5v25q0 40 -23 63t-66 23q-28 0 -55.5 -10.5t-57.5 -30.5l-23 45q70 46 142 46t113 -37t41 -107v-131q0 -23 21 -24v-62q-10 -2 -16.5 -2.5t-14.5 -0.5q-22 0 -34.5 11t-14.5 28 l-1 23q-25 -32 -60.5 -48.5t-76.5 -16.5zM185 397q29 0 54 10.5t39 27.5q13 12 13 26v48q-19 8 -41 11.5t-43 3.5q-42 0 -68 -17t-26 -46q0 -27 20.5 -45.5t51.5 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 596,
    d: "M40 280l253 181v-74l-182 -128l182 -125v-74l-253 174v46zM282 280l253 181v-74l-182 -128l182 -125v-74l-253 174v46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    d: "M521 375v-255h-76v175h-378v80h454z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 582,
    d: "M64 233v80h454v-80h-454z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 836,
    d: "M417 -7q-80 0 -147.5 27.5t-117 76t-77.5 114.5t-28 144q0 77 28 143t77.5 114t117 75.5t147.5 27.5t148 -27.5t118 -75.5t78 -114t28 -143q0 -78 -28 -144t-78 -114.5t-118 -76t-148 -27.5zM417 30q70 0 130 23.5t104.5 66.5t70 102.5t25.5 131.5q0 69 -25 128 t-69 102.5t-104.5 68t-131.5 24.5t-131.5 -24.5t-104 -68t-68 -102.5t-24.5 -127q0 -69 24.5 -128.5t68 -103t104 -68.5t131.5 -25zM262 579h192q30 0 55 -12.5t43 -33t28 -46.5t10 -52q0 -47 -26.5 -84.5t-69.5 -48.5l109 -172h-73l-102 162h-101v-162h-65v449zM451 349 q36 0 55.5 24t19.5 62t-22.5 61.5t-55.5 23.5h-121v-171h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 403,
    d: "M56 654v58h292v-58h-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 272,
    d: "M47 637q0 37 25.5 62t63.5 25t63.5 -25t25.5 -62q0 -40 -25.5 -65.5t-63.5 -25.5t-63.5 26t-25.5 65zM106 665q-12 -14 -12 -30q0 -17 12 -29q13 -13 30 -13q19 0 30 13q12 12 12 29q0 16 -12 30q-11 12 -30 12q-18 0 -30 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 466,
    d: "M67 51v72h332v-72h-332zM399 404v-72h-126v-136h-80v136h-126v72h126v136h80v-136h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 396,
    d: "M34 400q0 39 7.5 68.5t23 51.5t39.5 38.5t57 29.5q23 9 47.5 17.5t44 20t32 26.5t12.5 37q0 29 -24.5 48.5t-72.5 19.5t-79 -18t-47 -35l-36 39q5 7 18 18.5t34.5 22.5t51 19t66.5 8q75 0 113 -34.5t38 -88.5q0 -32 -14 -53.5t-35 -36t-45 -23.5t-44 -15 q-31 -10 -50.5 -23t-30.5 -27t-15 -28.5t-4 -27.5h231v-54h-318z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 394,
    d: "M190 394q-63 0 -105.5 23t-52.5 63l32 38q1 -11 10.5 -22.5t26 -22t39 -17t49.5 -6.5q47 0 79.5 17.5t32.5 47.5q0 33 -40 50.5t-109 17.5h-23v51h23q63 0 99 15t36 47q0 30 -30.5 47t-69.5 17q-41 0 -70 -15t-45 -39l-37 43q20 29 62 45.5t90 16.5q34 0 63 -8.5 t50.5 -23.5t33.5 -35.5t12 -44.5q0 -35 -23.5 -57t-68.5 -31q48 -7 75.5 -36t27.5 -68q0 -27 -13.5 -48.5t-37 -35.5t-53.5 -21.5t-63 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 232,
    d: "M106 609l-58 20l58 101h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 628,
    d: "M78 522h88v-296q0 -160 113 -160q26 0 52 9t48.5 25.5t40.5 40.5t30 54v327h88v-414q0 -31 28 -32v-76q-15 -2 -24 -2.5t-17 -0.5q-28 0 -45.5 18.5t-17.5 41.5v55q-12 -24 -32 -46t-44.5 -39t-53 -27t-58.5 -10q-46 0 -74 22.5t-39 54.5v-279h-83v734z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 618,
    d: "M35 465q0 116 74 180.5t208 64.5h257v-68h-70v-722h-76v304h-67v-304h-76v304q-57 1 -103.5 18t-79 48t-50 75.5t-17.5 99.5zM110 467q0 -43 14 -74.5t38 -53.5t55.5 -33.5t67.5 -13.5v350q-85 -2 -130 -48.5t-45 -126.5zM428 642h-67v-350h67v350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 202,
    d: "M64 245v124h74v-124h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 296,
    d: "M42 -126q13 -7 37.5 -13t50.5 -6q27 0 42 8t15 27q0 20 -14 27.5t-37 7.5q-21 0 -44 -4.5t-36 -8.5l58 109l39 -14l-35 -55q8 3 18 4t18 1q35 0 57 -16t22 -48q0 -35 -28 -55t-82 -20q-30 0 -55.5 5.5t-45.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 280,
    d: "M259 455v-55h-210v55h80v294q-5 -6 -16 -14.5t-24.5 -16t-28 -13t-26.5 -5.5v55q16 0 32.5 8.5t30.5 18.5t23 19t9 10h56v-356h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 448,
    d: "M224 344q-41 0 -74.5 15t-57.5 40t-37 58.5t-13 69.5q0 37 13 70.5t37 59t57.5 40t74.5 14.5t74.5 -14.5t57.5 -40t37 -59t13 -70.5q0 -36 -13 -69.5t-37 -58.5t-57.5 -40t-74.5 -15zM114 526q0 -26 8.5 -48t23.5 -38t35 -25.5t43 -9.5t43 9.5t35 26t23.5 39t8.5 48.5 t-8.5 48t-23.5 38.5t-35 25.5t-43 9t-43 -9.5t-35 -26t-23.5 -39t-8.5 -48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 596,
    d: "M556 234l-253 -174v74l182 125l-182 128v74l253 -181v-46zM314 234l-253 -174v74l182 125l-182 128v74l253 -181v-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 858,
    d: "M709 0v100h-226v53l243 253h38v-252h59v-54h-59v-100h-55zM540 154h171v180zM269 375v-55h-210v55h80v294q-5 -6 -16 -14.5t-24.5 -16t-28 -13t-26.5 -5.5v55q16 0 32.5 8.5t30.5 18.5t23 19t9 10h56v-356h74zM147 33l280 337l268 345l43 -37l-277 -335l-272 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 892,
    d: "M537 0q0 39 7 68.5t22 51.5t38.5 38.5t55.5 29.5q22 9 45 17.5t42 19.5t31 26t12 37q0 30 -23.5 49.5t-69.5 19.5q-23 0 -42 -5t-34 -13t-26.5 -17.5t-19.5 -18.5l-34 40q5 7 17.5 18.5t33 22.5t49 19t64.5 8q72 0 108.5 -34.5t36.5 -89.5q0 -32 -13.5 -53t-33 -35.5 t-43 -23.5t-42.5 -15q-30 -10 -49 -23t-29.5 -27t-14 -28.5t-3.5 -27.5h229v-54h-314zM269 375v-55h-210v55h80v294q-5 -6 -16 -14.5t-24.5 -16t-28 -13t-26.5 -5.5v55q16 0 32.5 8.5t30.5 18.5t23 19t9 10h56v-356h74zM110 33l280 337l268 345l43 -37l-277 -335l-272 -348z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 866,
    d: "M198 314q-63 0 -105.5 23t-52.5 63l32 38q1 -11 10.5 -22.5t26 -22t39 -17t49.5 -6.5q47 0 79.5 17.5t32.5 47.5q0 33 -40 50.5t-109 17.5h-23v51h23q63 0 99 15t36 47q0 30 -30.5 47t-69.5 17q-41 0 -70 -15t-45 -39l-37 43q20 29 62 45.5t90 16.5q34 0 63 -8.5 t50.5 -23.5t33.5 -35.5t12 -44.5q0 -35 -23.5 -57t-68.5 -31q48 -7 75.5 -36t27.5 -68q0 -27 -13.5 -48.5t-37 -35.5t-53.5 -21.5t-63 -7.5zM716 0v100h-226v53l243 253h38v-252h59v-54h-59v-100h-55zM547 154h171v180zM178 33l280 337l268 345l43 -37l-277 -335l-272 -348z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 473,
    d: "M331 295q0 -54 -19 -94.5t-65 -69.5q-18 -12 -41.5 -25t-44.5 -30.5t-35.5 -42t-14.5 -58.5q0 -28 10.5 -49.5t27.5 -36t39 -22t46 -7.5q25 0 47.5 7.5t41.5 20.5t34 30.5t25 36.5l59 -39q-14 -31 -35.5 -55t-49.5 -40.5t-59.5 -25t-64.5 -8.5q-37 0 -73 11.5t-64 35.5 t-45 60t-17 85q0 38 10.5 65t27.5 47t40 35t48 29q18 10 36 21t31.5 26.5t22 37.5t8.5 55h74zM329 506v-116h-74v116h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 677,
    d: "M301 710h76l290 -710h-96l-84 208h-298l-83 -208h-96zM467 278l-128 328l-132 -328h260zM235 917h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 677,
    d: "M301 710h76l290 -710h-96l-84 208h-298l-83 -208h-96zM467 278l-128 328l-132 -328h260zM354 795l-58 20l58 101h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 677,
    d: "M301 710h76l290 -710h-96l-84 208h-298l-83 -208h-96zM467 278l-128 328l-132 -328h260zM206 826l101 90h64l101 -90l-48 -24l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 677,
    d: "M301 710h76l290 -710h-96l-84 208h-298l-83 -208h-96zM467 278l-128 328l-132 -328h260zM401 813q-23 0 -39.5 6.5t-31 14.5t-28.5 14.5t-30 6.5q-17 0 -26.5 -7t-14.5 -15.5t-6.5 -16.5t-1.5 -9h-52q0 6 4.5 23t15.5 35t30 31.5t49 13.5q21 0 37 -6.5t30.5 -15t29 -15 t32.5 -6.5q19 0 30 7t17 16t7.5 16.5t1.5 9.5h52q0 -6 -4.5 -22.5t-16.5 -34.5t-32.5 -32t-52.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 677,
    d: "M301 710h76l290 -710h-96l-84 208h-298l-83 -208h-96zM467 278l-128 328l-132 -328h260zM221 811v102h74v-102h-74zM383 811v102h74v-102h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 677,
    d: "M301 710h76l290 -710h-96l-84 208h-298l-83 -208h-96zM467 278l-128 328l-132 -328h260zM257 847q0 32 23 50.5t58 18.5q36 0 58.5 -18.5t22.5 -50.5t-22.5 -50.5t-58.5 -18.5q-35 0 -58 18.5t-23 50.5zM338 885q-17 0 -28.5 -10.5t-11.5 -27.5q0 -16 11.5 -27t28.5 -11 q16 0 28.5 10.5t12.5 27.5t-12 27.5t-29 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 961,
    d: "M428 710h488v-80h-375v-228h321v-80h-321v-242h384v-80h-473v208h-249l-130 -208h-98zM446 288v317l-203 -317h203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 679,
    d: "M292 -126q13 -7 37.5 -13t50.5 -6q27 0 42 8t15 27q0 20 -14 27.5t-37 7.5q-21 0 -44 -4.5t-36 -8.5l44 83q-69 4 -127 37t-99.5 84t-64.5 115t-23 129q0 64 22.5 127.5t66 114t106.5 81.5t143 31q95 0 163 -43t101 -112l-71 -46q-16 34 -38.5 57t-49 37t-54.5 20t-55 6 q-59 0 -104.5 -24.5t-76.5 -64t-46.5 -89t-15.5 -99.5q0 -56 18.5 -106.5t51.5 -89.5t78 -62t98 -23q28 0 57.5 7t56.5 22.5t50.5 39t38.5 56.5l75 -41q-16 -37 -43.5 -66t-62 -50t-73 -33t-77.5 -15l-27 -43q8 3 18 4t18 1q35 0 57 -16t22 -48q0 -35 -28 -55t-82 -20 q-30 0 -55.5 5.5t-45.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 605,
    d: "M567 80v-80h-482v710h473v-80h-383v-230h333v-75h-333v-245h392zM230 917h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 605,
    d: "M349 795l-58 20l58 101h88zM567 80v-80h-482v710h473v-80h-383v-230h333v-75h-333v-245h392z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 605,
    d: "M201 826l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM567 80v-80h-482v710h473v-80h-383v-230h333v-75h-333v-245h392z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 605,
    d: "M216 811v102h74v-102h-74zM378 811v102h74v-102h-74zM567 80v-80h-482v710h473v-80h-383v-230h333v-75h-333v-245h392z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 260,
    d: "M85 0v710h90v-710h-90zM26 917h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 260,
    d: "M85 0v710h90v-710h-90zM145 795l-58 20l58 101h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 260,
    d: "M85 0v710h90v-710h-90zM-3 826l101 90h64l101 -90l-48 -24l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 260,
    d: "M85 0v710h90v-710h-90zM12 811v102h74v-102h-74zM174 811v102h74v-102h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 722,
    d: "M91 0v323h-57v68h57v319h246q85 0 149.5 -28t107.5 -76t64.5 -112.5t21.5 -137.5q0 -81 -24 -146.5t-69 -112t-108.5 -72t-141.5 -25.5h-246zM589 356q0 60 -16.5 110.5t-49 86.5t-79.5 56.5t-107 20.5h-156v-239h161v-68h-161v-243h156q61 0 108.5 21t79 58t48 87.5 t16.5 109.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 770,
    d: "M175 542v-542h-90v710h70l440 -553v552h90v-709h-76zM449 813q-23 0 -39.5 6.5t-31 14.5t-28.5 14.5t-30 6.5q-17 0 -26.5 -7t-14.5 -15.5t-6.5 -16.5t-1.5 -9h-52q0 6 4.5 23t15.5 35t30 31.5t49 13.5q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q19 0 30 7t17 16t7.5 16.5 t1.5 9.5h52q0 -6 -4.5 -22.5t-16.5 -34.5t-32.5 -32t-52.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 748,
    d: "M373 -5q-75 0 -136.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q75 0 136 -31.5t105 -82.5t68 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-106 -79t-133.5 -29.5zM130 355q0 -54 17.5 -104.5t49.5 -89.5t77 -62t100 -23 q57 0 102 24.5t76.5 64t48 89.5t16.5 101q0 54 -17.5 104.5t-50 89t-77 61.5t-98.5 23q-57 0 -102 -24t-76.5 -63t-48.5 -89t-17 -102zM271 917h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 748,
    d: "M390 795l-58 20l58 101h88zM373 -5q-75 0 -136.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q75 0 136 -31.5t105 -82.5t68 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-106 -79t-133.5 -29.5zM130 355q0 -54 17.5 -104.5 t49.5 -89.5t77 -62t100 -23q57 0 102 24.5t76.5 64t48 89.5t16.5 101q0 54 -17.5 104.5t-50 89t-77 61.5t-98.5 23q-57 0 -102 -24t-76.5 -63t-48.5 -89t-17 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 748,
    d: "M242 826l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM373 -5q-75 0 -136.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q75 0 136 -31.5t105 -82.5t68 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-106 -79t-133.5 -29.5z M130 355q0 -54 17.5 -104.5t49.5 -89.5t77 -62t100 -23q57 0 102 24.5t76.5 64t48 89.5t16.5 101q0 54 -17.5 104.5t-50 89t-77 61.5t-98.5 23q-57 0 -102 -24t-76.5 -63t-48.5 -89t-17 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 748,
    d: "M373 -5q-75 0 -136.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q75 0 136 -31.5t105 -82.5t68 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-106 -79t-133.5 -29.5zM130 355q0 -54 17.5 -104.5t49.5 -89.5t77 -62t100 -23 q57 0 102 24.5t76.5 64t48 89.5t16.5 101q0 54 -17.5 104.5t-50 89t-77 61.5t-98.5 23q-57 0 -102 -24t-76.5 -63t-48.5 -89t-17 -102zM437 813q-23 0 -39.5 6.5t-31 14.5t-28.5 14.5t-30 6.5q-17 0 -26.5 -7t-14.5 -15.5t-6.5 -16.5t-1.5 -9h-52q0 6 4.5 23t15.5 35 t30 31.5t49 13.5q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q19 0 30 7t17 16t7.5 16.5t1.5 9.5h52q0 -6 -4.5 -22.5t-16.5 -34.5t-32.5 -32t-52.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 748,
    d: "M257 811v102h74v-102h-74zM419 811v102h74v-102h-74zM373 -5q-75 0 -136.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q75 0 136 -31.5t105 -82.5t68 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-106 -79t-133.5 -29.5z M130 355q0 -54 17.5 -104.5t49.5 -89.5t77 -62t100 -23q57 0 102 24.5t76.5 64t48 89.5t16.5 101q0 54 -17.5 104.5t-50 89t-77 61.5t-98.5 23q-57 0 -102 -24t-76.5 -63t-48.5 -89t-17 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 464,
    d: "M404 157l-56 -55l-116 116l-116 -116l-55 56l115 115l-113 114l56 55l113 -113l114 114l55 -56l-113 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 748,
    d: "M663 710l-62 -92q51 -53 79 -122.5t28 -141.5q0 -71 -25.5 -136t-70 -114.5t-106 -79t-133.5 -29.5q-46 0 -87 11.5t-76 33.5l-27 -40h-98l61 91q-51 51 -79 120t-28 144q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q45 0 85.5 -12t75.5 -34l28 41h99zM617 355 q0 54 -17 103t-48 87l-296 -436q53 -33 118 -33q57 0 102 24.5t76.5 64t48 89.5t16.5 101zM130 355q0 -54 16.5 -104t48.5 -88l295 437q-53 33 -116 33q-57 0 -102 -24t-76.5 -63t-48.5 -89t-17 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 755,
    d: "M377 76q62 0 103 24t65.5 62.5t34.5 88t10 100.5v359h90v-359q0 -72 -16.5 -136.5t-52.5 -113.5t-93.5 -77.5t-139.5 -28.5q-85 0 -143 30t-93.5 79.5t-51 114t-15.5 132.5v359h90v-359q0 -53 10.5 -102.5t35 -87.5t65 -61.5t101.5 -23.5zM274 917h87l59 -101l-57 -20z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 755,
    d: "M393 795l-58 20l58 101h88zM377 76q62 0 103 24t65.5 62.5t34.5 88t10 100.5v359h90v-359q0 -72 -16.5 -136.5t-52.5 -113.5t-93.5 -77.5t-139.5 -28.5q-85 0 -143 30t-93.5 79.5t-51 114t-15.5 132.5v359h90v-359q0 -53 10.5 -102.5t35 -87.5t65 -61.5t101.5 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 755,
    d: "M245 826l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM377 76q62 0 103 24t65.5 62.5t34.5 88t10 100.5v359h90v-359q0 -72 -16.5 -136.5t-52.5 -113.5t-93.5 -77.5t-139.5 -28.5q-85 0 -143 30t-93.5 79.5t-51 114t-15.5 132.5v359h90v-359q0 -53 10.5 -102.5t35 -87.5 t65 -61.5t101.5 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 755,
    d: "M260 811v102h74v-102h-74zM422 811v102h74v-102h-74zM377 76q62 0 103 24t65.5 62.5t34.5 88t10 100.5v359h90v-359q0 -72 -16.5 -136.5t-52.5 -113.5t-93.5 -77.5t-139.5 -28.5q-85 0 -143 30t-93.5 79.5t-51 114t-15.5 132.5v359h90v-359q0 -53 10.5 -102.5t35 -87.5 t65 -61.5t101.5 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 655,
    d: "M112 710l215 -370l217 370h98l-270 -451v-259h-90v261l-269 449h99zM342 795l-58 20l58 101h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 604,
    d: "M363 573q47 0 86.5 -19.5t68 -52t44.5 -73t16 -82.5q0 -44 -15 -85.5t-42.5 -73t-66 -50.5t-85.5 -19h-194v-118h-90v710h90v-137h188zM365 198q28 0 51 12.5t39 33t24.5 47t8.5 55.5q0 30 -10.5 56.5t-28 47t-41 32t-49.5 11.5h-184v-295h190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 553,
    d: "M241 75q41 1 75 9t59 25t38.5 43.5t13.5 62.5q0 65 -41.5 103.5t-109.5 38.5h-19v80h18q48 0 78 28t30 75q0 25 -9 43.5t-24 30.5t-34.5 18t-40.5 6q-31 0 -53.5 -11t-37.5 -30t-22 -43t-7 -51v-503h-84v517q0 43 15.5 79.5t43 62.5t65.5 40.5t83 14.5q40 0 74.5 -11.5 t60 -33t40 -51t14.5 -65.5q0 -27 -8 -51.5t-21.5 -45t-31.5 -34.5t-39 -20q36 -8 64 -25.5t47.5 -43t29.5 -57.5t10 -68q0 -51 -20.5 -90.5t-57.5 -66t-88 -41t-111 -16.5v81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 554,
    d: "M205 -10q-37 0 -69 12.5t-55.5 34.5t-37 51.5t-13.5 64.5q0 36 16 65.5t45.5 50.5t70 33t88.5 12q38 0 77 -7t69 -19v42q0 64 -36 100.5t-102 36.5q-79 0 -166 -61l-29 57q101 68 203 68q103 0 160.5 -55t57.5 -155v-213q0 -31 28 -32v-76q-14 -2 -23 -3t-19 -1 q-26 0 -41.5 15.5t-18.5 37.5l-2 37q-35 -47 -88.5 -71.5t-114.5 -24.5zM228 56q47 0 87.5 17.5t61.5 46.5q19 19 19 39v77q-64 25 -133 25q-66 0 -107.5 -28t-41.5 -73q0 -22 8.5 -41t24 -33t36.5 -22t45 -8zM162 730h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 554,
    d: "M205 -10q-37 0 -69 12.5t-55.5 34.5t-37 51.5t-13.5 64.5q0 36 16 65.5t45.5 50.5t70 33t88.5 12q38 0 77 -7t69 -19v42q0 64 -36 100.5t-102 36.5q-79 0 -166 -61l-29 57q101 68 203 68q103 0 160.5 -55t57.5 -155v-213q0 -31 28 -32v-76q-14 -2 -23 -3t-19 -1 q-26 0 -41.5 15.5t-18.5 37.5l-2 37q-35 -47 -88.5 -71.5t-114.5 -24.5zM228 56q47 0 87.5 17.5t61.5 46.5q19 19 19 39v77q-64 25 -133 25q-66 0 -107.5 -28t-41.5 -73q0 -22 8.5 -41t24 -33t36.5 -22t45 -8zM281 609l-58 20l58 101h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 554,
    d: "M205 -10q-37 0 -69 12.5t-55.5 34.5t-37 51.5t-13.5 64.5q0 36 16 65.5t45.5 50.5t70 33t88.5 12q38 0 77 -7t69 -19v42q0 64 -36 100.5t-102 36.5q-79 0 -166 -61l-29 57q101 68 203 68q103 0 160.5 -55t57.5 -155v-213q0 -31 28 -32v-76q-14 -2 -23 -3t-19 -1 q-26 0 -41.5 15.5t-18.5 37.5l-2 37q-35 -47 -88.5 -71.5t-114.5 -24.5zM228 56q47 0 87.5 17.5t61.5 46.5q19 19 19 39v77q-64 25 -133 25q-66 0 -107.5 -28t-41.5 -73q0 -22 8.5 -41t24 -33t36.5 -22t45 -8zM133 640l101 90h64l101 -90l-48 -24l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 554,
    d: "M205 -10q-37 0 -69 12.5t-55.5 34.5t-37 51.5t-13.5 64.5q0 36 16 65.5t45.5 50.5t70 33t88.5 12q38 0 77 -7t69 -19v42q0 64 -36 100.5t-102 36.5q-79 0 -166 -61l-29 57q101 68 203 68q103 0 160.5 -55t57.5 -155v-213q0 -31 28 -32v-76q-14 -2 -23 -3t-19 -1 q-26 0 -41.5 15.5t-18.5 37.5l-2 37q-35 -47 -88.5 -71.5t-114.5 -24.5zM228 56q47 0 87.5 17.5t61.5 46.5q19 19 19 39v77q-64 25 -133 25q-66 0 -107.5 -28t-41.5 -73q0 -22 8.5 -41t24 -33t36.5 -22t45 -8zM328 627q-23 0 -39.5 6.5t-31 14.5t-28.5 14.5t-30 6.5 q-17 0 -26.5 -7t-14.5 -15.5t-6.5 -16.5t-1.5 -9h-52q0 6 4.5 23t15.5 35t30 31.5t49 13.5q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q19 0 30 7t17 16t7.5 16.5t1.5 9.5h52q0 -6 -4.5 -22.5t-16.5 -34.5t-32.5 -32t-52.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 554,
    d: "M205 -10q-37 0 -69 12.5t-55.5 34.5t-37 51.5t-13.5 64.5q0 36 16 65.5t45.5 50.5t70 33t88.5 12q38 0 77 -7t69 -19v42q0 64 -36 100.5t-102 36.5q-79 0 -166 -61l-29 57q101 68 203 68q103 0 160.5 -55t57.5 -155v-213q0 -31 28 -32v-76q-14 -2 -23 -3t-19 -1 q-26 0 -41.5 15.5t-18.5 37.5l-2 37q-35 -47 -88.5 -71.5t-114.5 -24.5zM228 56q47 0 87.5 17.5t61.5 46.5q19 19 19 39v77q-64 25 -133 25q-66 0 -107.5 -28t-41.5 -73q0 -22 8.5 -41t24 -33t36.5 -22t45 -8zM148 624v102h74v-102h-74zM310 624v102h74v-102h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 554,
    d: "M205 -10q-37 0 -69 12.5t-55.5 34.5t-37 51.5t-13.5 64.5q0 36 16 65.5t45.5 50.5t70 33t88.5 12q38 0 77 -7t69 -19v42q0 64 -36 100.5t-102 36.5q-79 0 -166 -61l-29 57q101 68 203 68q103 0 160.5 -55t57.5 -155v-213q0 -31 28 -32v-76q-14 -2 -23 -3t-19 -1 q-26 0 -41.5 15.5t-18.5 37.5l-2 37q-35 -47 -88.5 -71.5t-114.5 -24.5zM228 56q47 0 87.5 17.5t61.5 46.5q19 19 19 39v77q-64 25 -133 25q-66 0 -107.5 -28t-41.5 -73q0 -22 8.5 -41t24 -33t36.5 -22t45 -8zM184 661q0 32 23 50.5t58 18.5q36 0 58.5 -18.5t22.5 -50.5 t-22.5 -50.5t-58.5 -18.5q-35 0 -58 18.5t-23 50.5zM265 699q-17 0 -28.5 -10.5t-11.5 -27.5q0 -16 11.5 -27t28.5 -11q16 0 28.5 10.5t12.5 27.5t-12 27.5t-29 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 933,
    d: "M204 -10q-37 0 -68.5 12.5t-55 34.5t-37 51.5t-13.5 64.5q0 36 16 65.5t45 50.5t69.5 33t88.5 12q34 0 67.5 -5.5t61.5 -14.5q2 16 5 34t9 32q-8 51 -42.5 79t-92.5 28q-78 0 -166 -61l-29 57q103 68 203 68q64 0 110 -25t71 -70q33 43 83 69t112 26q59 0 108 -21.5 t83.5 -58.5t54 -86t19.5 -104q0 -6 -0.5 -15.5t-1.5 -14.5h-443q3 -39 19 -71t41 -55t57.5 -36t68.5 -13q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10q-71 0 -127 31t-91 82q-17 -30 -43 -51.5t-56 -35t-62 -20t-61 -6.5z M227 56q48 0 88 17.5t62 46.5q17 17 19 35q-8 17 -12.5 42.5t-5.5 44.5q-27 9 -57 14t-59 5q-66 0 -107.5 -28t-41.5 -73q0 -22 9 -41t24 -33t36 -22t45 -8zM822 288q-3 39 -18 71.5t-39 56t-56 36.5t-69 13t-69 -13t-56 -36.5t-38.5 -56t-16.5 -71.5h362z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 554,
    d: "M224 -126q13 -7 37.5 -13t50.5 -6q27 0 42 8t15 27q0 20 -14 27.5t-37 7.5q-21 0 -44 -4.5t-36 -8.5l42 79q-54 4 -99 27t-77.5 60t-50 84t-17.5 100q0 55 19 104t54 85.5t83.5 58t108.5 21.5q78 0 134.5 -34.5t85.5 -92.5l-86 -27q-20 37 -56 57.5t-80 20.5 q-36 0 -68 -14.5t-55 -40.5t-36.5 -61t-13.5 -77q0 -41 14 -77t37.5 -62.5t55 -41.5t67.5 -15q23 0 45.5 6.5t41 17.5t32.5 25.5t20 31.5l86 -26q-22 -54 -75.5 -89t-124.5 -41l-25 -39q8 3 18 4t18 1q35 0 57 -16t22 -48q0 -35 -28 -55t-82 -20q-30 0 -55.5 5.5t-45.5 13.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    d: "M302 -10q-59 0 -108 21.5t-84 58.5t-54.5 86.5t-19.5 104.5t19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21 q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354zM195 730h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    d: "M314 609l-58 20l58 101h88zM302 -10q-59 0 -108 21.5t-84 58.5t-54.5 86.5t-19.5 104.5t19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13q24 0 47 6.5t43 17.5 t35.5 27t23.5 36l76 -21q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    d: "M166 640l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM302 -10q-59 0 -108 21.5t-84 58.5t-54.5 86.5t-19.5 104.5t19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13 q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    d: "M181 624v102h74v-102h-74zM343 624v102h74v-102h-74zM302 -10q-59 0 -108 21.5t-84 58.5t-54.5 86.5t-19.5 104.5t19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13 q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 230,
    d: "M71 0v522h88v-522h-88zM11 730h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 230,
    d: "M130 609l-58 20l58 101h88zM71 0v522h88v-522h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 230,
    d: "M-18 640l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM71 0v522h88v-522h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 230,
    d: "M-3 624v102h74v-102h-74zM159 624v102h74v-102h-74zM71 0v522h88v-522h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 606,
    d: "M505 676l-78 -46q39 -41 65.5 -85.5t43 -88.5t23.5 -86.5t7 -79.5q0 -70 -21.5 -125.5t-58.5 -94.5t-86 -59.5t-103 -20.5q-53 0 -100 19t-82 51.5t-55.5 77t-20.5 95.5q0 49 19 92.5t52 76.5t77.5 52t95.5 19q63 0 114.5 -28.5t78.5 -76.5q-10 60 -36 116t-80 112 l-107 -64l-27 37l99 59q-59 52 -148 102h124q51 -30 93 -68l84 51zM129 233q0 -35 13.5 -65.5t36.5 -53t54 -35.5t67 -13q37 0 69 14t56 37.5t37.5 55t13.5 66.5q0 34 -13.5 64t-37 51.5t-54.5 34t-67 12.5q-37 0 -69 -13t-55.5 -36t-37 -53.5t-13.5 -65.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 590,
    d: "M524 0h-88v292q0 84 -25.5 122t-77.5 38q-27 0 -54 -10.5t-51 -28.5t-42 -43t-27 -55v-315h-88v522h80v-112q31 55 89.5 88t127.5 33q45 0 75 -16.5t48 -46t25.5 -69.5t7.5 -87v-312zM365 627q-23 0 -39.5 6.5t-31 14.5t-28.5 14.5t-30 6.5q-17 0 -26.5 -7t-14.5 -15.5 t-6.5 -16.5t-1.5 -9h-52q0 6 4.5 23t15.5 35t30 31.5t49 13.5q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q19 0 30 7t17 16t7.5 16.5t1.5 9.5h52q0 -6 -4.5 -22.5t-16.5 -34.5t-32.5 -32t-52.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 599,
    d: "M299 -10q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59t54 -86t19.5 -104q0 -54 -19 -103t-54 -86t-83.5 -59t-107.5 -22zM126 259q0 -41 13.5 -76t37 -61t55 -41t67.5 -15t67.5 15t55.5 41.5t37.5 62t13.5 76.5 q0 40 -13.5 75.5t-37.5 62t-55.5 41.5t-67.5 15t-67.5 -15.5t-55 -42t-37 -62t-13.5 -76.5zM196 730h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 599,
    d: "M314 609l-58 20l58 101h88zM299 -10q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59t54 -86t19.5 -104q0 -54 -19 -103t-54 -86t-83.5 -59t-107.5 -22zM126 259q0 -41 13.5 -76t37 -61t55 -41t67.5 -15t67.5 15 t55.5 41.5t37.5 62t13.5 76.5q0 40 -13.5 75.5t-37.5 62t-55.5 41.5t-67.5 15t-67.5 -15.5t-55 -42t-37 -62t-13.5 -76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 599,
    d: "M166 640l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM299 -10q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59t54 -86t19.5 -104q0 -54 -19 -103t-54 -86t-83.5 -59t-107.5 -22zM126 259q0 -41 13.5 -76t37 -61t55 -41 t67.5 -15t67.5 15t55.5 41.5t37.5 62t13.5 76.5q0 40 -13.5 75.5t-37.5 62t-55.5 41.5t-67.5 15t-67.5 -15.5t-55 -42t-37 -62t-13.5 -76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 599,
    d: "M299 -10q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59t54 -86t19.5 -104q0 -54 -19 -103t-54 -86t-83.5 -59t-107.5 -22zM126 259q0 -41 13.5 -76t37 -61t55 -41t67.5 -15t67.5 15t55.5 41.5t37.5 62t13.5 76.5 q0 40 -13.5 75.5t-37.5 62t-55.5 41.5t-67.5 15t-67.5 -15.5t-55 -42t-37 -62t-13.5 -76.5zM362 627q-23 0 -39.5 6.5t-31 14.5t-28.5 14.5t-30 6.5q-17 0 -26.5 -7t-14.5 -15.5t-6.5 -16.5t-1.5 -9h-52q0 6 4.5 23t15.5 35t30 31.5t49 13.5q21 0 37 -6.5t30.5 -15t29 -15 t32.5 -6.5q19 0 30 7t17 16t7.5 16.5t1.5 9.5h52q0 -6 -4.5 -22.5t-16.5 -34.5t-32.5 -32t-52.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 599,
    d: "M181 624v102h74v-102h-74zM343 624v102h74v-102h-74zM299 -10q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59t54 -86t19.5 -104q0 -54 -19 -103t-54 -86t-83.5 -59t-107.5 -22zM126 259q0 -41 13.5 -76t37 -61t55 -41 t67.5 -15t67.5 15t55.5 41.5t37.5 62t13.5 76.5q0 40 -13.5 75.5t-37.5 62t-55.5 41.5t-67.5 15t-67.5 -15.5t-55 -42t-37 -62t-13.5 -76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 533,
    d: "M229 405v102h75v-102h-75zM229 66v102h75v-102h-75zM65 251v72h403v-72h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 599,
    d: "M80 -2l45 56q-42 38 -65.5 91.5t-23.5 114.5q0 55 19.5 104t54 86t83 59t106.5 22q39 0 74 -10t64 -28l24 31h56l-45 -57q43 -38 67 -92t24 -115q0 -54 -19 -103t-54 -86t-83.5 -59t-107.5 -22q-78 0 -140 39l-24 -31h-55zM299 66q36 0 67.5 15t55.5 41.5t37.5 62 t13.5 76.5q0 42 -14.5 77.5t-38.5 61.5l-212 -306q40 -28 91 -28zM126 259q0 -42 14 -77.5t38 -61.5l211 307q-20 13 -42.5 20.5t-47.5 7.5q-36 0 -67.5 -15.5t-55 -42t-37 -62t-13.5 -76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 601,
    d: "M232 -10q-82 0 -124 55t-42 164v313h88v-296q0 -160 111 -160q54 0 101.5 34.5t70.5 94.5v327h88v-414q0 -31 28 -32v-76q-15 -2 -23.5 -2.5t-16.5 -0.5q-26 0 -43.5 15.5t-18.5 38.5l-2 61q-35 -59 -92 -90.5t-125 -31.5zM191 730h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 601,
    d: "M309 609l-58 20l58 101h88zM232 -10q-82 0 -124 55t-42 164v313h88v-296q0 -160 111 -160q54 0 101.5 34.5t70.5 94.5v327h88v-414q0 -31 28 -32v-76q-15 -2 -23.5 -2.5t-16.5 -0.5q-26 0 -43.5 15.5t-18.5 38.5l-2 61q-35 -59 -92 -90.5t-125 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 601,
    d: "M161 640l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM232 -10q-82 0 -124 55t-42 164v313h88v-296q0 -160 111 -160q54 0 101.5 34.5t70.5 94.5v327h88v-414q0 -31 28 -32v-76q-15 -2 -23.5 -2.5t-16.5 -0.5q-26 0 -43.5 15.5t-18.5 38.5l-2 61q-35 -59 -92 -90.5 t-125 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 601,
    d: "M176 624v102h74v-102h-74zM338 624v102h74v-102h-74zM232 -10q-82 0 -124 55t-42 164v313h88v-296q0 -160 111 -160q54 0 101.5 34.5t70.5 94.5v327h88v-414q0 -31 28 -32v-76q-15 -2 -23.5 -2.5t-16.5 -0.5q-26 0 -43.5 15.5t-18.5 38.5l-2 61q-35 -59 -92 -90.5 t-125 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 545,
    d: "M95 -142q13 -2 26 -3t20 -1q12 0 21.5 5.5t19 21.5t21.5 44.5t30 74.5l-221 522h91l178 -443l162 443h84l-254 -659q-14 -35 -46.5 -61.5t-89.5 -26.5q-9 0 -18.5 1t-23.5 4v78zM296 609l-58 20l58 101h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 603,
    d: "M568 257q-1 -54 -21 -104t-55 -88t-81.5 -60.5t-100.5 -22.5q-52 0 -91 23.5t-58 54.5v-273h-90v923h90v-261q24 34 61.5 59.5t96.5 25.5q58 0 104 -24.5t78 -64.5t49.5 -89.5t17.5 -98.5zM478 258q0 39 -11.5 74.5t-33 62.5t-52 43t-67.5 16q-27 0 -50 -9t-42 -24 t-34.5 -35t-26.5 -42v-171q0 -21 14 -41t36 -35.5t47.5 -25t49.5 -9.5q37 0 68.5 16.5t54 43.5t35 62.5t12.5 73.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 545,
    d: "M95 -142q13 -2 26 -3t20 -1q12 0 21.5 5.5t19 21.5t21.5 44.5t30 74.5l-221 522h91l178 -443l162 443h84l-254 -659q-14 -35 -46.5 -61.5t-89.5 -26.5q-9 0 -18.5 1t-23.5 4v78zM163 624v102h74v-102h-74zM325 624v102h74v-102h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 677,
    d: "M301 710h76l290 -710h-96l-84 208h-298l-83 -208h-96zM467 278l-128 328l-132 -328h260zM193 840v58h292v-58h-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 554,
    d: "M205 -10q-37 0 -69 12.5t-55.5 34.5t-37 51.5t-13.5 64.5q0 36 16 65.5t45.5 50.5t70 33t88.5 12q38 0 77 -7t69 -19v42q0 64 -36 100.5t-102 36.5q-79 0 -166 -61l-29 57q101 68 203 68q103 0 160.5 -55t57.5 -155v-213q0 -31 28 -32v-76q-14 -2 -23 -3t-19 -1 q-26 0 -41.5 15.5t-18.5 37.5l-2 37q-35 -47 -88.5 -71.5t-114.5 -24.5zM228 56q47 0 87.5 17.5t61.5 46.5q19 19 19 39v77q-64 25 -133 25q-66 0 -107.5 -28t-41.5 -73q0 -22 8.5 -41t24 -33t36.5 -22t45 -8zM120 654v58h292v-58h-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 677,
    d: "M301 710h76l290 -710h-96l-84 208h-298l-83 -208h-96zM467 278l-128 328l-132 -328h260zM339 848q22 0 38.5 19.5t19.5 48.5h50q0 -24 -8.5 -44t-23 -35t-34 -23.5t-42.5 -8.5t-42.5 8.5t-34 23.5t-23 35t-8.5 44h51q0 -27 17 -47.5t40 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 554,
    d: "M205 -10q-37 0 -69 12.5t-55.5 34.5t-37 51.5t-13.5 64.5q0 36 16 65.5t45.5 50.5t70 33t88.5 12q38 0 77 -7t69 -19v42q0 64 -36 100.5t-102 36.5q-79 0 -166 -61l-29 57q101 68 203 68q103 0 160.5 -55t57.5 -155v-213q0 -31 28 -32v-76q-14 -2 -23 -3t-19 -1 q-26 0 -41.5 15.5t-18.5 37.5l-2 37q-35 -47 -88.5 -71.5t-114.5 -24.5zM228 56q47 0 87.5 17.5t61.5 46.5q19 19 19 39v77q-64 25 -133 25q-66 0 -107.5 -28t-41.5 -73q0 -22 8.5 -41t24 -33t36.5 -22t45 -8zM266 662q22 0 38.5 19.5t19.5 48.5h50q0 -24 -8.5 -44t-23 -35 t-34 -23.5t-42.5 -8.5t-42.5 8.5t-34 23.5t-23 35t-8.5 44h51q0 -27 17 -47.5t40 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 676,
    d: "M618 -181q-42 8 -63 28.5t-21 48.5q0 26 18.5 52t58.5 52h-40l-84 208h-298l-83 -208h-96l291 710h76l290 -710q-44 -27 -63 -48.5t-19 -43.5q0 -37 55 -43zM467 278l-128 328l-132 -328h260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 554,
    d: "M463 -181q-42 8 -63 28.5t-21 48.5q0 26 18 51t56 51q-19 5 -30 19t-13 32l-2 37q-35 -47 -88.5 -71.5t-114.5 -24.5q-37 0 -69 12.5t-55.5 34.5t-37 51.5t-13.5 64.5q0 36 16 65.5t45.5 50.5t70 33t88.5 12q38 0 77 -7t69 -19v42q0 64 -36 100.5t-102 36.5 q-79 0 -166 -61l-29 57q101 68 203 68q103 0 160.5 -55t57.5 -155v-213q0 -31 28 -32v-76q-44 -27 -63 -48.5t-19 -43.5q0 -37 55 -43zM228 56q47 0 87.5 17.5t61.5 46.5q19 19 19 39v77q-64 25 -133 25q-66 0 -107.5 -28t-41.5 -73q0 -22 8.5 -41t24 -33t36.5 -22t45 -8z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 682,
    d: "M391 795l-58 20l58 101h88zM39 360q0 64 22.5 127.5t66 114t106.5 81.5t143 31q95 0 163 -43t101 -112l-71 -46q-16 34 -38.5 57t-49 37t-54.5 20t-55 6q-59 0 -104.5 -24.5t-76.5 -64t-46.5 -89t-15.5 -99.5q0 -56 18.5 -106.5t51.5 -89.5t78 -62t98 -23q28 0 57.5 7 t56.5 22.5t50.5 39t38.5 56.5l75 -41q-17 -40 -47.5 -70.5t-69 -51.5t-81.5 -32t-84 -11q-73 0 -134 32t-105.5 83.5t-69 117t-24.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 554,
    d: "M315 609l-58 20l58 101h88zM36 262q0 55 19 104t54 85.5t83.5 58t108.5 21.5q78 0 134.5 -34.5t85.5 -92.5l-86 -27q-20 37 -56 57.5t-80 20.5q-36 0 -68 -14.5t-55 -40.5t-36.5 -61t-13.5 -77q0 -41 14 -77t37.5 -62.5t55 -41.5t67.5 -15q23 0 45.5 6.5t41 17.5 t32.5 25.5t20 31.5l86 -26q-12 -29 -33.5 -53t-50.5 -41t-64.5 -27t-74.5 -10q-59 0 -108 22t-84 59t-54.5 86.5t-19.5 104.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 682,
    d: "M243 826l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM39 360q0 64 22.5 127.5t66 114t106.5 81.5t143 31q95 0 163 -43t101 -112l-71 -46q-16 34 -38.5 57t-49 37t-54.5 20t-55 6q-59 0 -104.5 -24.5t-76.5 -64t-46.5 -89t-15.5 -99.5q0 -56 18.5 -106.5t51.5 -89.5 t78 -62t98 -23q28 0 57.5 7t56.5 22.5t50.5 39t38.5 56.5l75 -41q-17 -40 -47.5 -70.5t-69 -51.5t-81.5 -32t-84 -11q-73 0 -134 32t-105.5 83.5t-69 117t-24.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 554,
    d: "M167 640l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM36 262q0 55 19 104t54 85.5t83.5 58t108.5 21.5q78 0 134.5 -34.5t85.5 -92.5l-86 -27q-20 37 -56 57.5t-80 20.5q-36 0 -68 -14.5t-55 -40.5t-36.5 -61t-13.5 -77q0 -41 14 -77t37.5 -62.5t55 -41.5t67.5 -15 q23 0 45.5 6.5t41 17.5t32.5 25.5t20 31.5l86 -26q-12 -29 -33.5 -53t-50.5 -41t-64.5 -27t-74.5 -10q-59 0 -108 22t-84 59t-54.5 86.5t-19.5 104.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 682,
    d: "M39 360q0 64 22.5 127.5t66 114t106.5 81.5t143 31q95 0 163 -43t101 -112l-71 -46q-16 34 -38.5 57t-49 37t-54.5 20t-55 6q-59 0 -104.5 -24.5t-76.5 -64t-46.5 -89t-15.5 -99.5q0 -56 18.5 -106.5t51.5 -89.5t78 -62t98 -23q28 0 57.5 7t56.5 22.5t50.5 39t38.5 56.5 l75 -41q-17 -40 -47.5 -70.5t-69 -51.5t-81.5 -32t-84 -11q-73 0 -134 32t-105.5 83.5t-69 117t-24.5 133.5zM336 810v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 554,
    d: "M36 262q0 55 19 104t54 85.5t83.5 58t108.5 21.5q78 0 134.5 -34.5t85.5 -92.5l-86 -27q-20 37 -56 57.5t-80 20.5q-36 0 -68 -14.5t-55 -40.5t-36.5 -61t-13.5 -77q0 -41 14 -77t37.5 -62.5t55 -41.5t67.5 -15q23 0 45.5 6.5t41 17.5t32.5 25.5t20 31.5l86 -26 q-12 -29 -33.5 -53t-50.5 -41t-64.5 -27t-74.5 -10q-59 0 -108 22t-84 59t-54.5 86.5t-19.5 104.5zM260 624v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 682,
    d: "M291 916l85 -63l85 63l48 -24l-101 -90h-64l-101 90zM39 360q0 64 22.5 127.5t66 114t106.5 81.5t143 31q95 0 163 -43t101 -112l-71 -46q-16 34 -38.5 57t-49 37t-54.5 20t-55 6q-59 0 -104.5 -24.5t-76.5 -64t-46.5 -89t-15.5 -99.5q0 -56 18.5 -106.5t51.5 -89.5 t78 -62t98 -23q28 0 57.5 7t56.5 22.5t50.5 39t38.5 56.5l75 -41q-17 -40 -47.5 -70.5t-69 -51.5t-81.5 -32t-84 -11q-73 0 -134 32t-105.5 83.5t-69 117t-24.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 554,
    d: "M215 730l85 -63l85 63l48 -24l-101 -90h-64l-101 90zM36 262q0 55 19 104t54 85.5t83.5 58t108.5 21.5q78 0 134.5 -34.5t85.5 -92.5l-86 -27q-20 37 -56 57.5t-80 20.5q-36 0 -68 -14.5t-55 -40.5t-36.5 -61t-13.5 -77q0 -41 14 -77t37.5 -62.5t55 -41.5t67.5 -15 q23 0 45.5 6.5t41 17.5t32.5 25.5t20 31.5l86 -26q-12 -29 -33.5 -53t-50.5 -41t-64.5 -27t-74.5 -10q-59 0 -108 22t-84 59t-54.5 86.5t-19.5 104.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 716,
    d: "M255 916l85 -63l85 63l48 -24l-101 -90h-64l-101 90zM85 0v710h246q85 0 149.5 -28t107.5 -76t64.5 -112.5t21.5 -137.5q0 -81 -24 -146.5t-69 -112t-108.5 -72t-141.5 -25.5h-246zM583 356q0 60 -16.5 110.5t-49 86.5t-79.5 56.5t-107 20.5h-156v-550h156q61 0 108.5 21 t79 58t48 87.5t16.5 109.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 629,
    d: "M644 609l-58 20l58 101h88zM286 -10q-54 0 -100 22t-79 59t-51.5 86t-18.5 103q0 55 17.5 104.5t49 86.5t75 58.5t95.5 21.5q63 0 112.5 -33t78.5 -80v312h88v-622q0 -31 28 -32v-76q-14 -2 -22.5 -3t-16.5 -1q-26 0 -45.5 17.5t-19.5 40.5v44q-31 -51 -82.5 -79.5 t-108.5 -28.5zM307 66q24 0 49.5 9t48 25t39 37.5t21.5 45.5v150q-9 25 -27 47.5t-40.5 39t-48 26t-50.5 9.5q-39 0 -70.5 -16.5t-54 -44t-34.5 -63t-12 -72.5q0 -39 14 -74.5t38 -61.5t56.5 -41.5t70.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 722,
    d: "M91 0v323h-57v68h57v319h246q85 0 149.5 -28t107.5 -76t64.5 -112.5t21.5 -137.5q0 -81 -24 -146.5t-69 -112t-108.5 -72t-141.5 -25.5h-246zM589 356q0 60 -16.5 110.5t-49 86.5t-79.5 56.5t-107 20.5h-156v-239h161v-68h-161v-243h156q61 0 108.5 21t79 58t48 87.5 t16.5 109.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 629,
    d: "M286 -10q-54 0 -100 22t-79 59t-51.5 86t-18.5 103q0 55 17.5 104.5t49 86.5t75 58.5t95.5 21.5q63 0 112.5 -33t78.5 -80v193h-110v56h110v63h88v-63h68v-56h-68v-503q0 -31 28 -32v-76q-14 -2 -22.5 -3t-16.5 -1q-26 0 -45.5 17.5t-19.5 40.5v44q-31 -51 -82.5 -79.5 t-108.5 -28.5zM307 66q24 0 49.5 9t48 25t39 37.5t21.5 45.5v150q-9 25 -27 47.5t-40.5 39t-48 26t-50.5 9.5q-39 0 -70.5 -16.5t-54 -44t-34.5 -63t-12 -72.5q0 -39 14 -74.5t38 -61.5t56.5 -41.5t70.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 605,
    d: "M567 80v-80h-482v710h473v-80h-383v-230h333v-75h-333v-245h392zM189 840v58h292v-58h-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    d: "M302 -10q-59 0 -108 21.5t-84 58.5t-54.5 86.5t-19.5 104.5t19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21 q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354zM153 654v58h292v-58h-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 605,
    d: "M567 80v-80h-482v710h473v-80h-383v-230h333v-75h-333v-245h392zM334 848q22 0 38.5 19.5t19.5 48.5h50q0 -24 -8.5 -44t-23 -35t-34 -23.5t-42.5 -8.5t-42.5 8.5t-34 23.5t-23 35t-8.5 44h51q0 -27 17 -47.5t40 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    d: "M302 -10q-59 0 -108 21.5t-84 58.5t-54.5 86.5t-19.5 104.5t19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21 q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354zM299 662q22 0 38.5 19.5t19.5 48.5h50q0 -24 -8.5 -44t-23 -35t-34 -23.5t-42.5 -8.5t-42.5 8.5t-34 23.5t-23 35 t-8.5 44h51q0 -27 17 -47.5t40 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 605,
    d: "M567 80v-80h-482v710h473v-80h-383v-230h333v-75h-333v-245h392zM294 810v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    d: "M302 -10q-59 0 -108 21.5t-84 58.5t-54.5 86.5t-19.5 104.5t19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21 q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354zM259 624v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 605,
    d: "M567 80v-80q-44 -27 -63 -48.5t-19 -43.5q0 -37 55 -43l-22 -46q-42 8 -63 28.5t-21 48.5q0 26 18.5 52t58.5 52h-426v710h473v-80h-383v-230h333v-75h-333v-245h392z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    d: "M301 -186q-42 8 -63 28.5t-21 48.5q0 50 70 100q-56 3 -102 25t-79 59t-51.5 84.5t-18.5 101.5q0 55 19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13q24 0 47 6.5 t43 17.5t35.5 27t23.5 36l76 -21q-22 -50 -70.5 -84.5t-112.5 -43.5q-42 -26 -60.5 -47.5t-18.5 -43.5q0 -37 55 -43zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 605,
    d: "M249 916l85 -63l85 63l48 -24l-101 -90h-64l-101 90zM567 80v-80h-482v710h473v-80h-383v-230h333v-75h-333v-245h392z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    d: "M214 730l85 -63l85 63l48 -24l-101 -90h-64l-101 90zM302 -10q-59 0 -108 21.5t-84 58.5t-54.5 86.5t-19.5 104.5t19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13 q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 714,
    d: "M236 826l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM586 96q-94 -101 -216 -101q-71 0 -131.5 31t-104.5 81.5t-69.5 115.5t-25.5 134q0 72 25 136.5t69 114t105 78.5t132 29q103 0 169.5 -43t101.5 -112l-69 -48q-32 62 -85 92t-119 30q-54 0 -98 -23.5t-75 -62 t-48 -89t-17 -104.5q0 -57 19 -107.5t52 -89t78 -60.5t98 -22q116 0 209 112v98h-153v68h229v-354h-76v96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 623,
    d: "M197 640l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM278 -6q-53 0 -97.5 22t-76.5 59t-49.5 85t-17.5 100q0 55 17.5 104.5t49.5 86.5t76.5 58.5t98.5 21.5q66 0 114 -32t81 -81v104h78v-516q0 -56 -21 -98.5t-57 -71.5t-84.5 -44t-103.5 -15q-89 0 -144.5 30.5 t-92.5 84.5l51 45q31 -46 80 -69t106 -23q36 0 68.5 10t56.5 30t38.5 50t14.5 71v92q-15 -24 -35.5 -43.5t-44.5 -33t-51 -20.5t-55 -7zM305 66q28 0 54 10t48 26.5t37 37.5t20 43v150q-11 27 -28.5 49t-39.5 38.5t-47.5 25.5t-51.5 9q-40 0 -71.5 -17t-53.5 -45t-34 -63.5 t-12 -71.5q0 -39 14 -74t38 -61t56.5 -41.5t70.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 714,
    d: "M586 96q-94 -101 -216 -101q-71 0 -131.5 31t-104.5 81.5t-69.5 115.5t-25.5 134q0 72 25 136.5t69 114t105 78.5t132 29q103 0 169.5 -43t101.5 -112l-69 -48q-32 62 -85 92t-119 30q-54 0 -98 -23.5t-75 -62t-48 -89t-17 -104.5q0 -57 19 -107.5t52 -89t78 -60.5 t98 -22q116 0 209 112v98h-153v68h229v-354h-76v96zM369 848q22 0 38.5 19.5t19.5 48.5h50q0 -24 -8.5 -44t-23 -35t-34 -23.5t-42.5 -8.5t-42.5 8.5t-34 23.5t-23 35t-8.5 44h51q0 -27 17 -47.5t40 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 623,
    d: "M278 -6q-53 0 -97.5 22t-76.5 59t-49.5 85t-17.5 100q0 55 17.5 104.5t49.5 86.5t76.5 58.5t98.5 21.5q66 0 114 -32t81 -81v104h78v-516q0 -56 -21 -98.5t-57 -71.5t-84.5 -44t-103.5 -15q-89 0 -144.5 30.5t-92.5 84.5l51 45q31 -46 80 -69t106 -23q36 0 68.5 10 t56.5 30t38.5 50t14.5 71v92q-15 -24 -35.5 -43.5t-44.5 -33t-51 -20.5t-55 -7zM305 66q28 0 54 10t48 26.5t37 37.5t20 43v150q-11 27 -28.5 49t-39.5 38.5t-47.5 25.5t-51.5 9q-40 0 -71.5 -17t-53.5 -45t-34 -63.5t-12 -71.5q0 -39 14 -74t38 -61t56.5 -41.5t70.5 -15.5z M330 662q22 0 38.5 19.5t19.5 48.5h50q0 -24 -8.5 -44t-23 -35t-34 -23.5t-42.5 -8.5t-42.5 8.5t-34 23.5t-23 35t-8.5 44h51q0 -27 17 -47.5t40 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 714,
    d: "M586 96q-94 -101 -216 -101q-71 0 -131.5 31t-104.5 81.5t-69.5 115.5t-25.5 134q0 72 25 136.5t69 114t105 78.5t132 29q103 0 169.5 -43t101.5 -112l-69 -48q-32 62 -85 92t-119 30q-54 0 -98 -23.5t-75 -62t-48 -89t-17 -104.5q0 -57 19 -107.5t52 -89t78 -60.5 t98 -22q116 0 209 112v98h-153v68h229v-354h-76v96zM329 810v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 623,
    d: "M278 -6q-53 0 -97.5 22t-76.5 59t-49.5 85t-17.5 100q0 55 17.5 104.5t49.5 86.5t76.5 58.5t98.5 21.5q66 0 114 -32t81 -81v104h78v-516q0 -56 -21 -98.5t-57 -71.5t-84.5 -44t-103.5 -15q-89 0 -144.5 30.5t-92.5 84.5l51 45q31 -46 80 -69t106 -23q36 0 68.5 10 t56.5 30t38.5 50t14.5 71v92q-15 -24 -35.5 -43.5t-44.5 -33t-51 -20.5t-55 -7zM305 66q28 0 54 10t48 26.5t37 37.5t20 43v150q-11 27 -28.5 49t-39.5 38.5t-47.5 25.5t-51.5 9q-40 0 -71.5 -17t-53.5 -45t-34 -63.5t-12 -71.5q0 -39 14 -74t38 -61t56.5 -41.5t70.5 -15.5z M290 624v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 714,
    d: "M337 -213l20 81h-25v84h78v-84l-30 -81h-43zM586 96q-94 -101 -216 -101q-71 0 -131.5 31t-104.5 81.5t-69.5 115.5t-25.5 134q0 72 25 136.5t69 114t105 78.5t132 29q103 0 169.5 -43t101.5 -112l-69 -48q-32 62 -85 92t-119 30q-54 0 -98 -23.5t-75 -62t-48 -89 t-17 -104.5q0 -57 19 -107.5t52 -89t78 -60.5t98 -22q116 0 209 112v98h-153v68h229v-354h-76v96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 623,
    d: "M278 -6q-53 0 -97.5 22t-76.5 59t-49.5 85t-17.5 100q0 55 17.5 104.5t49.5 86.5t76.5 58.5t98.5 21.5q66 0 114 -32t81 -81v104h78v-516q0 -56 -21 -98.5t-57 -71.5t-84.5 -44t-103.5 -15q-89 0 -144.5 30.5t-92.5 84.5l51 45q31 -46 80 -69t106 -23q36 0 68.5 10 t56.5 30t38.5 50t14.5 71v92q-15 -24 -35.5 -43.5t-44.5 -33t-51 -20.5t-55 -7zM305 66q28 0 54 10t48 26.5t37 37.5t20 43v150q-11 27 -28.5 49t-39.5 38.5t-47.5 25.5t-51.5 9q-40 0 -71.5 -17t-53.5 -45t-34 -63.5t-12 -71.5q0 -39 14 -74t38 -61t56.5 -41.5t70.5 -15.5z M347 745l-20 -81h25v-84h-78v84l30 81h43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 741,
    d: "M240 826l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM656 710v-710h-90v323h-391v-323h-90v710h90v-307h391v307h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 590,
    d: "M227 640l94 89h59l94 -89l-45 -24l-78 62l-79 -62zM524 0h-88v292q0 81 -28 120.5t-82 39.5q-26 0 -52 -10.5t-48.5 -28.5t-40 -43t-26.5 -55v-315h-88v730h88v-320q31 57 84 89t116 32q46 0 78 -17t51 -46t27.5 -69.5t8.5 -86.5v-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 751,
    d: "M661 710v-115h50v-47h-50v-548h-90v323h-391v-323h-90v548h-50v47h50v115h90v-115h391v115h90zM571 403v145h-391v-145h391z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 590,
    d: "M524 0h-88v292q0 81 -28 120.5t-82 39.5q-26 0 -52 -10.5t-48.5 -28.5t-40 -43t-26.5 -55v-315h-88v611h-56v56h56v63h88v-63h122v-56h-122v-201q31 57 84 89t116 32q46 0 78 -17t51 -46t27.5 -69.5t8.5 -86.5v-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 260,
    d: "M85 0v710h90v-710h-90zM192 813q-23 0 -39.5 6.5t-31 14.5t-28.5 14.5t-30 6.5q-17 0 -26.5 -7t-14.5 -15.5t-6.5 -16.5t-1.5 -9h-52q0 6 4.5 23t15.5 35t30 31.5t49 13.5q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q19 0 30 7t17 16t7.5 16.5t1.5 9.5h52q0 -6 -4.5 -22.5 t-16.5 -34.5t-32.5 -32t-52.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 230,
    d: "M71 0v522h88v-522h-88zM177 627q-23 0 -39.5 6.5t-31 14.5t-28.5 14.5t-30 6.5q-17 0 -26.5 -7t-14.5 -15.5t-6.5 -16.5t-1.5 -9h-52q0 6 4.5 23t15.5 35t30 31.5t49 13.5q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q19 0 30 7t17 16t7.5 16.5t1.5 9.5h52q0 -6 -4.5 -22.5 t-16.5 -34.5t-32.5 -32t-52.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 260,
    d: "M85 0v710h90v-710h-90zM-15 840v58h292v-58h-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 230,
    d: "M71 0v522h88v-522h-88zM-30 654v58h292v-58h-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 260,
    d: "M85 0v710h90v-710h-90zM130 848q22 0 38.5 19.5t19.5 48.5h50q0 -24 -8.5 -44t-23 -35t-34 -23.5t-42.5 -8.5t-42.5 8.5t-34 23.5t-23 35t-8.5 44h51q0 -27 17 -47.5t40 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 230,
    d: "M71 0v522h88v-522h-88zM115 662q22 0 38.5 19.5t19.5 48.5h50q0 -24 -8.5 -44t-23 -35t-34 -23.5t-42.5 -8.5t-42.5 8.5t-34 23.5t-23 35t-8.5 44h51q0 -27 17 -47.5t40 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 260,
    d: "M126 -181q-42 8 -63 28.5t-21 48.5q0 26 18.5 52t58.5 52h-34v710h90v-710q-44 -27 -63 -48.5t-19 -43.5q0 -37 55 -43l-22 -46v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 230,
    d: "M110 -181q-42 8 -63 28.5t-21 48.5q0 26 18.5 52t58.5 52h-32v522h88v-522q-44 -27 -63 -48.5t-19 -43.5q0 -37 55 -43zM71 620v110h88v-110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 260,
    d: "M85 0v710h90v-710h-90zM90 810v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 230,
    d: "M71 0v522h88v-522h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 745,
    d: "M85 0v710h90v-710h-90zM295 106q20 -14 54 -25t77 -11q51 0 81 18t45.5 53.5t20.5 87.5t5 120v361h90v-361q0 -81 -7.5 -147.5t-33 -113.5t-73 -73t-128.5 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 467,
    d: "M71 0v522h88v-522h-88zM71 620v110h88v-110h-88zM234 -186q-35 0 -65.5 10t-54.5 32l41 59q14 -13 32.5 -18t36.5 -5q16 0 31 6.5t27 17.5t19 27t7 34v545h88v-539q0 -37 -13.5 -68t-36 -53.5t-51.5 -35t-61 -12.5zM308 620v110h88v-110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 485,
    d: "M231 826l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM35 106q20 -14 54 -25t77 -11q51 0 81 18t45.5 53.5t20.5 87.5t5 120v361h90v-361q0 -81 -7.5 -147.5t-33 -113.5t-73 -73t-128.5 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 230,
    d: "M-3 -186q-35 0 -65.5 10t-54.5 32l41 59q14 -13 32.5 -18t36.5 -5q16 0 31 6.5t27 17.5t19 27t7 34v545h88v-539q0 -37 -13.5 -68t-36 -53.5t-51.5 -35t-61 -12.5zM-18 640l101 90h64l101 -90l-48 -24l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 652,
    d: "M300 -213l20 81h-25v84h78v-84l-30 -81h-43zM85 0v709h90v-392l366 393h97l-285 -313l301 -397h-98l-258 345l-123 -128v-217h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 539,
    d: "M243 -213l20 81h-25v84h78v-84l-30 -81h-43zM439 0l-180 255l-100 -94v-161h-88v730h88v-480l268 271h97l-208 -216l218 -305h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 539,
    d: "M439 0l-180 255l-100 -94v-161h-88v522h88v-272l268 271h97l-208 -216l218 -305h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 584,
    d: "M363 795l-58 20l58 101h88zM85 0v710h90v-630h396v-80h-486z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 286,
    d: "M126 770l-58 20l58 101h88zM73 730h88v-595q0 -29 15.5 -45.5t43.5 -16.5q11 0 26 3.5t28 8.5l14 -71q-22 -9 -52 -15t-53 -6q-51 0 -80.5 29t-29.5 81v627z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 584,
    d: "M297 -213l20 81h-25v84h78v-84l-30 -81h-43zM85 0v710h90v-630h396v-80h-486z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 286,
    d: "M142 -213l20 81h-25v84h78v-84l-30 -81h-43zM73 730h88v-595q0 -29 15.5 -45.5t43.5 -16.5q11 0 26 3.5t28 8.5l14 -71q-22 -9 -52 -15t-53 -6q-51 0 -80.5 29t-29.5 81v627z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 584,
    d: "M391 609l-58 20l58 101h88zM85 0v710h90v-630h396v-80h-486z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 286,
    d: "M263 609l-58 20l58 101h88zM73 730h88v-595q0 -29 15.5 -45.5t43.5 -16.5q11 0 26 3.5t28 8.5l14 -71q-22 -9 -52 -15t-53 -6q-51 0 -80.5 29t-29.5 81v627z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 584,
    d: "M85 0v710h90v-630h396v-80h-486zM366 343v124h74v-124h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 339,
    d: "M73 730h88v-595q0 -29 15.5 -45.5t43.5 -16.5q11 0 26 3.5t28 8.5l14 -71q-22 -9 -52 -15t-53 -6q-51 0 -80.5 29t-29.5 81v627zM249 269v124h74v-124h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    d: "M92 0v276l-56 -43l-26 50l82 62v365h90v-296l142 109l25 -49l-167 -129v-265h396v-80h-486z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 308,
    d: "M94 326l-60 -43l-26 49l86 62v336h88v-272l88 64l27 -49l-115 -83v-255q0 -29 15.5 -45.5t43.5 -16.5q11 0 26 3.5t28 8.5l14 -71q-22 -9 -52 -15t-53 -6q-51 0 -80.5 29t-29.5 81v223z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 770,
    d: "M402 795l-58 20l58 101h88zM175 542v-542h-90v710h70l440 -553v552h90v-709h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 590,
    d: "M318 609l-58 20l58 101h88zM524 0h-88v292q0 84 -25.5 122t-77.5 38q-27 0 -54 -10.5t-51 -28.5t-42 -43t-27 -55v-315h-88v522h80v-112q31 55 89.5 88t127.5 33q45 0 75 -16.5t48 -46t25.5 -69.5t7.5 -87v-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 770,
    d: "M350 -213l20 81h-25v84h78v-84l-30 -81h-43zM175 542v-542h-90v710h70l440 -553v552h90v-709h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 590,
    d: "M256 -213l20 81h-25v84h78v-84l-30 -81h-43zM524 0h-88v292q0 84 -25.5 122t-77.5 38q-27 0 -54 -10.5t-51 -28.5t-42 -43t-27 -55v-315h-88v522h80v-112q31 55 89.5 88t127.5 33q45 0 75 -16.5t48 -46t25.5 -69.5t7.5 -87v-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 770,
    d: "M302 916l85 -63l85 63l48 -24l-101 -90h-64l-101 90zM175 542v-542h-90v710h70l440 -553v552h90v-709h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 590,
    d: "M218 730l85 -63l85 63l48 -24l-101 -90h-64l-101 90zM524 0h-88v292q0 84 -25.5 122t-77.5 38q-27 0 -54 -10.5t-51 -28.5t-42 -43t-27 -55v-315h-88v522h80v-112q31 55 89.5 88t127.5 33q45 0 75 -16.5t48 -46t25.5 -69.5t7.5 -87v-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 590,
    d: "M48 609l-57 20l37 63l-3 38h112zM524 0h-88v292q0 84 -25.5 122t-77.5 38q-27 0 -54 -10.5t-51 -28.5t-42 -43t-27 -55v-315h-88v522h80v-112q31 55 89.5 88t127.5 33q45 0 75 -16.5t48 -46t25.5 -69.5t7.5 -87v-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 762,
    d: "M175 540v-540h-90v710h69l433 -549v548h90v-729q0 -37 -13.5 -67.5t-36.5 -52.5t-52.5 -34t-60.5 -12q-34 0 -64.5 10t-54.5 32l41 59q14 -13 32 -18t36 -5q16 0 31.5 6.5t27.5 17.5t19 27t7 34v38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 590,
    d: "M362 -186q-35 0 -65.5 10t-54.5 32l41 59q14 -13 32.5 -18t36.5 -5q16 0 31 6.5t27 17.5t19 27t7 34v315q0 84 -25.5 122t-77.5 38q-27 0 -54 -10.5t-51 -28.5t-42 -43t-27 -55v-315h-88v522h80v-112q31 55 89.5 88t127.5 33q45 0 75 -16.5t48 -46t25.5 -69.5t7.5 -87 v-329q0 -37 -13.5 -68t-36 -53.5t-51.5 -35t-61 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 748,
    d: "M230 840v58h292v-58h-292zM373 -5q-75 0 -136.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q75 0 136 -31.5t105 -82.5t68 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-106 -79t-133.5 -29.5zM130 355q0 -54 17.5 -104.5 t49.5 -89.5t77 -62t100 -23q57 0 102 24.5t76.5 64t48 89.5t16.5 101q0 54 -17.5 104.5t-50 89t-77 61.5t-98.5 23q-57 0 -102 -24t-76.5 -63t-48.5 -89t-17 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 599,
    d: "M154 654v58h292v-58h-292zM299 -10q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59t54 -86t19.5 -104q0 -54 -19 -103t-54 -86t-83.5 -59t-107.5 -22zM126 259q0 -41 13.5 -76t37 -61t55 -41t67.5 -15t67.5 15t55.5 41.5 t37.5 62t13.5 76.5q0 40 -13.5 75.5t-37.5 62t-55.5 41.5t-67.5 15t-67.5 -15.5t-55 -42t-37 -62t-13.5 -76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 748,
    d: "M373 -5q-75 0 -136.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q75 0 136 -31.5t105 -82.5t68 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-106 -79t-133.5 -29.5zM130 355q0 -54 17.5 -104.5t49.5 -89.5t77 -62t100 -23 q57 0 102 24.5t76.5 64t48 89.5t16.5 101q0 54 -17.5 104.5t-50 89t-77 61.5t-98.5 23q-57 0 -102 -24t-76.5 -63t-48.5 -89t-17 -102zM375 848q22 0 38.5 19.5t19.5 48.5h50q0 -24 -8.5 -44t-23 -35t-34 -23.5t-42.5 -8.5t-42.5 8.5t-34 23.5t-23 35t-8.5 44h51 q0 -27 17 -47.5t40 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 599,
    d: "M299 -10q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59t54 -86t19.5 -104q0 -54 -19 -103t-54 -86t-83.5 -59t-107.5 -22zM126 259q0 -41 13.5 -76t37 -61t55 -41t67.5 -15t67.5 15t55.5 41.5t37.5 62t13.5 76.5 q0 40 -13.5 75.5t-37.5 62t-55.5 41.5t-67.5 15t-67.5 -15.5t-55 -42t-37 -62t-13.5 -76.5zM299 662q22 0 38.5 19.5t19.5 48.5h50q0 -24 -8.5 -44t-23 -35t-34 -23.5t-42.5 -8.5t-42.5 8.5t-34 23.5t-23 35t-8.5 44h51q0 -27 17 -47.5t40 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 748,
    d: "M312 796l-46 20l54 101h76zM448 796l-46 20l54 101h76zM373 -5q-75 0 -136.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q75 0 136 -31.5t105 -82.5t68 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-106 -79t-133.5 -29.5z M130 355q0 -54 17.5 -104.5t49.5 -89.5t77 -62t100 -23q57 0 102 24.5t76.5 64t48 89.5t16.5 101q0 54 -17.5 104.5t-50 89t-77 61.5t-98.5 23q-57 0 -102 -24t-76.5 -63t-48.5 -89t-17 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 599,
    d: "M236 609l-46 20l54 101h76zM372 609l-46 20l54 101h76zM299 -10q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59t54 -86t19.5 -104q0 -54 -19 -103t-54 -86t-83.5 -59t-107.5 -22zM126 259q0 -41 13.5 -76t37 -61t55 -41 t67.5 -15t67.5 15t55.5 41.5t37.5 62t13.5 76.5q0 40 -13.5 75.5t-37.5 62t-55.5 41.5t-67.5 15t-67.5 -15.5t-55 -42t-37 -62t-13.5 -76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1131,
    d: "M1094 80v-80h-474v157q-17 -35 -42 -64.5t-57 -51t-69 -34t-78 -12.5q-75 0 -136.5 30.5t-105.5 81t-68.5 115.5t-24.5 133q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q42 0 79.5 -12.5t68.5 -34.5t55.5 -51.5t41.5 -63.5v157h465v-80h-375v-228h321v-80h-321v-242 h384zM374 76q57 0 102 24t76.5 63.5t48 90t16.5 102.5q0 54 -17.5 104t-50 89t-77 62t-98.5 23q-57 0 -102 -24t-76.5 -63.5t-48.5 -89.5t-17 -102q0 -54 17.5 -104.5t49.5 -89.5t77 -62t100 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 1028,
    d: "M298 -10q-56 0 -104 20.5t-83 57t-55 85.5t-20 106q0 58 20 107.5t55.5 86t83.5 57.5t104 21q74 0 131.5 -40.5t86.5 -111.5q31 73 87.5 112.5t133.5 39.5q56 0 102.5 -19.5t81 -55t55 -85t23.5 -110.5v-15.5t-1 -14.5h-433q3 -37 18.5 -69t40 -56t56.5 -37.5t68 -13.5 q25 0 49 6.5t44 18t34.5 27.5t22.5 36l74 -21q-14 -30 -37 -54t-53 -41.5t-65.5 -27t-72.5 -9.5q-72 0 -131 40t-96 109q-37 -71 -93 -110t-127 -39zM299 66q37 0 68.5 15t55 41t37 61.5t13.5 76.5t-13.5 76.5t-36.5 62t-55 41.5t-68 15t-68 -15.5t-55.5 -42t-37 -62.5 t-13.5 -77t13.5 -76t36.5 -61t55 -40.5t68 -14.5zM915 288q-3 39 -18 71.5t-39 56t-55.5 36.5t-66.5 13t-65.5 -13t-53.5 -36.5t-37 -56t-16 -71.5h351z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 657,
    d: "M334 797l-58 20l58 101h88zM85 0v710h304q47 0 86.5 -19.5t68 -52t44.5 -73t16 -82.5q0 -37 -10.5 -71.5t-30 -62.5t-47 -48t-61.5 -29l172 -272h-102l-162 255h-188v-255h-90zM175 335h215q28 0 50.5 12t38.5 32.5t25 47.5t9 56q0 30 -10.5 56.5t-28 47t-41 32 t-49.5 11.5h-209v-295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 363,
    d: "M226 609l-58 20l58 101h88zM347 445q-66 -2 -116.5 -34t-71.5 -89v-322h-88v522h82v-121q27 54 71 87.5t94 37.5h17t12 -1v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 657,
    d: "M295 -213l20 81h-25v84h78v-84l-30 -81h-43zM85 0v710h304q47 0 86.5 -19.5t68 -52t44.5 -73t16 -82.5q0 -37 -10.5 -71.5t-30 -62.5t-47 -48t-61.5 -29l172 -272h-102l-162 255h-188v-255h-90zM175 335h215q28 0 50.5 12t38.5 32.5t25 47.5t9 56q0 30 -10.5 56.5t-28 47 t-41 32t-49.5 11.5h-209v-295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 363,
    d: "M75 -213l20 81h-25v84h78v-84l-30 -81h-43zM347 445q-66 -2 -116.5 -34t-71.5 -89v-322h-88v522h82v-121q27 54 71 87.5t94 37.5h17t12 -1v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 657,
    d: "M233 918l85 -63l85 63l48 -24l-101 -90h-64l-101 90zM85 0v710h304q47 0 86.5 -19.5t68 -52t44.5 -73t16 -82.5q0 -37 -10.5 -71.5t-30 -62.5t-47 -48t-61.5 -29l172 -272h-102l-162 255h-188v-255h-90zM175 335h215q28 0 50.5 12t38.5 32.5t25 47.5t9 56 q0 30 -10.5 56.5t-28 47t-41 32t-49.5 11.5h-209v-295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 363,
    d: "M126 730l85 -63l85 63l48 -24l-101 -90h-64l-101 90zM347 445q-66 -2 -116.5 -34t-71.5 -89v-322h-88v522h82v-121q27 54 71 87.5t94 37.5h17t12 -1v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 609,
    d: "M331 809l-58 20l58 101h88zM502 561q-12 14 -32 27t-45 23.5t-54.5 17t-61.5 6.5q-83 0 -121.5 -31t-38.5 -85q0 -29 11 -48t34.5 -32.5t58.5 -23.5t83 -21q55 -12 99.5 -27.5t76 -38.5t48 -56t16.5 -81q0 -51 -20 -88.5t-54.5 -62t-81.5 -36t-102 -11.5 q-82 0 -155.5 25.5t-133.5 74.5l43 76q16 -17 41.5 -34t58 -30.5t70 -22t78.5 -8.5q76 0 118 27t42 81q0 30 -13.5 50.5t-39.5 35.5t-64.5 26.5t-87.5 23.5q-54 13 -95 28t-68.5 36t-41.5 51t-14 72q0 51 19 90t53 66t81 40.5t102 13.5q72 0 130 -22t103 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 494,
    d: "M263 609l-58 20l58 101h88zM254 -10q-63 0 -124 19.5t-105 56.5l38 59q46 -35 92 -52.5t97 -17.5q57 0 90.5 22.5t33.5 63.5q0 19 -9 32.5t-27 23.5t-46 18t-65 17q-47 12 -81 23t-56 26t-32 36t-10 52q0 39 15.5 69.5t42.5 51t63.5 31t78.5 10.5q59 0 110 -19t86 -50 l-40 -53q-33 29 -74 43.5t-84 14.5q-48 0 -81.5 -20.5t-33.5 -65.5q0 -18 6.5 -30t21.5 -21t38.5 -16t56.5 -15q52 -12 90.5 -24.5t64 -29.5t38 -40t12.5 -56q0 -73 -56 -116t-151 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 609,
    d: "M183 840l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM502 561q-12 14 -32 27t-45 23.5t-54.5 17t-61.5 6.5q-83 0 -121.5 -31t-38.5 -85q0 -29 11 -48t34.5 -32.5t58.5 -23.5t83 -21q55 -12 99.5 -27.5t76 -38.5t48 -56t16.5 -81q0 -51 -20 -88.5t-54.5 -62t-81.5 -36 t-102 -11.5q-82 0 -155.5 25.5t-133.5 74.5l43 76q16 -17 41.5 -34t58 -30.5t70 -22t78.5 -8.5q76 0 118 27t42 81q0 30 -13.5 50.5t-39.5 35.5t-64.5 26.5t-87.5 23.5q-54 13 -95 28t-68.5 36t-41.5 51t-14 72q0 51 19 90t53 66t81 40.5t102 13.5q72 0 130 -22t103 -59z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 494,
    d: "M115 640l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM254 -10q-63 0 -124 19.5t-105 56.5l38 59q46 -35 92 -52.5t97 -17.5q57 0 90.5 22.5t33.5 63.5q0 19 -9 32.5t-27 23.5t-46 18t-65 17q-47 12 -81 23t-56 26t-32 36t-10 52q0 39 15.5 69.5t42.5 51t63.5 31 t78.5 10.5q59 0 110 -19t86 -50l-40 -53q-33 29 -74 43.5t-84 14.5q-48 0 -81.5 -20.5t-33.5 -65.5q0 -18 6.5 -30t21.5 -21t38.5 -16t56.5 -15q52 -12 90.5 -24.5t64 -29.5t38 -40t12.5 -56q0 -73 -56 -116t-151 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015E",
    unicode: "\u015E",
    horizAdvX: 609,
    d: "M243 -126q13 -7 37.5 -13t50.5 -6q27 0 42 8t15 27q0 20 -14 27.5t-37 7.5q-21 0 -44 -4.5t-36 -8.5l43 82q-77 2 -145.5 27t-125.5 72l43 76q16 -17 41.5 -34t58 -30.5t70 -22t78.5 -8.5q76 0 118 27t42 81q0 30 -13.5 50.5t-39.5 35.5t-64.5 26.5t-87.5 23.5 q-54 13 -95 28t-68.5 36t-41.5 51t-14 72q0 51 19 90t53 66t81 40.5t102 13.5q72 0 130 -22t103 -59l-42 -73q-12 14 -32 27t-45 23.5t-54.5 17t-61.5 6.5q-83 0 -121.5 -31t-38.5 -85q0 -29 11 -48t34.5 -32.5t58.5 -23.5t83 -21q55 -12 99.5 -27.5t76 -38.5t48 -56 t16.5 -81t-17.5 -84t-48.5 -60t-73.5 -37t-91.5 -16l-26 -42q8 3 18 4t18 1q35 0 57 -16t22 -48q0 -35 -28 -55t-82 -20q-30 0 -55.5 5.5t-45.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015F",
    unicode: "\u015F",
    horizAdvX: 494,
    d: "M176 -126q13 -7 37.5 -13t50.5 -6q27 0 42 8t15 27q0 20 -14 27.5t-37 7.5q-21 0 -44 -4.5t-36 -8.5l42 79q-58 4 -112.5 22.5t-94.5 52.5l38 59q46 -35 92 -52.5t97 -17.5q57 0 90.5 22.5t33.5 63.5q0 19 -9 32.5t-27 23.5t-46 18t-65 17q-47 12 -81 23t-56 26t-32 36 t-10 52q0 39 15.5 69.5t42.5 51t63.5 31t78.5 10.5q59 0 110 -19t86 -50l-40 -53q-33 29 -74 43.5t-84 14.5q-48 0 -81.5 -20.5t-33.5 -65.5q0 -18 6.5 -30t21.5 -21t38.5 -16t56.5 -15q52 -12 90.5 -24.5t64 -29.5t38 -40t12.5 -56q0 -69 -50 -111t-135 -47l-24 -39 q8 3 18 4t18 1q35 0 57 -16t22 -48q0 -35 -28 -55t-82 -20q-30 0 -55.5 5.5t-45.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 609,
    d: "M231 930l85 -63l85 63l48 -24l-101 -90h-64l-101 90zM502 561q-12 14 -32 27t-45 23.5t-54.5 17t-61.5 6.5q-83 0 -121.5 -31t-38.5 -85q0 -29 11 -48t34.5 -32.5t58.5 -23.5t83 -21q55 -12 99.5 -27.5t76 -38.5t48 -56t16.5 -81q0 -51 -20 -88.5t-54.5 -62t-81.5 -36 t-102 -11.5q-82 0 -155.5 25.5t-133.5 74.5l43 76q16 -17 41.5 -34t58 -30.5t70 -22t78.5 -8.5q76 0 118 27t42 81q0 30 -13.5 50.5t-39.5 35.5t-64.5 26.5t-87.5 23.5q-54 13 -95 28t-68.5 36t-41.5 51t-14 72q0 51 19 90t53 66t81 40.5t102 13.5q72 0 130 -22t103 -59z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 494,
    d: "M163 730l85 -63l85 63l48 -24l-101 -90h-64l-101 90zM254 -10q-63 0 -124 19.5t-105 56.5l38 59q46 -35 92 -52.5t97 -17.5q57 0 90.5 22.5t33.5 63.5q0 19 -9 32.5t-27 23.5t-46 18t-65 17q-47 12 -81 23t-56 26t-32 36t-10 52q0 39 15.5 69.5t42.5 51t63.5 31 t78.5 10.5q59 0 110 -19t86 -50l-40 -53q-33 29 -74 43.5t-84 14.5q-48 0 -81.5 -20.5t-33.5 -65.5q0 -18 6.5 -30t21.5 -21t38.5 -16t56.5 -15q52 -12 90.5 -24.5t64 -29.5t38 -40t12.5 -56q0 -73 -56 -116t-151 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 613,
    d: "M230 -126q13 -7 37.5 -13t50.5 -6q27 0 42 8t15 27q0 20 -14 27.5t-37 7.5q-21 0 -44 -4.5t-36 -8.5l47 88h-30v630h-245v80h580v-80h-245v-630h-15l-30 -48q8 3 18 4t18 1q35 0 57 -16t22 -48q0 -35 -28 -55t-82 -20q-30 0 -55.5 5.5t-45.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 352,
    d: "M136 -126q13 -7 37.5 -13t50.5 -6q27 0 42 8t15 27q0 20 -14 27.5t-37 7.5q-21 0 -44 -4.5t-36 -8.5l43 82q-41 5 -69 31t-28 77v351h-71v69h71v174h88v-174h117v-69h-117v-324q2 -29 19 -42t40 -13q26 0 47.5 8.5t29.5 13.5l21 -70q-14 -7 -41 -17t-61 -14l-27 -43 q8 3 18 4t18 1q35 0 57 -16t22 -48q0 -35 -28 -55t-82 -20q-30 0 -55.5 5.5t-45.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 614,
    d: "M225 916l85 -63l85 63l48 -24l-101 -90h-64l-101 90zM597 630h-245v-630h-90v630h-245v80h580v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 352,
    d: "M302 609l-58 20l58 101h88zM341 26q-8 -4 -21 -9.5t-29.5 -11t-36 -9t-40.5 -3.5q-48 0 -83 26.5t-35 82.5v351h-71v69h71v174h88v-174h117v-69h-117v-324q2 -29 19 -42t40 -13q26 0 47.5 8.5t29.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 642,
    d: "M611 630h-245v-233h211v-47h-211v-350h-90v350h-211v47h211v233h-245v80h580v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 353,
    d: "M342 26q-8 -4 -21 -9.5t-29.5 -11t-36 -9t-40.5 -3.5q-48 0 -83 26.5t-35 82.5v192h-71v56h71v103h-71v69h71v174h88v-174h117v-69h-117v-103h117v-56h-117v-165q2 -29 19 -42t40 -13q26 0 47.5 8.5t29.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 755,
    d: "M377 76q62 0 103 24t65.5 62.5t34.5 88t10 100.5v359h90v-359q0 -72 -16.5 -136.5t-52.5 -113.5t-93.5 -77.5t-139.5 -28.5q-85 0 -143 30t-93.5 79.5t-51 114t-15.5 132.5v359h90v-359q0 -53 10.5 -102.5t35 -87.5t65 -61.5t101.5 -23.5zM440 813q-23 0 -39.5 6.5 t-31 14.5t-28.5 14.5t-30 6.5q-17 0 -26.5 -7t-14.5 -15.5t-6.5 -16.5t-1.5 -9h-52q0 6 4.5 23t15.5 35t30 31.5t49 13.5q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q19 0 30 7t17 16t7.5 16.5t1.5 9.5h52q0 -6 -4.5 -22.5t-16.5 -34.5t-32.5 -32t-52.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 601,
    d: "M232 -10q-82 0 -124 55t-42 164v313h88v-296q0 -160 111 -160q54 0 101.5 34.5t70.5 94.5v327h88v-414q0 -31 28 -32v-76q-15 -2 -23.5 -2.5t-16.5 -0.5q-26 0 -43.5 15.5t-18.5 38.5l-2 61q-35 -59 -92 -90.5t-125 -31.5zM357 627q-23 0 -39.5 6.5t-31 14.5t-28.5 14.5 t-30 6.5q-17 0 -26.5 -7t-14.5 -15.5t-6.5 -16.5t-1.5 -9h-52q0 6 4.5 23t15.5 35t30 31.5t49 13.5q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q19 0 30 7t17 16t7.5 16.5t1.5 9.5h52q0 -6 -4.5 -22.5t-16.5 -34.5t-32.5 -32t-52.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 755,
    d: "M377 76q62 0 103 24t65.5 62.5t34.5 88t10 100.5v359h90v-359q0 -72 -16.5 -136.5t-52.5 -113.5t-93.5 -77.5t-139.5 -28.5q-85 0 -143 30t-93.5 79.5t-51 114t-15.5 132.5v359h90v-359q0 -53 10.5 -102.5t35 -87.5t65 -61.5t101.5 -23.5zM232 840v58h292v-58h-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 601,
    d: "M232 -10q-82 0 -124 55t-42 164v313h88v-296q0 -160 111 -160q54 0 101.5 34.5t70.5 94.5v327h88v-414q0 -31 28 -32v-76q-15 -2 -23.5 -2.5t-16.5 -0.5q-26 0 -43.5 15.5t-18.5 38.5l-2 61q-35 -59 -92 -90.5t-125 -31.5zM149 654v58h292v-58h-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 755,
    d: "M377 76q62 0 103 24t65.5 62.5t34.5 88t10 100.5v359h90v-359q0 -72 -16.5 -136.5t-52.5 -113.5t-93.5 -77.5t-139.5 -28.5q-85 0 -143 30t-93.5 79.5t-51 114t-15.5 132.5v359h90v-359q0 -53 10.5 -102.5t35 -87.5t65 -61.5t101.5 -23.5zM378 848q22 0 38.5 19.5 t19.5 48.5h50q0 -24 -8.5 -44t-23 -35t-34 -23.5t-42.5 -8.5t-42.5 8.5t-34 23.5t-23 35t-8.5 44h51q0 -27 17 -47.5t40 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 601,
    d: "M232 -10q-82 0 -124 55t-42 164v313h88v-296q0 -160 111 -160q54 0 101.5 34.5t70.5 94.5v327h88v-414q0 -31 28 -32v-76q-15 -2 -23.5 -2.5t-16.5 -0.5q-26 0 -43.5 15.5t-18.5 38.5l-2 61q-35 -59 -92 -90.5t-125 -31.5zM294 662q22 0 38.5 19.5t19.5 48.5h50 q0 -24 -8.5 -44t-23 -35t-34 -23.5t-42.5 -8.5t-42.5 8.5t-34 23.5t-23 35t-8.5 44h51q0 -27 17 -47.5t40 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 755,
    d: "M296 847q0 32 23 50.5t58 18.5q36 0 58.5 -18.5t22.5 -50.5t-22.5 -50.5t-58.5 -18.5q-35 0 -58 18.5t-23 50.5zM377 885q-17 0 -28.5 -10.5t-11.5 -27.5q0 -16 11.5 -27t28.5 -11q16 0 28.5 10.5t12.5 27.5t-12 27.5t-29 10.5zM377 76q62 0 103 24t65.5 62.5t34.5 88 t10 100.5v359h90v-359q0 -72 -16.5 -136.5t-52.5 -113.5t-93.5 -77.5t-139.5 -28.5q-85 0 -143 30t-93.5 79.5t-51 114t-15.5 132.5v359h90v-359q0 -53 10.5 -102.5t35 -87.5t65 -61.5t101.5 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 601,
    d: "M213 661q0 32 23 50.5t58 18.5q36 0 58.5 -18.5t22.5 -50.5t-22.5 -50.5t-58.5 -18.5q-35 0 -58 18.5t-23 50.5zM294 699q-17 0 -28.5 -10.5t-11.5 -27.5q0 -16 11.5 -27t28.5 -11q16 0 28.5 10.5t12.5 27.5t-12 27.5t-29 10.5zM232 -10q-82 0 -124 55t-42 164v313h88 v-296q0 -160 111 -160q54 0 101.5 34.5t70.5 94.5v327h88v-414q0 -31 28 -32v-76q-15 -2 -23.5 -2.5t-16.5 -0.5q-26 0 -43.5 15.5t-18.5 38.5l-2 61q-35 -59 -92 -90.5t-125 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 755,
    d: "M377 76q62 0 103 24t65.5 62.5t34.5 88t10 100.5v359h90v-359q0 -72 -16.5 -136.5t-52.5 -113.5t-93.5 -77.5t-139.5 -28.5q-85 0 -143 30t-93.5 79.5t-51 114t-15.5 132.5v359h90v-359q0 -53 10.5 -102.5t35 -87.5t65 -61.5t101.5 -23.5zM314 796l-46 20l54 101h76z M450 796l-46 20l54 101h76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 601,
    d: "M232 -10q-82 0 -124 55t-42 164v313h88v-296q0 -160 111 -160q54 0 101.5 34.5t70.5 94.5v327h88v-414q0 -31 28 -32v-76q-15 -2 -23.5 -2.5t-16.5 -0.5q-26 0 -43.5 15.5t-18.5 38.5l-2 61q-35 -59 -92 -90.5t-125 -31.5zM231 609l-46 20l54 101h76zM367 609l-46 20 l54 101h76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 755,
    d: "M377 76q62 0 103 24t65.5 62.5t34.5 88t10 100.5v359h90v-359q0 -70 -15.5 -133t-49.5 -111t-88 -78t-130 -33q-42 -26 -59.5 -47t-17.5 -43q0 -37 55 -43l-22 -46q-42 8 -63 28.5t-21 48.5q0 26 18 51.5t57 51.5q-75 6 -126.5 37.5t-83 80.5t-45.5 110t-14 126v359h90 v-359q0 -53 10.5 -102.5t35 -87.5t65 -61.5t101.5 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 601,
    d: "M232 -10q-82 0 -124 55t-42 164v313h88v-296q0 -160 111 -160q54 0 101.5 34.5t70.5 94.5v327h88v-414q0 -31 28 -32v-76q-44 -27 -63 -48.5t-19 -43.5q0 -37 55 -43l-22 -46q-42 8 -63 28.5t-21 48.5q0 52 76 103q-20 5 -32 18.5t-13 33.5l-2 61q-35 -59 -92 -90.5 t-125 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1049,
    d: "M391 826l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM345 706h85l94 -247l95 247h85l-123 -309l122 -293l240 606h98l-297 -710h-78l-141 335l-142 -335h-78l-296 710h97l241 -606l121 293z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 821,
    d: "M277 640l101 90h64l101 -90l-48 -24l-85 63l-85 -63zM725 522h85l-222 -522h-73l-105 255l-104 -255h-73l-222 522h84l180 -435l88 217l-90 217h73l64 -167l64 167h73l-89 -217l88 -217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 655,
    d: "M112 710l215 -370l217 370h98l-270 -451v-259h-90v261l-269 449h99zM194 826l101 90h64l101 -90l-48 -24l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 545,
    d: "M95 -142q13 -2 26 -3t20 -1q12 0 21.5 5.5t19 21.5t21.5 44.5t30 74.5l-221 522h91l178 -443l162 443h84l-254 -659q-14 -35 -46.5 -61.5t-89.5 -26.5q-9 0 -18.5 1t-23.5 4v78zM148 640l101 90h64l101 -90l-48 -24l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 655,
    d: "M112 710l215 -370l217 370h98l-270 -451v-259h-90v261l-269 449h99zM209 811v102h74v-102h-74zM371 811v102h74v-102h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 631,
    d: "M346 795l-58 20l58 101h88zM32 70l458 560h-449v80h554v-70l-450 -560h450v-80h-563v70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 493,
    d: "M270 609l-58 20l58 101h88zM30 57l334 401h-325v64h419v-57l-332 -401h333v-64h-429v57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 631,
    d: "M32 70l458 560h-449v80h554v-70l-450 -560h450v-80h-563v70zM291 810v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 493,
    d: "M30 57l334 401h-325v64h419v-57l-332 -401h333v-64h-429v57zM214 624v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 631,
    d: "M246 916l85 -63l85 63l48 -24l-101 -90h-64l-101 90zM32 70l458 560h-449v80h554v-70l-450 -560h450v-80h-563v70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 493,
    d: "M169 730l85 -63l85 63l48 -24l-101 -90h-64l-101 90zM30 57l334 401h-325v64h419v-57l-332 -401h333v-64h-429v57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Schwa",
    unicode: "\u018F",
    horizAdvX: 736,
    d: "M364 -5q-70 0 -131.5 28t-107 76t-72 112.5t-26.5 137.5q0 13 0.5 25t2.5 18h567q-5 51 -26 95t-52.5 76.5t-72.5 50.5t-87 18q-35 0 -67 -10t-58.5 -27.5t-46.5 -42t-29 -53.5l-85 39q19 39 50.5 72t70.5 56t83 36t90 13q69 0 129 -28t104.5 -77t70 -115t25.5 -142 q0 -75 -25.5 -140.5t-70.5 -114t-105.5 -76t-130.5 -27.5zM366 76q47 0 88 18t72 49.5t50.5 75.5t22.5 95h-475q3 -50 23 -93.5t53 -75.5t75.5 -50.5t90.5 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 534,
    d: "M150 -186q-34 0 -65 10t-55 32l41 59q14 -13 32.5 -18t36.5 -5q16 0 31 6.5t27 17.5t19 27t7 34v415h-71v69h71v72q0 97 43 152t117 55q30 0 60.5 -8.5t54.5 -23.5l-22 -65q-14 10 -35 16t-41 6q-44 0 -66.5 -33t-22.5 -96v-75h139v-69h-139v-413q0 -36 -13.5 -66.5 t-36 -52.5t-52 -34t-60.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C4",
    unicode: "\u01C4",
    horizAdvX: 1347,
    d: "M85 0v710h246q85 0 149.5 -28t107.5 -76t64.5 -112.5t21.5 -137.5q0 -81 -24 -146.5t-69 -112t-108.5 -72t-141.5 -25.5h-246zM583 356q0 60 -16.5 110.5t-49 86.5t-79.5 56.5t-107 20.5h-156v-550h156q61 0 108.5 21t79 58t48 87.5t16.5 109.5zM962 916l85 -63l85 63 l48 -24l-101 -90h-64l-101 90zM748 70l458 560h-449v80h554v-70l-450 -560h450v-80h-563v70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C5",
    unicode: "\u01C5",
    horizAdvX: 1209,
    d: "M85 0v710h246q85 0 149.5 -28t107.5 -76t64.5 -112.5t21.5 -137.5q0 -81 -24 -146.5t-69 -112t-108.5 -72t-141.5 -25.5h-246zM583 356q0 60 -16.5 110.5t-49 86.5t-79.5 56.5t-107 20.5h-156v-550h156q61 0 108.5 21t79 58t48 87.5t16.5 109.5zM885 730l85 -63l85 63 l48 -24l-101 -90h-64l-101 90zM746 57l334 401h-325v64h419v-57l-332 -401h333v-64h-429v57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C6",
    unicode: "\u01C6",
    horizAdvX: 1122,
    d: "M286 -10q-54 0 -100 22t-79 59t-51.5 86t-18.5 103q0 55 17.5 104.5t49 86.5t75 58.5t95.5 21.5q63 0 112.5 -33t78.5 -80v312h88v-622q0 -31 28 -32v-76q-14 -2 -22.5 -3t-16.5 -1q-26 0 -45.5 17.5t-19.5 40.5v44q-31 -51 -82.5 -79.5t-108.5 -28.5zM307 66 q24 0 49.5 9t48 25t39 37.5t21.5 45.5v150q-9 25 -27 47.5t-40.5 39t-48 26t-50.5 9.5q-39 0 -70.5 -16.5t-54 -44t-34.5 -63t-12 -72.5q0 -39 14 -74.5t38 -61.5t56.5 -41.5t70.5 -15.5zM798 730l85 -63l85 63l48 -24l-101 -90h-64l-101 90zM659 57l334 401h-325v64h419 v-57l-332 -401h333v-64h-429v57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C7",
    unicode: "\u01C7",
    horizAdvX: 1069,
    d: "M85 0v710h90v-630h396v-80h-486zM619 106q20 -14 54 -25t77 -11q51 0 81 18t45.5 53.5t20.5 87.5t5 120v361h90v-361q0 -81 -7.5 -147.5t-33 -113.5t-73 -73t-128.5 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C8",
    unicode: "\u01C8",
    horizAdvX: 821,
    d: "M85 0v710h90v-630h396v-80h-486zM588 -186q-35 0 -65.5 10t-54.5 32l41 59q14 -13 32.5 -18t36.5 -5q16 0 31 6.5t27 17.5t19 27t7 34v545h88v-539q0 -37 -13.5 -68t-36 -53.5t-51.5 -35t-61 -12.5zM662 620v110h88v-110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C9",
    unicode: "\u01C9",
    horizAdvX: 523,
    d: "M73 730h88v-595q0 -29 15.5 -45.5t43.5 -16.5q11 0 26 3.5t28 8.5l14 -71q-22 -9 -52 -15t-53 -6q-51 0 -80.5 29t-29.5 81v627zM290 -186q-35 0 -65.5 10t-54.5 32l41 59q14 -13 32.5 -18t36.5 -5q16 0 31 6.5t27 17.5t19 27t7 34v545h88v-539q0 -37 -13.5 -68 t-36 -53.5t-51.5 -35t-61 -12.5zM364 620v110h88v-110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CA",
    unicode: "\u01CA",
    horizAdvX: 1255,
    d: "M175 542v-542h-90v710h70l440 -553v552h90v-709h-76zM805 106q20 -14 54 -25t77 -11q51 0 81 18t45.5 53.5t20.5 87.5t5 120v361h90v-361q0 -81 -7.5 -147.5t-33 -113.5t-73 -73t-128.5 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CB",
    unicode: "\u01CB",
    horizAdvX: 1007,
    d: "M175 542v-542h-90v710h70l440 -553v552h90v-709h-76zM774 -186q-35 0 -65.5 10t-54.5 32l41 59q14 -13 32.5 -18t36.5 -5q16 0 31 6.5t27 17.5t19 27t7 34v545h88v-539q0 -37 -13.5 -68t-36 -53.5t-51.5 -35t-61 -12.5zM848 620v110h88v-110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CC",
    unicode: "\u01CC",
    horizAdvX: 827,
    d: "M524 0h-88v292q0 84 -25.5 122t-77.5 38q-27 0 -54 -10.5t-51 -28.5t-42 -43t-27 -55v-315h-88v522h80v-112q31 55 89.5 88t127.5 33q45 0 75 -16.5t48 -46t25.5 -69.5t7.5 -87v-312zM594 -186q-35 0 -65.5 10t-54.5 32l41 59q14 -13 32.5 -18t36.5 -5q16 0 31 6.5 t27 17.5t19 27t7 34v545h88v-539q0 -37 -13.5 -68t-36 -53.5t-51.5 -35t-61 -12.5zM668 620v110h88v-110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oogonek",
    unicode: "\u01EA",
    horizAdvX: 748,
    d: "M349 -183q-42 8 -63 28.5t-21 48.5q0 26 18 51.5t57 51.5q-68 7 -123.5 39.5t-95 82t-61 110.5t-21.5 126q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q75 0 136 -31.5t105 -82.5t68 -115.5t24 -131.5q0 -68 -23.5 -131t-65.5 -112t-99.5 -80t-125.5 -35 q-42 -26 -60 -47t-18 -43q0 -37 55 -43zM130 355q0 -54 17.5 -104.5t49.5 -89.5t77 -62t100 -23q57 0 102 24.5t76.5 64t48 89.5t16.5 101q0 54 -17.5 104.5t-50 89t-77 61.5t-98.5 23q-57 0 -102 -24t-76.5 -63t-48.5 -89t-17 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oogonek",
    unicode: "\u01EB",
    horizAdvX: 599,
    d: "M297 -186q-42 8 -63 28.5t-21 48.5q0 50 70 100q-56 3 -101.5 25.5t-77.5 59.5t-50 84t-18 100q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59t54 -86t19.5 -104q0 -49 -16 -94t-44.5 -80.5t-69.5 -60t-90 -31.5q-42 -26 -60.5 -47.5t-18.5 -43.5q0 -37 55 -43z M126 259q0 -41 13.5 -76t37 -61t55 -41t67.5 -15t67.5 15t55.5 41.5t37.5 62t13.5 76.5q0 40 -13.5 75.5t-37.5 62t-55.5 41.5t-67.5 15t-67.5 -15.5t-55 -42t-37 -62t-13.5 -76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F1",
    unicode: "\u01F1",
    horizAdvX: 1334,
    d: "M85 0v710h246q85 0 149.5 -28t107.5 -76t64.5 -112.5t21.5 -137.5q0 -81 -24 -146.5t-69 -112t-108.5 -72t-141.5 -25.5h-246zM583 356q0 60 -16.5 110.5t-49 86.5t-79.5 56.5t-107 20.5h-156v-550h156q61 0 108.5 21t79 58t48 87.5t16.5 109.5zM735 70l458 560h-449v80 h554v-70l-450 -560h450v-80h-563v70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F2",
    unicode: "\u01F2",
    horizAdvX: 1209,
    d: "M85 0v710h246q85 0 149.5 -28t107.5 -76t64.5 -112.5t21.5 -137.5q0 -81 -24 -146.5t-69 -112t-108.5 -72t-141.5 -25.5h-246zM583 356q0 60 -16.5 110.5t-49 86.5t-79.5 56.5t-107 20.5h-156v-550h156q61 0 108.5 21t79 58t48 87.5t16.5 109.5zM746 57l334 401h-325v64 h419v-57l-332 -401h333v-64h-429v57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F3",
    unicode: "\u01F3",
    horizAdvX: 1122,
    d: "M286 -10q-54 0 -100 22t-79 59t-51.5 86t-18.5 103q0 55 17.5 104.5t49 86.5t75 58.5t95.5 21.5q63 0 112.5 -33t78.5 -80v312h88v-622q0 -31 28 -32v-76q-14 -2 -22.5 -3t-16.5 -1q-26 0 -45.5 17.5t-19.5 40.5v44q-31 -51 -82.5 -79.5t-108.5 -28.5zM307 66 q24 0 49.5 9t48 25t39 37.5t21.5 45.5v150q-9 25 -27 47.5t-40.5 39t-48 26t-50.5 9.5q-39 0 -70.5 -16.5t-54 -44t-34.5 -63t-12 -72.5q0 -39 14 -74.5t38 -61.5t56.5 -41.5t70.5 -15.5zM659 57l334 401h-325v64h419v-57l-332 -401h333v-64h-429v57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gacute",
    unicode: "\u01F4",
    horizAdvX: 714,
    d: "M586 96q-94 -101 -216 -101q-71 0 -131.5 31t-104.5 81.5t-69.5 115.5t-25.5 134q0 72 25 136.5t69 114t105 78.5t132 29q103 0 169.5 -43t101.5 -112l-69 -48q-32 62 -85 92t-119 30q-54 0 -98 -23.5t-75 -62t-48 -89t-17 -104.5q0 -57 19 -107.5t52 -89t78 -60.5 t98 -22q116 0 209 112v98h-153v68h229v-354h-76v96zM390 795l-58 20l58 101h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gacute",
    unicode: "\u01F5",
    horizAdvX: 623,
    d: "M278 -6q-53 0 -97.5 22t-76.5 59t-49.5 85t-17.5 100q0 55 17.5 104.5t49.5 86.5t76.5 58.5t98.5 21.5q66 0 114 -32t81 -81v104h78v-516q0 -56 -21 -98.5t-57 -71.5t-84.5 -44t-103.5 -15q-89 0 -144.5 30.5t-92.5 84.5l51 45q31 -46 80 -69t106 -23q36 0 68.5 10 t56.5 30t38.5 50t14.5 71v92q-15 -24 -35.5 -43.5t-44.5 -33t-51 -20.5t-55 -7zM305 66q28 0 54 10t48 26.5t37 37.5t20 43v150q-11 27 -28.5 49t-39.5 38.5t-47.5 25.5t-51.5 9q-40 0 -71.5 -17t-53.5 -45t-34 -63.5t-12 -71.5q0 -39 14 -74t38 -61t56.5 -41.5t70.5 -15.5z M324 609l-58 20l58 101h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 677,
    d: "M367 813q24 -7 38 -24t14 -41q0 -20 -9 -35t-25 -23l282 -690h-96l-84 208h-298l-83 -208h-96l282 689q-35 19 -35 59q0 26 16.5 44t42.5 23l44 103h88zM467 278l-128 328l-132 -328h260zM338 786q-17 0 -28.5 -10.5t-11.5 -27.5q0 -16 11.5 -27t28.5 -11q16 0 28.5 10.5 t12.5 27.5t-12 27.5t-29 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    horizAdvX: 554,
    d: "M205 -10q-37 0 -69 12.5t-55.5 34.5t-37 51.5t-13.5 64.5q0 36 16 65.5t45.5 50.5t70 33t88.5 12q38 0 77 -7t69 -19v42q0 64 -36 100.5t-102 36.5q-79 0 -166 -61l-29 57q101 68 203 68q103 0 160.5 -55t57.5 -155v-213q0 -31 28 -32v-76q-14 -2 -23 -3t-19 -1 q-26 0 -41.5 15.5t-18.5 37.5l-2 37q-35 -47 -88.5 -71.5t-114.5 -24.5zM228 56q47 0 87.5 17.5t61.5 46.5q19 19 19 39v77q-64 25 -133 25q-66 0 -107.5 -28t-41.5 -73q0 -22 8.5 -41t24 -33t36.5 -22t45 -8zM281 765l-58 20l58 101h88zM184 661q0 32 23 50.5t58 18.5 q36 0 58.5 -18.5t22.5 -50.5t-22.5 -50.5t-58.5 -18.5q-35 0 -58 18.5t-23 50.5zM265 699q-17 0 -28.5 -10.5t-11.5 -27.5q0 -16 11.5 -27t28.5 -11q16 0 28.5 10.5t12.5 27.5t-12 27.5t-29 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 961,
    d: "M547 795l-58 20l58 101h88zM428 710h488v-80h-375v-228h321v-80h-321v-242h384v-80h-473v208h-249l-130 -208h-98zM446 288v317l-203 -317h203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 933,
    d: "M460 609l-58 20l58 101h88zM204 -10q-37 0 -68.5 12.5t-55 34.5t-37 51.5t-13.5 64.5q0 36 16 65.5t45 50.5t69.5 33t88.5 12q34 0 67.5 -5.5t61.5 -14.5q2 16 5 34t9 32q-8 51 -42.5 79t-92.5 28q-78 0 -166 -61l-29 57q103 68 203 68q64 0 110 -25t71 -70q33 43 83 69 t112 26q59 0 108 -21.5t83.5 -58.5t54 -86t19.5 -104q0 -6 -0.5 -15.5t-1.5 -14.5h-443q3 -39 19 -71t41 -55t57.5 -36t68.5 -13q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10q-71 0 -127 31t-91 82q-17 -30 -43 -51.5 t-56 -35t-62 -20t-61 -6.5zM227 56q48 0 88 17.5t62 46.5q17 17 19 35q-8 17 -12.5 42.5t-5.5 44.5q-27 9 -57 14t-59 5q-66 0 -107.5 -28t-41.5 -73q0 -22 9 -41t24 -33t36 -22t45 -8zM822 288q-3 39 -18 71.5t-39 56t-56 36.5t-69 13t-69 -13t-56 -36.5t-38.5 -56 t-16.5 -71.5h362z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 748,
    d: "M663 710l-62 -92q51 -53 79 -122.5t28 -141.5q0 -71 -25.5 -136t-70 -114.5t-106 -79t-133.5 -29.5q-46 0 -87 11.5t-76 33.5l-27 -40h-98l61 91q-51 51 -79 120t-28 144q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q45 0 85.5 -12t75.5 -34l28 41h99zM617 355 q0 54 -17 103t-48 87l-296 -436q53 -33 118 -33q57 0 102 24.5t76.5 64t48 89.5t16.5 101zM130 355q0 -54 16.5 -104t48.5 -88l295 437q-53 33 -116 33q-57 0 -102 -24t-76.5 -63t-48.5 -89t-17 -102zM390 795l-58 20l58 101h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 599,
    d: "M314 609l-58 20l58 101h88zM80 -2l45 56q-42 38 -65.5 91.5t-23.5 114.5q0 55 19.5 104t54 86t83 59t106.5 22q39 0 74 -10t64 -28l24 31h56l-45 -57q43 -38 67 -92t24 -115q0 -54 -19 -103t-54 -86t-83.5 -59t-107.5 -22q-78 0 -140 39l-24 -31h-55zM299 66 q36 0 67.5 15t55.5 41.5t37.5 62t13.5 76.5q0 42 -14.5 77.5t-38.5 61.5l-212 -306q40 -28 91 -28zM126 259q0 -42 14 -77.5t38 -61.5l211 307q-20 13 -42.5 20.5t-47.5 7.5q-36 0 -67.5 -15.5t-55 -42t-37 -62t-13.5 -76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adblgrave",
    unicode: "\u0200",
    horizAdvX: 677,
    d: "M301 710h76l290 -710h-96l-84 208h-298l-83 -208h-96zM467 278l-128 328l-132 -328h260zM307 918h76l54 -101l-46 -20zM171 918h76l54 -101l-46 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adblgrave",
    unicode: "\u0201",
    horizAdvX: 554,
    d: "M205 -10q-37 0 -69 12.5t-55.5 34.5t-37 51.5t-13.5 64.5q0 36 16 65.5t45.5 50.5t70 33t88.5 12q38 0 77 -7t69 -19v42q0 64 -36 100.5t-102 36.5q-79 0 -166 -61l-29 57q101 68 203 68q103 0 160.5 -55t57.5 -155v-213q0 -31 28 -32v-76q-14 -2 -23 -3t-19 -1 q-26 0 -41.5 15.5t-18.5 37.5l-2 37q-35 -47 -88.5 -71.5t-114.5 -24.5zM228 56q47 0 87.5 17.5t61.5 46.5q19 19 19 39v77q-64 25 -133 25q-66 0 -107.5 -28t-41.5 -73q0 -22 8.5 -41t24 -33t36.5 -22t45 -8zM258 730h76l54 -101l-46 -20zM122 730h76l54 -101l-46 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ainvertedbreve",
    unicode: "\u0202",
    horizAdvX: 677,
    d: "M301 710h76l290 -710h-96l-84 208h-298l-83 -208h-96zM467 278l-128 328l-132 -328h260zM339 873q-23 0 -40 -20.5t-17 -47.5h-51q0 24 8.5 44t23 35t34 23.5t42.5 8.5t42.5 -8.5t34 -23.5t23 -35t8.5 -44h-50q-3 29 -19.5 48.5t-38.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ainvertedbreve",
    unicode: "\u0203",
    horizAdvX: 554,
    d: "M205 -10q-37 0 -69 12.5t-55.5 34.5t-37 51.5t-13.5 64.5q0 36 16 65.5t45.5 50.5t70 33t88.5 12q38 0 77 -7t69 -19v42q0 64 -36 100.5t-102 36.5q-79 0 -166 -61l-29 57q101 68 203 68q103 0 160.5 -55t57.5 -155v-213q0 -31 28 -32v-76q-14 -2 -23 -3t-19 -1 q-26 0 -41.5 15.5t-18.5 37.5l-2 37q-35 -47 -88.5 -71.5t-114.5 -24.5zM228 56q47 0 87.5 17.5t61.5 46.5q19 19 19 39v77q-64 25 -133 25q-66 0 -107.5 -28t-41.5 -73q0 -22 8.5 -41t24 -33t36.5 -22t45 -8zM273 687q-23 0 -40 -20.5t-17 -47.5h-51q0 24 8.5 44t23 35 t34 23.5t42.5 8.5t42.5 -8.5t34 -23.5t23 -35t8.5 -44h-50q-3 29 -19.5 48.5t-38.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edblgrave",
    unicode: "\u0204",
    horizAdvX: 605,
    d: "M567 80v-80h-482v710h473v-80h-383v-230h333v-75h-333v-245h392zM306 918h76l54 -101l-46 -20zM170 918h76l54 -101l-46 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edblgrave",
    unicode: "\u0205",
    d: "M302 -10q-59 0 -108 21.5t-84 58.5t-54.5 86.5t-19.5 104.5t19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21 q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354zM278 730h76l54 -101l-46 -20zM142 730h76l54 -101l-46 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Einvertedbreve",
    unicode: "\u0206",
    horizAdvX: 605,
    d: "M567 80v-80h-482v710h473v-80h-383v-230h333v-75h-333v-245h392zM333 873q-23 0 -40 -20.5t-17 -47.5h-51q0 24 8.5 44t23 35t34 23.5t42.5 8.5t42.5 -8.5t34 -23.5t23 -35t8.5 -44h-50q-3 29 -19.5 48.5t-38.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "einvertedbreve",
    unicode: "\u0207",
    d: "M302 -10q-59 0 -108 21.5t-84 58.5t-54.5 86.5t-19.5 104.5t19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21 q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354zM303 687q-23 0 -40 -20.5t-17 -47.5h-51q0 24 8.5 44t23 35t34 23.5t42.5 8.5t42.5 -8.5t34 -23.5t23 -35 t8.5 -44h-50q-3 29 -19.5 48.5t-38.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idblgrave",
    unicode: "\u0208",
    horizAdvX: 260,
    d: "M85 0v710h90v-710h-90zM112 918h76l54 -101l-46 -20zM-24 918h76l54 -101l-46 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idblgrave",
    unicode: "\u0209",
    horizAdvX: 230,
    d: "M71 0v522h88v-522h-88zM100 730h76l54 -101l-46 -20zM-36 730h76l54 -101l-46 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iinvertedbreve",
    unicode: "\u020A",
    horizAdvX: 260,
    d: "M85 0v710h90v-710h-90zM127 873q-23 0 -40 -20.5t-17 -47.5h-51q0 24 8.5 44t23 35t34 23.5t42.5 8.5t42.5 -8.5t34 -23.5t23 -35t8.5 -44h-50q-3 29 -19.5 48.5t-38.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iinvertedbreve",
    unicode: "\u020B",
    horizAdvX: 230,
    d: "M71 0v522h88v-522h-88zM116 687q-23 0 -40 -20.5t-17 -47.5h-51q0 24 8.5 44t23 35t34 23.5t42.5 8.5t42.5 -8.5t34 -23.5t23 -35t8.5 -44h-50q-3 29 -19.5 48.5t-38.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odblgrave",
    unicode: "\u020C",
    horizAdvX: 748,
    d: "M373 -5q-75 0 -136.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q75 0 136 -31.5t105 -82.5t68 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-106 -79t-133.5 -29.5zM130 355q0 -54 17.5 -104.5t49.5 -89.5t77 -62t100 -23 q57 0 102 24.5t76.5 64t48 89.5t16.5 101q0 54 -17.5 104.5t-50 89t-77 61.5t-98.5 23q-57 0 -102 -24t-76.5 -63t-48.5 -89t-17 -102zM342 918h76l54 -101l-46 -20zM206 918h76l54 -101l-46 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odblgrave",
    unicode: "\u020D",
    horizAdvX: 599,
    d: "M299 -10q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59t54 -86t19.5 -104q0 -54 -19 -103t-54 -86t-83.5 -59t-107.5 -22zM126 259q0 -41 13.5 -76t37 -61t55 -41t67.5 -15t67.5 15t55.5 41.5t37.5 62t13.5 76.5 q0 40 -13.5 75.5t-37.5 62t-55.5 41.5t-67.5 15t-67.5 -15.5t-55 -42t-37 -62t-13.5 -76.5zM271 730h76l54 -101l-46 -20zM135 730h76l54 -101l-46 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oinvertedbreve",
    unicode: "\u020E",
    horizAdvX: 748,
    d: "M373 -5q-75 0 -136.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q75 0 136 -31.5t105 -82.5t68 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-106 -79t-133.5 -29.5zM130 355q0 -54 17.5 -104.5t49.5 -89.5t77 -62t100 -23 q57 0 102 24.5t76.5 64t48 89.5t16.5 101q0 54 -17.5 104.5t-50 89t-77 61.5t-98.5 23q-57 0 -102 -24t-76.5 -63t-48.5 -89t-17 -102zM375 873q-23 0 -40 -20.5t-17 -47.5h-51q0 24 8.5 44t23 35t34 23.5t42.5 8.5t42.5 -8.5t34 -23.5t23 -35t8.5 -44h-50q-3 29 -19.5 48.5 t-38.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oinvertedbreve",
    unicode: "\u020F",
    horizAdvX: 599,
    d: "M299 -10q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59t54 -86t19.5 -104q0 -54 -19 -103t-54 -86t-83.5 -59t-107.5 -22zM126 259q0 -41 13.5 -76t37 -61t55 -41t67.5 -15t67.5 15t55.5 41.5t37.5 62t13.5 76.5 q0 40 -13.5 75.5t-37.5 62t-55.5 41.5t-67.5 15t-67.5 -15.5t-55 -42t-37 -62t-13.5 -76.5zM299 687q-23 0 -40 -20.5t-17 -47.5h-51q0 24 8.5 44t23 35t34 23.5t42.5 8.5t42.5 -8.5t34 -23.5t23 -35t8.5 -44h-50q-3 29 -19.5 48.5t-38.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdblgrave",
    unicode: "\u0210",
    horizAdvX: 657,
    d: "M85 0v710h304q47 0 86.5 -19.5t68 -52t44.5 -73t16 -82.5q0 -37 -10.5 -71.5t-30 -62.5t-47 -48t-61.5 -29l172 -272h-102l-162 255h-188v-255h-90zM175 335h215q28 0 50.5 12t38.5 32.5t25 47.5t9 56q0 30 -10.5 56.5t-28 47t-41 32t-49.5 11.5h-209v-295zM294 918h76 l54 -101l-46 -20zM158 918h76l54 -101l-46 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdblgrave",
    unicode: "\u0211",
    horizAdvX: 363,
    d: "M347 445q-66 -2 -116.5 -34t-71.5 -89v-322h-88v522h82v-121q27 54 71 87.5t94 37.5h17t12 -1v-80zM191 730h76l54 -101l-46 -20zM55 730h76l54 -101l-46 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rinvertedbreve",
    unicode: "\u0212",
    horizAdvX: 657,
    d: "M85 0v710h304q47 0 86.5 -19.5t68 -52t44.5 -73t16 -82.5q0 -37 -10.5 -71.5t-30 -62.5t-47 -48t-61.5 -29l172 -272h-102l-162 255h-188v-255h-90zM175 335h215q28 0 50.5 12t38.5 32.5t25 47.5t9 56q0 30 -10.5 56.5t-28 47t-41 32t-49.5 11.5h-209v-295zM323 873 q-23 0 -40 -20.5t-17 -47.5h-51q0 24 8.5 44t23 35t34 23.5t42.5 8.5t42.5 -8.5t34 -23.5t23 -35t8.5 -44h-50q-3 29 -19.5 48.5t-38.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rinvertedbreve",
    unicode: "\u0213",
    horizAdvX: 363,
    d: "M347 445q-66 -2 -116.5 -34t-71.5 -89v-322h-88v522h82v-121q27 54 71 87.5t94 37.5h17t12 -1v-80zM208 687q-23 0 -40 -20.5t-17 -47.5h-51q0 24 8.5 44t23 35t34 23.5t42.5 8.5t42.5 -8.5t34 -23.5t23 -35t8.5 -44h-50q-3 29 -19.5 48.5t-38.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udblgrave",
    unicode: "\u0214",
    horizAdvX: 755,
    d: "M377 76q62 0 103 24t65.5 62.5t34.5 88t10 100.5v359h90v-359q0 -72 -16.5 -136.5t-52.5 -113.5t-93.5 -77.5t-139.5 -28.5q-85 0 -143 30t-93.5 79.5t-51 114t-15.5 132.5v359h90v-359q0 -53 10.5 -102.5t35 -87.5t65 -61.5t101.5 -23.5zM349 918h76l54 -101l-46 -20z M213 918h76l54 -101l-46 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udblgrave",
    unicode: "\u0215",
    horizAdvX: 601,
    d: "M232 -10q-82 0 -124 55t-42 164v313h88v-296q0 -160 111 -160q54 0 101.5 34.5t70.5 94.5v327h88v-414q0 -31 28 -32v-76q-15 -2 -23.5 -2.5t-16.5 -0.5q-26 0 -43.5 15.5t-18.5 38.5l-2 61q-35 -59 -92 -90.5t-125 -31.5zM271 730h76l54 -101l-46 -20zM135 730h76 l54 -101l-46 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uinvertedbreve",
    unicode: "\u0216",
    horizAdvX: 755,
    d: "M377 76q62 0 103 24t65.5 62.5t34.5 88t10 100.5v359h90v-359q0 -72 -16.5 -136.5t-52.5 -113.5t-93.5 -77.5t-139.5 -28.5q-85 0 -143 30t-93.5 79.5t-51 114t-15.5 132.5v359h90v-359q0 -53 10.5 -102.5t35 -87.5t65 -61.5t101.5 -23.5zM377 873q-23 0 -40 -20.5 t-17 -47.5h-51q0 24 8.5 44t23 35t34 23.5t42.5 8.5t42.5 -8.5t34 -23.5t23 -35t8.5 -44h-50q-3 29 -19.5 48.5t-38.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uinvertedbreve",
    unicode: "\u0217",
    horizAdvX: 601,
    d: "M232 -10q-82 0 -124 55t-42 164v313h88v-296q0 -160 111 -160q54 0 101.5 34.5t70.5 94.5v327h88v-414q0 -31 28 -32v-76q-15 -2 -23.5 -2.5t-16.5 -0.5q-26 0 -43.5 15.5t-18.5 38.5l-2 61q-35 -59 -92 -90.5t-125 -31.5zM293 687q-23 0 -40 -20.5t-17 -47.5h-51 q0 24 8.5 44t23 35t34 23.5t42.5 8.5t42.5 -8.5t34 -23.5t23 -35t8.5 -44h-50q-3 29 -19.5 48.5t-38.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 609,
    d: "M283 -213l20 81h-25v84h78v-84l-30 -81h-43zM502 561q-12 14 -32 27t-45 23.5t-54.5 17t-61.5 6.5q-83 0 -121.5 -31t-38.5 -85q0 -29 11 -48t34.5 -32.5t58.5 -23.5t83 -21q55 -12 99.5 -27.5t76 -38.5t48 -56t16.5 -81q0 -51 -20 -88.5t-54.5 -62t-81.5 -36t-102 -11.5 q-82 0 -155.5 25.5t-133.5 74.5l43 76q16 -17 41.5 -34t58 -30.5t70 -22t78.5 -8.5q76 0 118 27t42 81q0 30 -13.5 50.5t-39.5 35.5t-64.5 26.5t-87.5 23.5q-54 13 -95 28t-68.5 36t-41.5 51t-14 72q0 51 19 90t53 66t81 40.5t102 13.5q72 0 130 -22t103 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 494,
    d: "M216 -213l20 81h-25v84h78v-84l-30 -81h-43zM254 -10q-63 0 -124 19.5t-105 56.5l38 59q46 -35 92 -52.5t97 -17.5q57 0 90.5 22.5t33.5 63.5q0 19 -9 32.5t-27 23.5t-46 18t-65 17q-47 12 -81 23t-56 26t-32 36t-10 52q0 39 15.5 69.5t42.5 51t63.5 31t78.5 10.5 q59 0 110 -19t86 -50l-40 -53q-33 29 -74 43.5t-84 14.5q-48 0 -81.5 -20.5t-33.5 -65.5q0 -18 6.5 -30t21.5 -21t38.5 -16t56.5 -15q52 -12 90.5 -24.5t64 -29.5t38 -40t12.5 -56q0 -73 -56 -116t-151 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 614,
    d: "M273 -213l20 81h-25v84h78v-84l-30 -81h-43zM597 630h-245v-630h-90v630h-245v80h580v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 352,
    d: "M176 -213l20 81h-25v84h78v-84l-30 -81h-43zM341 26q-8 -4 -21 -9.5t-29.5 -11t-36 -9t-40.5 -3.5q-48 0 -83 26.5t-35 82.5v351h-71v69h71v174h88v-174h117v-69h-117v-324q2 -29 19 -42t40 -13q26 0 47.5 8.5t29.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 230,
    d: "M-3 -186q-35 0 -65.5 10t-54.5 32l41 59q14 -13 32.5 -18t36.5 -5q16 0 31 6.5t27 17.5t19 27t7 34v545h88v-539q0 -37 -13.5 -68t-36 -53.5t-51.5 -35t-61 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "schwa",
    unicode: "\u0259",
    d: "M292 -10q-59 0 -107.5 21.5t-83.5 58.5t-54.5 86t-19.5 104q0 6 0.5 15.5t1.5 14.5h433q-3 39 -18 71t-39 55t-54.5 35.5t-64.5 12.5q-24 0 -47 -6.5t-43 -17.5t-35.5 -27t-23.5 -35l-76 21q13 28 35.5 52.5t52 42t65.5 27.5t76 10q58 0 107 -21.5t84 -59t54.5 -87 t19.5 -105.5q0 -55 -19 -103.5t-53.5 -85t-83 -58t-107.5 -21.5zM293 56q35 0 65 13t52.5 36.5t36.5 56t17 70.5h-352q3 -39 18.5 -71.5t40 -55.5t56 -36t66.5 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophe",
    unicode: "\u02BC",
    horizAdvX: 543,
    d: "M265 609l-57 20l37 63l-3 38h112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 342,
    d: "M38 640l101 90h64l101 -90l-48 -24l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 342,
    d: "M86 730l85 -63l85 63l48 -24l-101 -90h-64l-101 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 403,
    d: "M56 654v58h292v-58h-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 296,
    d: "M148 662q22 0 38.5 19.5t19.5 48.5h50q0 -24 -8.5 -44t-23 -35t-34 -23.5t-42.5 -8.5t-42.5 8.5t-34 23.5t-23 35t-8.5 44h51q0 -27 17 -47.5t40 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 180,
    d: "M50 624v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 252,
    d: "M45 661q0 32 23 50.5t58 18.5q36 0 58.5 -18.5t22.5 -50.5t-22.5 -50.5t-58.5 -18.5q-35 0 -58 18.5t-23 50.5zM126 699q-17 0 -28.5 -10.5t-11.5 -27.5q0 -16 11.5 -27t28.5 -11q16 0 28.5 10.5t12.5 27.5t-12 27.5t-29 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 255,
    d: "M142 -181q-42 8 -63 28.5t-21 48.5q0 30 25.5 60t81.5 62l26 -18q-44 -27 -63 -48.5t-19 -43.5q0 -37 55 -43l-22 -46v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 415,
    d: "M270 627q-23 0 -39.5 6.5t-31 14.5t-28.5 14.5t-30 6.5q-17 0 -26.5 -7t-14.5 -15.5t-6.5 -16.5t-1.5 -9h-52q0 6 4.5 23t15.5 35t30 31.5t49 13.5q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q19 0 30 7t17 16t7.5 16.5t1.5 9.5h52q0 -6 -4.5 -22.5t-16.5 -34.5t-32.5 -32 t-52.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 338,
    d: "M86 609l-46 20l54 101h76zM222 609l-46 20l54 101h76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F",
    unicode: "\u030F",
    horizAdvX: 338,
    d: "M168 730h76l54 -101l-46 -20zM32 730h76l54 -101l-46 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311",
    unicode: "\u0311",
    horizAdvX: 296,
    d: "M148 687q-23 0 -40 -20.5t-17 -47.5h-51q0 24 8.5 44t23 35t34 23.5t42.5 8.5t42.5 -8.5t34 -23.5t23 -35t8.5 -44h-50q-3 29 -19.5 48.5t-38.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 647,
    d: "M624 67v-67h-602v67l265 643h74zM525 80l-201 526l-202 -526h403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03A9",
    unicode: "\u03A9",
    horizAdvX: 760,
    d: "M44 79h179q-78 44 -123.5 118.5t-45.5 167.5q0 69 25 132.5t68.5 111.5t103 77t129.5 29t129.5 -29t103 -77t68.5 -111.5t25 -132.5q0 -93 -45.5 -167.5t-123.5 -118.5h179v-79h-289v79q43 14 78 43.5t59.5 68.5t37.5 84t13 90q0 50 -16.5 98t-47 86t-74 61t-97.5 23 t-97.5 -23t-74 -61t-47 -86t-16.5 -98q0 -45 13 -90t37.5 -84t59.5 -68.5t78 -43.5v-79h-289v79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 607,
    d: "M71 522h88v-296q0 -160 113 -160q26 0 52 9t48.5 25.5t40.5 40.5t30 54v327h88v-414q0 -31 28 -32v-76q-15 -2 -24 -2.5t-17 -0.5q-28 0 -45.5 18.5t-17.5 41.5v55q-12 -24 -32 -46t-44.5 -39t-53 -27t-58.5 -10q-46 0 -74 22.5t-39 54.5v-279h-83v734z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 609,
    d: "M190 442v-442h-85v442h-80v80h541v-80h-110v-307q0 -29 15.5 -45.5t43.5 -16.5q11 0 26 3.5t28 8.5l14 -71q-22 -9 -52 -15t-53 -6q-49 0 -78 29t-29 81v339h-181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0400",
    unicode: "\u0400",
    horizAdvX: 606,
    d: "M569 80v-80h-482v710h473v-80h-383v-230h333v-75h-333v-245h392zM232 917h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0401",
    unicode: "\u0401",
    horizAdvX: 606,
    d: "M218 811v102h74v-102h-74zM380 811v102h74v-102h-74zM569 80v-80h-482v710h473v-80h-383v-230h333v-75h-333v-245h392z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0402",
    unicode: "\u0402",
    horizAdvX: 711,
    d: "M202 630h-185v80h550v-80h-275v-242q34 29 80 45t98 16q101 0 157.5 -60t56.5 -176q0 -108 -51 -165.5t-154 -57.5q-62 0 -119 22l26 77q29 -13 50.5 -18t41.5 -5q57 0 84 36.5t27 111.5q0 80 -31 117.5t-100 37.5q-91 0 -166 -69v-300h-90v630z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0403",
    unicode: "\u0403",
    horizAdvX: 513,
    d: "M314 795l-58 20l58 101h88zM496 630h-319v-630h-90v710h409v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0404",
    unicode: "\u0404",
    horizAdvX: 701,
    d: "M675 159q-18 -40 -47 -70.5t-66.5 -51.5t-83 -32t-95.5 -11q-79 0 -142.5 32t-108 83.5t-68.5 117t-24 133.5q0 64 22 127.5t65.5 114t109 81.5t151.5 31q53 0 96 -11.5t76.5 -32t59 -49t42.5 -62.5l-71 -46q-17 34 -40.5 57t-51 37t-57.5 20t-58 6q-59 0 -103 -19.5 t-75 -52t-48.5 -74.5t-23.5 -87h353v-75h-355q5 -51 25 -96t53 -79.5t77.5 -54.5t99.5 -20q29 0 60 7t59.5 22.5t53 39t40.5 56.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0405",
    unicode: "\u0405",
    horizAdvX: 609,
    d: "M502 561q-12 14 -32 27t-45 23.5t-54.5 17t-61.5 6.5q-83 0 -121.5 -31t-38.5 -85q0 -29 11 -48t34.5 -32.5t58.5 -23.5t83 -21q55 -12 99.5 -27.5t76 -38.5t48 -56t16.5 -81q0 -51 -20 -88.5t-54.5 -62t-81.5 -36t-102 -11.5q-82 0 -155.5 25.5t-133.5 74.5l43 76 q16 -17 41.5 -34t58 -30.5t70 -22t78.5 -8.5q76 0 118 27t42 81q0 30 -13.5 50.5t-39.5 35.5t-64.5 26.5t-87.5 23.5q-54 13 -95 28t-68.5 36t-41.5 51t-14 72q0 51 19 90t53 66t81 40.5t102 13.5q72 0 130 -22t103 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0406",
    unicode: "\u0406",
    horizAdvX: 264,
    d: "M87 0v710h90v-710h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0407",
    unicode: "\u0407",
    horizAdvX: 264,
    d: "M87 0v710h90v-710h-90zM14 811v102h74v-102h-74zM176 811v102h74v-102h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0408",
    unicode: "\u0408",
    horizAdvX: 487,
    d: "M35 106q20 -14 54 -25t77 -11q51 0 81 18t45.5 53.5t20.5 87.5t5 120v361h90v-361q0 -81 -7.5 -147.5t-33 -113.5t-73 -73t-128.5 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0409",
    unicode: "\u0409",
    horizAdvX: 1002,
    d: "M7 80q21 1 40 7.5t35 23.5t30 47.5t26 78.5t21.5 116.5t17.5 162.5l16 194h376v-292h197q43 0 80.5 -13.5t66 -39.5t45 -65.5t16.5 -90.5t-16.5 -90.5t-45 -65.5t-66 -39.5t-80.5 -13.5h-287v630h-202l-10 -118q-12 -138 -30 -236t-47 -161t-69.5 -92.5t-97.5 -29.5z M766 78q57 0 87 35.5t30 95.5t-30 95.5t-87 35.5h-197v-262h197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040A",
    unicode: "\u040A",
    horizAdvX: 1041,
    d: "M87 710h90v-292h341v292h90v-292h197q43 0 80.5 -13.5t66 -39.5t45 -65.5t16.5 -90.5t-16.5 -90.5t-45 -65.5t-66 -39.5t-80.5 -13.5h-287v338h-341v-338h-90v710zM805 78q57 0 87 35.5t30 95.5t-30 95.5t-87 35.5h-197v-262h197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040B",
    unicode: "\u040B",
    horizAdvX: 717,
    d: "M589 239q0 71 -27 100.5t-89 29.5q-53 0 -98.5 -18.5t-82.5 -50.5v-300h-90v630h-185v80h550v-80h-275v-243q35 29 85 45.5t106 16.5q89 0 141.5 -46.5t52.5 -143.5v-259h-88v239z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040C",
    unicode: "\u040C",
    horizAdvX: 623,
    d: "M177 401h90l233 309h103l-253 -343l276 -367h-103l-246 321h-100v-321h-90v710h90v-309zM344 795l-58 20l58 101h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040D",
    unicode: "\u040D",
    horizAdvX: 724,
    d: "M177 137l411 573h74v-710h-90v563l-404 -563h-81v710h90v-573zM262 917h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040E",
    unicode: "\u040E",
    horizAdvX: 623,
    d: "M170 -7q-19 0 -42 3.5t-39 10.5v77q17 -7 37.5 -10t36.5 -3q18 0 33.5 4.5t29 16.5t26 32t25.5 51l-258 535h95l205 -437l194 437h95l-250 -540q-22 -48 -43 -81.5t-43 -55t-47 -31t-55 -9.5zM319 799q-67 0 -108.5 30.5t-43.5 86.5h53q0 -27 29 -47.5t71 -20.5 q40 0 67 19.5t32 48.5h52q-2 -56 -43.5 -86.5t-108.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040F",
    unicode: "\u040F",
    horizAdvX: 697,
    d: "M88 710h90v-630h341v630h90v-710h-216v-185h-90v185h-215v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0410",
    unicode: "\u0410",
    horizAdvX: 677,
    d: "M301 710h76l290 -710h-96l-84 208h-298l-83 -208h-96zM467 278l-128 328l-132 -328h260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0411",
    unicode: "\u0411",
    horizAdvX: 658,
    d: "M87 710h499v-80h-409v-212h237q43 0 80.5 -13.5t66 -39.5t45 -65.5t16.5 -90.5t-16.5 -90.5t-44.5 -65.5t-66 -39.5t-81 -13.5h-327v710zM414 78q57 0 87 35.5t30 95.5t-29.5 95.5t-87.5 35.5h-237v-262h237z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0412",
    unicode: "\u0412",
    horizAdvX: 673,
    d: "M612 183q0 -41 -16.5 -75t-45 -58t-66 -37t-80.5 -13h-337v710h353q37 0 67 -16t51 -41.5t32.5 -58t11.5 -65.5q0 -53 -26.5 -98t-75.5 -67q61 -18 96.5 -66.5t35.5 -114.5zM521 199q0 24 -8.5 46.5t-23 39.5t-34.5 27t-44 10h-254v-244h247q25 0 46 10t37 26.5t25 38.5 t9 46zM157 632v-237h226q24 0 44 9.5t34.5 25.5t23 37.5t8.5 45.5q0 25 -8 47t-21.5 38t-33 25t-41.5 9h-232z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0413",
    horizAdvX: 513,
    d: "M496 630h-319v-630h-90v710h409v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0414",
    unicode: "\u0414",
    horizAdvX: 716,
    d: "M18 80h9q21 1 40 7.5t35 23.5t30 47.5t26 78.5t21.5 116.5t17.5 162.5l16 194h376v-630h110v-266h-80v186h-521v-186h-80v266zM499 80v550h-202l-10 -118q-15 -179 -42.5 -282.5t-73.5 -149.5h328z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0415",
    unicode: "\u0415",
    horizAdvX: 606,
    d: "M569 80v-80h-482v710h473v-80h-383v-230h333v-75h-333v-245h392z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0416",
    unicode: "\u0416",
    horizAdvX: 972,
    d: "M238 367l-213 343h103l188 -309h120v309h100v-309h120l188 309h103l-213 -343l236 -367h-103l-197 321h-134v-321h-100v321h-134l-197 -321h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0417",
    unicode: "\u0417",
    horizAdvX: 519,
    d: "M42 626q34 45 80.5 67t115.5 22q99 0 153.5 -43t54.5 -125q0 -61 -30 -104.5t-84 -56.5q66 -8 106 -53t40 -117q0 -48 -18.5 -88.5t-51.5 -70t-78 -46t-98 -16.5q-71 0 -126 29t-84 82l72 53q23 -38 57 -60t85 -22q33 0 60.5 10t47.5 27.5t31.5 42t11.5 53.5 q0 63 -50.5 99.5t-140.5 36.5h-54v80h54q75 0 118 30t43 84q0 49 -33.5 73t-84.5 24q-45 0 -81 -17.5t-56 -49.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0418",
    unicode: "\u0418",
    horizAdvX: 749,
    d: "M177 137l411 573h74v-710h-90v563l-404 -563h-81v710h90v-573z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0419",
    unicode: "\u0419",
    horizAdvX: 749,
    d: "M543 916q-2 -56 -43.5 -86.5t-108.5 -30.5t-108.5 30.5t-43.5 86.5h53q0 -27 29 -47.5t71 -20.5q40 0 67 19.5t32 48.5h52zM177 137l411 573h74v-710h-90v563l-404 -563h-81v710h90v-573z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041A",
    unicode: "\u041A",
    horizAdvX: 623,
    d: "M177 401h90l233 309h103l-253 -343l276 -367h-103l-246 321h-100v-321h-90v710h90v-309z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041B",
    unicode: "\u041B",
    horizAdvX: 657,
    d: "M267 512q-12 -138 -30 -236t-47 -161t-69.5 -92.5t-97.5 -29.5l-16 87q21 1 40 7.5t35 23.5t30 47.5t26 78.5t21.5 116.5t17.5 162.5l16 194h376v-710h-90v630h-202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041C",
    unicode: "\u041C",
    horizAdvX: 878,
    d: "M701 0v549l-236 -421h-51l-237 421v-549h-90v710h95l257 -461l258 461h94v-710h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041D",
    unicode: "\u041D",
    horizAdvX: 745,
    d: "M658 710v-710h-90v323h-391v-323h-90v710h90v-307h391v307h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041E",
    unicode: "\u041E",
    horizAdvX: 748,
    d: "M374 -5q-75 0 -136.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q75 0 136 -31.5t105 -82.5t68 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-106 -79t-133.5 -29.5zM131 355q0 -54 17.5 -104.5t49.5 -89.5t77 -62t100 -23 q57 0 102 24.5t76.5 64t48 89.5t16.5 101q0 54 -17.5 104.5t-50 89t-77 61.5t-98.5 23q-57 0 -102 -24t-76.5 -63t-48.5 -89t-17 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u041F",
    horizAdvX: 740,
    d: "M87 710h566v-710h-90v630h-386v-630h-90v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0420",
    unicode: "\u0420",
    horizAdvX: 625,
    d: "M87 0v710h296q47 0 86.5 -19.5t68 -52t44.5 -73t16 -82.5q0 -44 -15 -85t-42.5 -73t-66 -51t-85.5 -19h-212v-255h-90zM177 335h207q28 0 50.5 11.5t38.5 32t25 47.5t9 57q0 31 -10.5 58t-28 47t-41 31t-49.5 11h-201v-295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0421",
    unicode: "\u0421",
    horizAdvX: 681,
    d: "M39 360q0 64 22.5 127.5t66 114t106.5 81.5t143 31q95 0 163 -43t101 -112l-71 -46q-16 34 -38.5 57t-49 37t-54.5 20t-55 6q-59 0 -104.5 -24.5t-76.5 -64t-46.5 -89t-15.5 -99.5q0 -56 18.5 -106.5t51.5 -89.5t78 -62t98 -23q28 0 57.5 7t56.5 22.5t50.5 39t38.5 56.5 l75 -41q-17 -40 -47.5 -70.5t-69 -51.5t-81.5 -32t-84 -11q-73 0 -134 32t-105.5 83.5t-69 117t-24.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0422",
    unicode: "\u0422",
    horizAdvX: 614,
    d: "M597 630h-245v-630h-90v630h-245v80h580v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0423",
    unicode: "\u0423",
    horizAdvX: 623,
    d: "M170 -7q-19 0 -42 3.5t-39 10.5v77q17 -7 37.5 -10t37.5 -3q34 0 60.5 21t52.5 83l-258 535h95l205 -437l194 437h95l-250 -540q-22 -48 -43 -81.5t-43 -55t-47 -31t-55 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u0424",
    horizAdvX: 746,
    d: "M332 55q-143 11 -220.5 91t-77.5 215q0 137 78 217.5t220 92.5v89h90v-89q137 -12 212.5 -93t75.5 -217q0 -135 -75.5 -215t-212.5 -91v-95h-90v95zM422 136q97 11 147 68.5t50 160.5q0 101 -50 157t-147 66v-452zM332 588q-207 -20 -207 -223q0 -104 52.5 -161 t154.5 -68v452z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0425",
    unicode: "\u0425",
    horizAdvX: 637,
    d: "M103 710l216 -296l216 296h99l-267 -360l259 -350h-99l-208 286l-208 -286h-100l259 350l-267 360h100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0426",
    unicode: "\u0426",
    horizAdvX: 736,
    d: "M639 0h-551v710h90v-630h341v630h90v-630h110v-266h-80v186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0427",
    unicode: "\u0427",
    horizAdvX: 615,
    d: "M437 710h91v-710h-91v300q-17 -6 -34 -11t-37 -8.5t-44.5 -5t-55.5 -1.5q-62 0 -105 18.5t-69 51.5t-37.5 77.5t-11.5 96.5v192h91v-175q0 -50 7 -84.5t24.5 -55.5t46 -30.5t71.5 -9.5q57 0 95.5 10.5t58.5 26.5v318z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0428",
    unicode: "\u0428",
    horizAdvX: 946,
    d: "M859 710v-710h-772v710h90v-630h251v630h90v-630h251v630h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0429",
    unicode: "\u0429",
    horizAdvX: 987,
    d: "M890 0h-802v710h90v-630h251v630h90v-630h251v630h90v-630h109v-266h-79v186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042A",
    unicode: "\u042A",
    horizAdvX: 750,
    d: "M17 710h315v-262h152q50 0 93.5 -14.5t75.5 -42.5t50.5 -70t18.5 -97t-19 -97t-51.5 -70t-76 -42.5t-91.5 -14.5h-242v630h-225v80zM332 78h152q74 0 110.5 39.5t36.5 106.5t-38 106.5t-109 39.5h-152v-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042B",
    unicode: "\u042B",
    horizAdvX: 827,
    d: "M87 710h90v-262h152q50 0 93.5 -14.5t75.5 -42.5t50.5 -70t18.5 -97t-19 -97t-51.5 -70t-76 -42.5t-91.5 -14.5h-242v710zM177 78h152q74 0 110.5 39.5t36.5 106.5t-38 106.5t-109 39.5h-152v-292zM649 0v709h90v-709h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042C",
    unicode: "\u042C",
    horizAdvX: 595,
    d: "M87 710h90v-262h152q50 0 93.5 -14.5t75.5 -42.5t50.5 -70t18.5 -97t-19 -97t-51.5 -70t-76 -42.5t-91.5 -14.5h-242v710zM177 78h152q74 0 110.5 39.5t36.5 106.5t-38 106.5t-109 39.5h-152v-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042D",
    unicode: "\u042D",
    horizAdvX: 701,
    d: "M318 -6q-50 0 -95.5 11t-83 32t-66.5 51.5t-47 70.5l75 41q16 -33 40.5 -56.5t53 -39t59.5 -22.5t60 -7q55 0 99.5 20t77.5 54.5t52.5 79.5t24.5 96h-354v75h353q-6 45 -24 87t-48.5 74.5t-75 52t-102.5 19.5q-29 0 -58.5 -6t-57 -20t-51.5 -37t-40 -57l-71 46 q34 68 101 111.5t173 43.5q86 0 151.5 -31t109 -81.5t65.5 -114t22 -127.5q0 -68 -24 -133.5t-68.5 -117t-108 -83.5t-142.5 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042E",
    unicode: "\u042E",
    horizAdvX: 986,
    d: "M619 -5q-66 0 -121 23.5t-96 66t-66 102t-30 131.5h-128v-318h-90v710h90v-312h129q6 73 32 131.5t68 99.5t96.5 63.5t117.5 22.5q72 0 131.5 -27t102 -75.5t66 -114.5t23.5 -144q0 -82 -24.5 -148.5t-68 -113t-103 -72t-129.5 -25.5zM396 355q0 -66 16 -117.5 t45.5 -87.5t70.5 -55t92 -19q54 0 97.5 20t73.5 57t46 88t16 114q0 66 -17 117.5t-48 87t-73.5 54.5t-94.5 19t-93.5 -20t-70.5 -56t-44.5 -87.5t-15.5 -114.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042F",
    unicode: "\u042F",
    horizAdvX: 637,
    d: "M460 0v275h-164l-163 -275h-105l176 288q-31 11 -57.5 31.5t-45.5 47.5t-29.5 59t-10.5 67q0 40 16 79t44.5 69.5t68 49.5t86.5 19h274v-710h-90zM460 630h-179q-26 0 -49.5 -11t-41 -29.5t-28 -43.5t-10.5 -53q0 -27 9 -52t25 -44t38.5 -30.5t50.5 -11.5h185v275z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0430",
    unicode: "\u0430",
    horizAdvX: 555,
    d: "M205 -10q-37 0 -69 12.5t-55.5 34.5t-37 51.5t-13.5 64.5q0 36 16 65.5t45.5 50.5t70 33t88.5 12q38 0 77 -7t69 -19v42q0 64 -36 100.5t-102 36.5q-79 0 -166 -61l-29 57q101 68 203 68q103 0 160.5 -55t57.5 -155v-213q0 -31 28 -32v-76q-14 -2 -23 -3t-19 -1 q-26 0 -41.5 15.5t-18.5 37.5l-2 37q-35 -47 -88.5 -71.5t-114.5 -24.5zM228 56q47 0 87.5 17.5t61.5 46.5q19 19 19 39v77q-64 25 -133 25q-66 0 -107.5 -28t-41.5 -73q0 -22 8.5 -41t24 -33t36.5 -22t45 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0431",
    unicode: "\u0431",
    horizAdvX: 590,
    d: "M324 626q-78 -20 -123 -69t-59 -141q35 42 80 63.5t97 21.5q50 0 92.5 -19.5t73.5 -54.5t48.5 -82.5t17.5 -102.5q0 -56 -18.5 -102.5t-51.5 -79.5t-79.5 -51.5t-103.5 -18.5q-120 0 -182 84t-62 245q0 163 67.5 256.5t196.5 125.5l165 40l16 -72zM144 248q0 -40 12 -74 t33.5 -59t51 -39t64.5 -14q34 0 63 13t49.5 36.5t32 56.5t11.5 72q0 40 -12 73.5t-33 57.5t-51 37t-66 13q-35 0 -63.5 -12.5t-48.5 -35.5t-31.5 -54.5t-11.5 -70.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0432",
    unicode: "\u0432",
    horizAdvX: 527,
    d: "M338 522q28 0 52 -9.5t42 -26.5t28 -40.5t10 -51.5q0 -17 -4 -34.5t-12.5 -34t-22.5 -30.5t-34 -22q43 -12 68 -44.5t25 -81.5q0 -33 -12 -60.5t-33.5 -46.5t-51 -29.5t-65.5 -10.5h-253v522h263zM303 299q38 0 59.5 21.5t21.5 59.5q0 32 -17 54.5t-57 22.5h-149v-158 h142zM318 65q40 0 63.5 25.5t23.5 60.5q0 33 -22 58t-63 25h-159v-169h157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0433",
    unicode: "\u0433",
    horizAdvX: 424,
    d: "M405 456h-246v-456h-86v522h332v-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0434",
    unicode: "\u0434",
    horizAdvX: 592,
    d: "M18 76h30q24 6 40.5 22t28.5 49.5t21 89t18 139.5l16 146h325v-446h62v-240h-76v164h-392v-164h-73v240zM411 76v377h-158l-15 -113q-14 -108 -31.5 -170.5t-42.5 -93.5h247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0435",
    unicode: "\u0435",
    d: "M302 -10q-59 0 -108 21.5t-84 58.5t-54.5 86.5t-19.5 104.5t19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21 q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0436",
    unicode: "\u0436",
    horizAdvX: 761,
    d: "M124 522l130 -232h83v232h88v-232h83l130 232h97l-152 -254l167 -268h-98l-129 224h-98v-224h-88v224h-98l-129 -224h-98l166 268l-152 254h98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0437",
    unicode: "\u0437",
    horizAdvX: 410,
    d: "M42 468q58 63 149 63q69 0 111 -34.5t42 -92.5q0 -46 -24.5 -77.5t-66.5 -36.5q57 -7 89.5 -43.5t32.5 -93.5q0 -36 -13.5 -66t-38.5 -51.5t-59.5 -33.5t-76.5 -12q-100 0 -161 76l47 61q23 -32 51 -46.5t66 -14.5q48 0 74 22.5t26 64.5q0 48 -34 73.5t-99 25.5h-35v67 h35q49 0 77.5 21t28.5 57q0 30 -21 47.5t-57 17.5q-52 0 -100 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0438",
    unicode: "\u0438",
    horizAdvX: 588,
    d: "M159 124l284 398h71v-522h-86v390l-279 -390h-76v522h86v-398z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0439",
    unicode: "\u0439",
    horizAdvX: 587,
    d: "M458 730q-4 -56 -45 -83.5t-108 -27.5t-108 27.5t-45 83.5h53q2 -41 28.5 -54.5t71.5 -13.5t71.5 13.5t28.5 54.5h53zM159 124l284 398h71v-522h-86v390l-279 -390h-76v522h86v-398z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u043A",
    horizAdvX: 500,
    d: "M384 522h98l-205 -254l219 -268h-97l-179 229h-61v-229h-86v522h86v-227h51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043B",
    unicode: "\u043B",
    horizAdvX: 552,
    d: "M4 72q32 3 53.5 15.5t36 45t24.5 91t20 152.5l16 146h325v-522h-86v453h-158l-15 -113q-14 -102 -29.5 -167.5t-38.5 -104t-55 -54.5t-78 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043C",
    unicode: "\u043C",
    horizAdvX: 675,
    d: "M338 191l177 331h87v-522h-86v368l-153 -283h-50l-154 283v-368h-86v522h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043D",
    unicode: "\u043D",
    horizAdvX: 582,
    d: "M159 305h264v217h86v-522h-86v232h-264v-232h-86v522h86v-217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043E",
    unicode: "\u043E",
    horizAdvX: 599,
    d: "M299 -10q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59t54 -86t19.5 -104q0 -54 -19 -103t-54 -86t-83.5 -59t-107.5 -22zM126 259q0 -41 13.5 -76t37 -61t55 -41t67.5 -15t67.5 15t55.5 41.5t37.5 62t13.5 76.5 q0 40 -13.5 75.5t-37.5 62t-55.5 41.5t-67.5 15t-67.5 -15.5t-55 -42t-37 -62t-13.5 -76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043F",
    unicode: "\u043F",
    horizAdvX: 567,
    d: "M494 0h-86v446h-249v-446h-86v522h421v-522z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0440",
    unicode: "\u0440",
    horizAdvX: 625,
    d: "M354 -10q-65 0 -114.5 32t-78.5 81v-316h-88v735h78v-98q31 48 80.5 77.5t109.5 29.5q54 0 99 -22t78 -59.5t51.5 -86.5t18.5 -102q0 -56 -17 -105.5t-48 -86t-74 -58t-95 -21.5zM327 66q39 0 70.5 16.5t54 44t34.5 62.5t12 72q0 39 -14 74.5t-38 62t-56.5 42t-70.5 15.5 q-24 0 -49.5 -9.5t-48 -25t-39 -37t-21.5 -45.5v-149q11 -26 28 -48.5t39 -39t47 -26t52 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0441",
    unicode: "\u0441",
    horizAdvX: 554,
    d: "M36 262q0 55 19 104t54 85.5t83.5 58t108.5 21.5q78 0 134.5 -34.5t85.5 -92.5l-86 -27q-20 37 -56 57.5t-80 20.5q-36 0 -68 -14.5t-55 -40.5t-36.5 -61t-13.5 -77q0 -41 14 -77t37.5 -62.5t55 -41.5t67.5 -15q23 0 45.5 6.5t41 17.5t32.5 25.5t20 31.5l86 -26 q-12 -29 -33.5 -53t-50.5 -41t-64.5 -27t-74.5 -10q-59 0 -108 22t-84 59t-54.5 86.5t-19.5 104.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0442",
    unicode: "\u0442",
    horizAdvX: 478,
    d: "M282 0h-86v446h-175v76h436v-76h-175v-446z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0443",
    unicode: "\u0443",
    horizAdvX: 545,
    d: "M70 -119q17 -15 33.5 -21t34.5 -6q26 0 49 32t46 114l-221 522h91l178 -443l162 443h84l-228 -594q-17 -44 -33.5 -73t-35 -46.5t-39.5 -24.5t-46 -7q-26 0 -43.5 6t-31.5 21v77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u0444",
    horizAdvX: 678,
    d: "M385 528q61 -6 108.5 -28.5t80.5 -58t50.5 -82t17.5 -101.5t-17.5 -101t-50.5 -80.5t-80.5 -56t-108.5 -27.5v-206h-88v205q-62 6 -110.5 27.5t-82 56t-51 81t-17.5 101.5q0 56 17.5 103t51 82.5t82 57.5t110.5 28v201h88v-202zM297 446q-170 -18 -170 -184 q0 -84 43 -131.5t127 -57.5v373zM385 73q81 11 123.5 58.5t42.5 130.5q0 81 -42 127.5t-124 56.5v-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0445",
    unicode: "\u0445",
    horizAdvX: 513,
    d: "M105 522l143 -192l8 -16l9 16l142 192h93l-195 -262l196 -260h-93l-143 191l-9 15l-8 -15l-143 -191h-93l196 260l-195 262h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0446",
    unicode: "\u0446",
    horizAdvX: 577,
    d: "M73 522h86v-446h225v446h86v-446h95v-240h-76v164h-416v522z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0447",
    unicode: "\u0447",
    horizAdvX: 483,
    d: "M410 0h-87v208q-11 -3 -21.5 -6t-24 -4.5t-31 -2.5t-41.5 -1q-47 0 -79 15t-51 40.5t-27 58t-8 68.5v146h87v-129q0 -69 26 -95.5t71 -26.5q42 0 65 7t34 18v226h87v-522z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0448",
    unicode: "\u0448",
    horizAdvX: 741,
    d: "M73 0v522h86v-446h168v446h86v-446h169v446h86v-522h-595z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0449",
    unicode: "\u0449",
    horizAdvX: 775,
    d: "M73 522h86v-446h168v446h86v-446h169v446h86v-446h95v-240h-76v164h-614v522z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044A",
    unicode: "\u044A",
    horizAdvX: 580,
    d: "M272 342h99q34 0 66.5 -10.5t58 -32t41.5 -54t16 -76.5t-16 -76t-41.5 -52.5t-58.5 -30.5t-67 -10h-184v446h-165v76h251v-180zM370 74q43 0 69.5 23.5t26.5 71.5q0 49 -28.5 74t-66.5 25h-99v-194h98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044B",
    unicode: "\u044B",
    horizAdvX: 650,
    d: "M73 522h86v-180h99q34 0 66.5 -10.5t58 -32t41.5 -54t16 -76.5t-16 -76t-41.5 -52.5t-58.5 -30.5t-67 -10h-184v522zM491 522h86v-522h-86v522zM257 74q43 0 69.5 23.5t26.5 71.5q0 49 -28.5 74t-66.5 25h-99v-194h98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044C",
    unicode: "\u044C",
    horizAdvX: 467,
    d: "M73 522h86v-180h99q34 0 66.5 -10.5t58 -32t41.5 -54t16 -76.5t-16 -76t-41.5 -52.5t-58.5 -30.5t-67 -10h-184v522zM257 74q43 0 69.5 23.5t26.5 71.5q0 49 -28.5 74t-66.5 25h-99v-194h98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044D",
    unicode: "\u044D",
    horizAdvX: 541,
    d: "M242 -9q-75 0 -133.5 33t-83.5 94l67 31q11 -22 28 -39t37.5 -28t43.5 -17t45 -6q33 0 62.5 12t53 34.5t39 54t19.5 70.5h-260v70h258q-6 34 -20.5 64t-37 52t-52 34.5t-65.5 12.5q-20 0 -41.5 -4.5t-41.5 -14.5t-37.5 -26t-30.5 -39l-58 35q26 49 78 83.5t130 34.5 q61 0 110 -22.5t83 -60.5t52 -87t18 -101t-18 -101t-51.5 -86.5t-82.5 -60t-111 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044E",
    unicode: "\u044E",
    horizAdvX: 744,
    d: "M230 301q6 53 25.5 96t50.5 73t71.5 46.5t87.5 16.5q54 0 98.5 -20.5t76 -57.5t49 -87t17.5 -108q0 -62 -18.5 -112t-50.5 -85t-77 -54t-97 -19q-49 0 -89.5 16.5t-71 47.5t-49.5 74.5t-24 96.5h-71v-225h-86v522h86v-221h72zM315 261q0 -94 40 -144t109 -50 q75 0 115 51.5t40 142.5q0 92 -42 143t-113 51q-72 0 -110.5 -53t-38.5 -141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044F",
    unicode: "\u044F",
    horizAdvX: 498,
    d: "M155 204q-44 16 -73 53t-29 97q0 37 13.5 68t37.5 53.5t56 34.5t70 12h195v-522h-86v189h-99l-114 -189h-100zM339 265v181h-104q-17 0 -34 -6t-30.5 -18t-22 -29t-8.5 -39q0 -42 27 -65.5t63 -23.5h109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0450",
    unicode: "\u0450",
    d: "M302 -10q-59 0 -108 21.5t-84 58.5t-54.5 86.5t-19.5 104.5t19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21 q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354zM195 730h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0451",
    unicode: "\u0451",
    d: "M181 624v102h74v-102h-74zM343 624v102h74v-102h-74zM302 -10q-59 0 -108 21.5t-84 58.5t-54.5 86.5t-19.5 104.5t19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13 q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0452",
    unicode: "\u0452",
    horizAdvX: 594,
    d: "M526 -17q0 -36 -12.5 -67t-35 -53.5t-53 -35.5t-65.5 -13q-33 0 -63.5 11t-52.5 31l41 59q11 -11 28.5 -17t36.5 -6q37 0 62.5 24.5t25.5 60.5v282q0 79 -28 119.5t-80 40.5q-30 0 -57 -12.5t-49 -34.5t-38.5 -51t-24.5 -63v-258h-88v588h-73v64h73v78h88v-78h226v-64 h-226v-225q25 64 78.5 99.5t122.5 35.5q81 0 122.5 -55.5t41.5 -163.5v-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0453",
    unicode: "\u0453",
    horizAdvX: 426,
    d: "M241 609l-58 20l58 101h88zM405 456h-246v-456h-86v522h332v-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0454",
    unicode: "\u0454",
    horizAdvX: 542,
    d: "M299 -9q-62 0 -111 22.5t-83 60t-51.5 86.5t-17.5 101t18 101t52 87t82.5 60.5t110.5 22.5q78 0 130 -34.5t78 -83.5l-58 -35q-13 23 -30.5 39t-37.5 26t-41.5 14.5t-41.5 4.5q-36 0 -65.5 -12.5t-52 -34.5t-37.5 -52t-21 -64h259v-70h-261q4 -39 20 -70.5t39 -54 t53 -34.5t63 -12q22 0 45 6t43.5 17t37.5 28t28 39l67 -31q-25 -61 -83.5 -94t-133.5 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0455",
    unicode: "\u0455",
    horizAdvX: 494,
    d: "M254 -10q-63 0 -124 19.5t-105 56.5l38 59q46 -35 92 -52.5t97 -17.5q57 0 90.5 22.5t33.5 63.5q0 19 -9 32.5t-27 23.5t-46 18t-65 17q-47 12 -81 23t-56 26t-32 36t-10 52q0 39 15.5 69.5t42.5 51t63.5 31t78.5 10.5q59 0 110 -19t86 -50l-40 -53q-33 29 -74 43.5 t-84 14.5q-48 0 -81.5 -20.5t-33.5 -65.5q0 -18 6.5 -30t21.5 -21t38.5 -16t56.5 -15q52 -12 90.5 -24.5t64 -29.5t38 -40t12.5 -56q0 -73 -56 -116t-151 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0456",
    unicode: "\u0456",
    horizAdvX: 234,
    d: "M73 0v522h88v-522h-88zM73 620v110h88v-110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0457",
    unicode: "\u0457",
    horizAdvX: 234,
    d: "M-1 624v102h74v-102h-74zM161 624v102h74v-102h-74zM73 0v522h88v-522h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0458",
    unicode: "\u0458",
    horizAdvX: 240,
    d: "M5 -186q-35 0 -65.5 10t-54.5 32l41 59q14 -13 32.5 -18t36.5 -5q16 0 31 6.5t27 17.5t19 27t7 34v545h88v-539q0 -37 -13.5 -68t-36 -53.5t-51.5 -35t-61 -12.5zM79 620v110h88v-110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0459",
    unicode: "\u0459",
    horizAdvX: 808,
    d: "M4 72q32 3 53.5 15.5t36 45t24.5 91t20 152.5l16 146h325v-200h145q28 0 55.5 -10t49 -30.5t34.5 -51t13 -71.5t-13 -71t-35 -49.5t-49.5 -29t-55.5 -9.5h-230v453h-158l-15 -113q-14 -102 -29.5 -167.5t-38.5 -104t-55 -54.5t-78 -19zM623 74q29 0 47.5 21.5t18.5 63.5 q0 44 -19.5 66.5t-45.5 22.5h-145v-174h144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045A",
    unicode: "\u045A",
    horizAdvX: 800,
    d: "M73 522h86v-200h232v200h86v-200h139q28 0 55.5 -10t49 -30.5t34.5 -51t13 -71.5t-13 -71t-35 -49.5t-49.5 -29t-55.5 -9.5h-224v246h-232v-246h-86v522zM615 74q29 0 47.5 21.5t18.5 63.5q0 44 -19.5 66.5t-45.5 22.5h-139v-174h138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045B",
    unicode: "\u045B",
    horizAdvX: 593,
    d: "M438 259q0 160 -110 160q-29 0 -55.5 -11.5t-48.5 -32t-38 -49.5t-25 -64v-262h-88v588h-74v64h74v78h88v-78h226v-64h-226v-221q23 61 76.5 96t123.5 35q82 0 123.5 -55t41.5 -164v-279h-88v259z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045C",
    unicode: "\u045C",
    horizAdvX: 500,
    d: "M384 522h98l-205 -254l219 -268h-97l-179 229h-61v-229h-86v522h86v-227h51zM274 609l-58 20l58 101h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045D",
    unicode: "\u045D",
    horizAdvX: 564,
    d: "M159 124l284 398h71v-522h-86v390l-279 -390h-76v522h86v-398zM170 730h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045E",
    unicode: "\u045E",
    horizAdvX: 545,
    d: "M280 591q-48 0 -77.5 26.5t-29.5 64.5h47q0 -19 18 -35.5t42 -16.5q23 0 39.5 15.5t21.5 36.5h46q0 -38 -30 -64.5t-77 -26.5zM93 -140q17 -5 28 -6t22 -1q9 0 18 2.5t19 17t23 44t30 83.5l-221 522h91l178 -443l162 443h84l-256 -659q-17 -45 -46.5 -65.5t-77.5 -20.5 q-25 0 -54 7v76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045F",
    unicode: "\u045F",
    horizAdvX: 543,
    d: "M228 0h-155v523h86v-447h225v447h86v-523h-156v-164h-86v164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0490",
    unicode: "\u0490",
    horizAdvX: 514,
    d: "M88 710h332l7 164h70v-244h-319v-630h-90v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0491",
    unicode: "\u0491",
    horizAdvX: 425,
    d: "M73 522h267l7 164h58v-233h-246v-453h-86v522z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B0",
    unicode: "\u04B0",
    horizAdvX: 614,
    d: "M501 231v-60h-149v-171h-90v171h-147v60h147v30l-268 449h100l215 -370l215 370h96l-268 -446v-33h149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B1",
    unicode: "\u04B1",
    horizAdvX: 542,
    d: "M224 0h-147v60h147v4l-223 458h100l170 -379l174 379h96l-227 -458v-4h149v-60h-149v-213h-90v213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ddotbelow",
    unicode: "\u1E0C",
    horizAdvX: 716,
    d: "M85 0v710h246q85 0 149.5 -28t107.5 -76t64.5 -112.5t21.5 -137.5q0 -81 -24 -146.5t-69 -112t-108.5 -72t-141.5 -25.5h-246zM583 356q0 60 -16.5 110.5t-49 86.5t-79.5 56.5t-107 20.5h-156v-550h156q61 0 108.5 21t79 58t48 87.5t16.5 109.5zM298 -182v106h80v-106 h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ddotbelow",
    unicode: "\u1E0D",
    horizAdvX: 629,
    d: "M286 -10q-54 0 -100 22t-79 59t-51.5 86t-18.5 103q0 55 17.5 104.5t49 86.5t75 58.5t95.5 21.5q63 0 112.5 -33t78.5 -80v312h88v-622q0 -31 28 -32v-76q-14 -2 -22.5 -3t-16.5 -1q-26 0 -45.5 17.5t-19.5 40.5v44q-31 -51 -82.5 -79.5t-108.5 -28.5zM307 66 q24 0 49.5 9t48 25t39 37.5t21.5 45.5v150q-9 25 -27 47.5t-40.5 39t-48 26t-50.5 9.5q-39 0 -70.5 -16.5t-54 -44t-34.5 -63t-12 -72.5q0 -39 14 -74.5t38 -61.5t56.5 -41.5t70.5 -15.5zM260 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hdotbelow",
    unicode: "\u1E24",
    horizAdvX: 741,
    d: "M656 710v-710h-90v323h-391v-323h-90v710h90v-307h391v307h90zM330 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hdotbelow",
    unicode: "\u1E25",
    horizAdvX: 590,
    d: "M524 0h-88v292q0 81 -28 120.5t-82 39.5q-26 0 -52 -10.5t-48.5 -28.5t-40 -43t-26.5 -55v-315h-88v730h88v-320q31 57 84 89t116 32q46 0 78 -17t51 -46t27.5 -69.5t8.5 -86.5v-312zM261 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ndotaccent",
    unicode: "\u1E44",
    horizAdvX: 770,
    d: "M347 810v106h80v-106h-80zM175 542v-542h-90v710h70l440 -553v552h90v-709h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ndotaccent",
    unicode: "\u1E45",
    horizAdvX: 590,
    d: "M263 624v106h80v-106h-80zM524 0h-88v292q0 84 -25.5 122t-77.5 38q-27 0 -54 -10.5t-51 -28.5t-42 -43t-27 -55v-315h-88v522h80v-112q31 55 89.5 88t127.5 33q45 0 75 -16.5t48 -46t25.5 -69.5t7.5 -87v-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdotbelow",
    unicode: "\u1E5A",
    horizAdvX: 657,
    d: "M85 0v710h304q47 0 86.5 -19.5t68 -52t44.5 -73t16 -82.5q0 -37 -10.5 -71.5t-30 -62.5t-47 -48t-61.5 -29l172 -272h-102l-162 255h-188v-255h-90zM175 335h215q28 0 50.5 12t38.5 32.5t25 47.5t9 56q0 30 -10.5 56.5t-28 47t-41 32t-49.5 11.5h-209v-295zM288 -182v106 h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdotbelow",
    unicode: "\u1E5B",
    horizAdvX: 363,
    d: "M347 445q-66 -2 -116.5 -34t-71.5 -89v-322h-88v522h82v-121q27 54 71 87.5t94 37.5h17t12 -1v-80zM76 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sdotbelow",
    unicode: "\u1E62",
    horizAdvX: 609,
    d: "M502 561q-12 14 -32 27t-45 23.5t-54.5 17t-61.5 6.5q-83 0 -121.5 -31t-38.5 -85q0 -29 11 -48t34.5 -32.5t58.5 -23.5t83 -21q55 -12 99.5 -27.5t76 -38.5t48 -56t16.5 -81q0 -51 -20 -88.5t-54.5 -62t-81.5 -36t-102 -11.5q-82 0 -155.5 25.5t-133.5 74.5l43 76 q16 -17 41.5 -34t58 -30.5t70 -22t78.5 -8.5q76 0 118 27t42 81q0 30 -13.5 50.5t-39.5 35.5t-64.5 26.5t-87.5 23.5q-54 13 -95 28t-68.5 36t-41.5 51t-14 72q0 51 19 90t53 66t81 40.5t102 13.5q72 0 130 -22t103 -59zM264 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sdotbelow",
    unicode: "\u1E63",
    horizAdvX: 494,
    d: "M254 -10q-63 0 -124 19.5t-105 56.5l38 59q46 -35 92 -52.5t97 -17.5q57 0 90.5 22.5t33.5 63.5q0 19 -9 32.5t-27 23.5t-46 18t-65 17q-47 12 -81 23t-56 26t-32 36t-10 52q0 39 15.5 69.5t42.5 51t63.5 31t78.5 10.5q59 0 110 -19t86 -50l-40 -53q-33 29 -74 43.5 t-84 14.5q-48 0 -81.5 -20.5t-33.5 -65.5q0 -18 6.5 -30t21.5 -21t38.5 -16t56.5 -15q52 -12 90.5 -24.5t64 -29.5t38 -40t12.5 -56q0 -73 -56 -116t-151 -43zM205 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tdotbelow",
    unicode: "\u1E6C",
    horizAdvX: 614,
    d: "M597 630h-245v-630h-90v630h-245v80h580v-80zM265 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tdotbelow",
    unicode: "\u1E6D",
    horizAdvX: 352,
    d: "M341 26q-8 -4 -21 -9.5t-29.5 -11t-36 -9t-40.5 -3.5q-48 0 -83 26.5t-35 82.5v351h-71v69h71v174h88v-174h117v-69h-117v-324q2 -29 19 -42t40 -13q26 0 47.5 8.5t29.5 13.5zM168 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1049,
    d: "M345 706h85l94 -247l95 247h85l-123 -309l122 -293l240 606h98l-297 -710h-78l-141 335l-142 -335h-78l-296 710h97l241 -606l121 293zM420 917h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 821,
    d: "M725 522h85l-222 -522h-73l-105 255l-104 -255h-73l-222 522h84l180 -435l88 217l-90 217h73l64 -167l64 167h73l-89 -217l88 -217zM307 730h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1049,
    d: "M539 795l-58 20l58 101h88zM345 706h85l94 -247l95 247h85l-123 -309l122 -293l240 606h98l-297 -710h-78l-141 335l-142 -335h-78l-296 710h97l241 -606l121 293z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 821,
    d: "M425 609l-58 20l58 101h88zM725 522h85l-222 -522h-73l-105 255l-104 -255h-73l-222 522h84l180 -435l88 217l-90 217h73l64 -167l64 167h73l-89 -217l88 -217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1049,
    d: "M406 811v102h74v-102h-74zM568 811v102h74v-102h-74zM345 706h85l94 -247l95 247h85l-123 -309l122 -293l240 606h98l-297 -710h-78l-141 335l-142 -335h-78l-296 710h97l241 -606l121 293z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 821,
    d: "M292 624v102h74v-102h-74zM454 624v102h74v-102h-74zM725 522h85l-222 -522h-73l-105 255l-104 -255h-73l-222 522h84l180 -435l88 217l-90 217h73l64 -167l64 167h73l-89 -217l88 -217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotbelow",
    unicode: "\u1E92",
    horizAdvX: 631,
    d: "M32 70l458 560h-449v80h554v-70l-450 -560h450v-80h-563v70zM286 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotbelow",
    unicode: "\u1E93",
    horizAdvX: 493,
    d: "M30 57l334 401h-325v64h419v-57l-332 -401h333v-64h-429v57zM203 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotbelow",
    unicode: "\u1EB8",
    horizAdvX: 605,
    d: "M567 80v-80h-482v710h473v-80h-383v-230h333v-75h-333v-245h392zM281 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotbelow",
    unicode: "\u1EB9",
    d: "M302 -10q-59 0 -108 21.5t-84 58.5t-54.5 86.5t-19.5 104.5t19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21 q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354zM265 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etilde",
    unicode: "\u1EBC",
    horizAdvX: 605,
    d: "M567 80v-80h-482v710h473v-80h-383v-230h333v-75h-333v-245h392zM396 813q-23 0 -39.5 6.5t-31 14.5t-28.5 14.5t-30 6.5q-17 0 -26.5 -7t-14.5 -15.5t-6.5 -16.5t-1.5 -9h-52q0 6 4.5 23t15.5 35t30 31.5t49 13.5q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q19 0 30 7 t17 16t7.5 16.5t1.5 9.5h52q0 -6 -4.5 -22.5t-16.5 -34.5t-32.5 -32t-52.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etilde",
    unicode: "\u1EBD",
    d: "M302 -10q-59 0 -108 21.5t-84 58.5t-54.5 86.5t-19.5 104.5t19.5 104t55 86t84.5 58.5t108 21.5t107.5 -22t82.5 -58.5t52.5 -85t18.5 -100.5q0 -11 -0.5 -20t-1.5 -14h-433q3 -39 18 -71t39 -55t54.5 -36t64.5 -13q24 0 47 6.5t43 17.5t35.5 27t23.5 36l76 -21 q-13 -29 -35.5 -53t-52 -41.5t-65.5 -27.5t-75 -10zM481 296q-3 37 -18.5 68.5t-39 53.5t-54.5 34.5t-66 12.5t-66 -12.5t-54.5 -35t-38 -53.5t-17.5 -68h354zM361 627q-23 0 -39.5 6.5t-31 14.5t-28.5 14.5t-30 6.5q-17 0 -26.5 -7t-14.5 -15.5t-6.5 -16.5t-1.5 -9h-52 q0 6 4.5 23t15.5 35t30 31.5t49 13.5q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q19 0 30 7t17 16t7.5 16.5t1.5 9.5h52q0 -6 -4.5 -22.5t-16.5 -34.5t-32.5 -32t-52.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotbelow",
    unicode: "\u1ECA",
    horizAdvX: 260,
    d: "M85 0v710h90v-710h-90zM87 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idotbelow",
    unicode: "\u1ECB",
    horizAdvX: 230,
    d: "M71 0v522h88v-522h-88zM71 620v110h88v-110h-88zM74 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odotbelow",
    unicode: "\u1ECC",
    horizAdvX: 748,
    d: "M373 -5q-75 0 -136.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106.5 79.5t133.5 29.5q75 0 136 -31.5t105 -82.5t68 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-106 -79t-133.5 -29.5zM130 355q0 -54 17.5 -104.5t49.5 -89.5t77 -62t100 -23 q57 0 102 24.5t76.5 64t48 89.5t16.5 101q0 54 -17.5 104.5t-50 89t-77 61.5t-98.5 23q-57 0 -102 -24t-76.5 -63t-48.5 -89t-17 -102zM333 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odotbelow",
    unicode: "\u1ECD",
    horizAdvX: 599,
    d: "M299 -10q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59t54 -86t19.5 -104q0 -54 -19 -103t-54 -86t-83.5 -59t-107.5 -22zM126 259q0 -41 13.5 -76t37 -61t55 -41t67.5 -15t67.5 15t55.5 41.5t37.5 62t13.5 76.5 q0 40 -13.5 75.5t-37.5 62t-55.5 41.5t-67.5 15t-67.5 -15.5t-55 -42t-37 -62t-13.5 -76.5zM261 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udotbelow",
    unicode: "\u1EE4",
    horizAdvX: 755,
    d: "M377 76q62 0 103 24t65.5 62.5t34.5 88t10 100.5v359h90v-359q0 -72 -16.5 -136.5t-52.5 -113.5t-93.5 -77.5t-139.5 -28.5q-85 0 -143 30t-93.5 79.5t-51 114t-15.5 132.5v359h90v-359q0 -53 10.5 -102.5t35 -87.5t65 -61.5t101.5 -23.5zM339 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udotbelow",
    unicode: "\u1EE5",
    horizAdvX: 601,
    d: "M232 -10q-82 0 -124 55t-42 164v313h88v-296q0 -160 111 -160q54 0 101.5 34.5t70.5 94.5v327h88v-414q0 -31 28 -32v-76q-15 -2 -23.5 -2.5t-16.5 -0.5q-26 0 -43.5 15.5t-18.5 38.5l-2 61q-35 -59 -92 -90.5t-125 -31.5zM248 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 655,
    d: "M112 710l215 -370l217 370h98l-270 -451v-259h-90v261l-269 449h99zM223 917h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 545,
    d: "M95 -142q13 -2 26 -3t20 -1q12 0 21.5 5.5t19 21.5t21.5 44.5t30 74.5l-221 522h91l178 -443l162 443h84l-254 -659q-14 -35 -46.5 -61.5t-89.5 -26.5q-9 0 -18.5 1t-23.5 4v78zM177 730h87l59 -101l-57 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ytilde",
    unicode: "\u1EF8",
    horizAdvX: 655,
    d: "M112 710l215 -370l217 370h98l-270 -451v-259h-90v261l-269 449h99zM389 813q-23 0 -39.5 6.5t-31 14.5t-28.5 14.5t-30 6.5q-17 0 -26.5 -7t-14.5 -15.5t-6.5 -16.5t-1.5 -9h-52q0 6 4.5 23t15.5 35t30 31.5t49 13.5q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q19 0 30 7 t17 16t7.5 16.5t1.5 9.5h52q0 -6 -4.5 -22.5t-16.5 -34.5t-32.5 -32t-52.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ytilde",
    unicode: "\u1EF9",
    horizAdvX: 545,
    d: "M95 -142q13 -2 26 -3t20 -1q12 0 21.5 5.5t19 21.5t21.5 44.5t30 74.5l-221 522h91l178 -443l162 443h84l-254 -659q-14 -35 -46.5 -61.5t-89.5 -26.5q-9 0 -18.5 1t-23.5 4v78zM343 627q-23 0 -39.5 6.5t-31 14.5t-28.5 14.5t-30 6.5q-17 0 -26.5 -7t-14.5 -15.5 t-6.5 -16.5t-1.5 -9h-52q0 6 4.5 23t15.5 35t30 31.5t49 13.5q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q19 0 30 7t17 16t7.5 16.5t1.5 9.5h52q0 -6 -4.5 -22.5t-16.5 -34.5t-32.5 -32t-52.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "enspace",
    unicode: "\u2002",
    horizAdvX: 586
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emspace",
    unicode: "\u2003",
    horizAdvX: 920
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 582,
    d: "M64 233v80h454v-80h-454z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 911,
    d: "M64 233v80h783v-80h-783z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 207,
    d: "M135 730l-20 -115h30v-114h-83v114l30 115h43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 200,
    d: "M71 501l20 115h-30v114h83v-114l-30 -115h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 211,
    d: "M74 -115l20 115h-30v114h83v-114l-30 -115h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 345,
    d: "M135 730l-20 -115h30v-114h-83v114l30 115h43zM273 730l-20 -115h30v-114h-83v114l30 115h43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 338,
    d: "M71 501l20 115h-30v114h83v-114l-30 -115h-43zM209 501l20 115h-30v114h83v-114l-30 -115h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 349,
    d: "M74 -115l20 115h-30v114h83v-114l-30 -115h-43zM212 -115l20 115h-30v114h83v-114l-30 -115h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 421,
    d: "M169 -130v361h-132v80h132v464h84v-464h131v-80h-131v-361h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 423,
    d: "M170 -130v272h-132v80h132v111h-132v80h132v362h84v-362h131v-80h-131v-111h131v-80h-131v-272h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 356,
    d: "M272 347q0 -20 -7.5 -37t-20 -29.5t-30 -20t-36.5 -7.5t-36 7.5t-30 20t-20.5 29.5t-7.5 37q0 19 7.5 36t20.5 30t30 20.5t36 7.5t36.5 -7.5t30 -20.5t20 -30t7.5 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 503,
    d: "M64 0v112h74v-112h-74zM215 0v112h73v-112h-73zM365 0v112h74v-112h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1096,
    d: "M197 428q-32 0 -60 11.5t-49 31t-33 46.5t-12 57t12 57t33 46.5t49 31t60 11.5t60 -11.5t49 -31t33 -46.5t12 -57t-12 -57t-33 -46.5t-49 -31t-60 -11.5zM197 476q19 0 35.5 8t28.5 21.5t19 31t7 37.5t-7.5 38t-19.5 31.5t-28.5 21t-34.5 7.5q-19 0 -35.5 -8t-28.5 -21.5 t-19 -31.5t-7 -37q0 -20 7.5 -38t19.5 -31.5t28.5 -21t34.5 -7.5zM548 -10q-32 0 -60 11.5t-49 31t-33 46.5t-12 57t12 57t33 46.5t49 31t60 11.5t60 -11.5t49 -31t33 -46.5t12 -57t-12 -57t-33 -46.5t-49 -31t-60 -11.5zM548 38q19 0 35.5 8t28.5 21.5t19 31t7 37.5 t-7.5 38t-19.5 31.5t-28.5 21t-34.5 7.5q-19 0 -35.5 -8t-28.5 -21.5t-19 -31.5t-7 -37q0 -20 7 -38t19.5 -31.5t29 -21t34.5 -7.5zM909 -10q-32 0 -60 11.5t-49 31t-33 46.5t-12 57t12 57t33 46.5t49 31t60 11.5t60 -11.5t49 -31t33 -46.5t12 -57t-12 -57t-33 -46.5 t-49 -31t-60 -11.5zM909 38q19 0 35.5 8t28.5 21.5t19 31t7 37.5t-7.5 38t-19.5 31.5t-28.5 21t-34.5 7.5q-19 0 -35.5 -8t-28.5 -21.5t-19 -31.5t-7 -37q0 -20 7 -38t19.5 -31.5t29 -21t34.5 -7.5zM77 33l280 337l268 345l43 -37l-277 -335l-272 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 354,
    d: "M40 280l253 181v-74l-182 -128l182 -125v-74l-253 174v46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 354,
    d: "M314 234l-253 -174v74l182 125l-182 128v74l253 -181v-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 168,
    d: "M-212 33l280 337l268 345l43 -37l-277 -335l-272 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 467,
    d: "M234 399q-49 0 -86 19t-62 49t-37.5 66.5t-12.5 70.5q0 37 14 73.5t39.5 66t62 48t82.5 18.5q49 0 85.5 -19.5t61.5 -50t37.5 -67t12.5 -69.5q0 -37 -13.5 -73.5t-39 -66t-62 -47.5t-82.5 -18zM93 604q0 -26 9 -53t27 -48.5t44 -35t61 -13.5q36 0 62.5 14.5t44 37 t26 48.5t8.5 50q0 27 -9.5 53.5t-27.5 48.5t-44 35.5t-60 13.5q-36 0 -62.5 -14.5t-44 -37t-26 -49t-8.5 -50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 392,
    d: "M249 405v99h-226v53l243 253h38v-252h59v-54h-59v-99h-55zM80 558h171v180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 380,
    d: "M193 664q33 0 61.5 -9.5t49.5 -26.5t33 -41t12 -52q0 -30 -13 -55t-35.5 -43t-53.5 -28t-66 -10q-51 0 -91.5 20t-60.5 54l35 34q19 -26 50 -40.5t70 -14.5q46 0 77 22.5t31 61.5q0 21 -9 37t-24 26.5t-33.5 16t-37.5 5.5q-29 0 -56.5 -13t-42.5 -34h-50q4 21 12 54.5 t16.5 68.5t15.5 66t10 47h229v-55h-188l-30 -117q16 12 38.5 19t50.5 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 409,
    d: "M378 536q0 -30 -13 -55.5t-36 -44.5t-54 -30t-67 -11q-76 0 -123 47t-47 132q0 118 48.5 177t129.5 59q45 0 82.5 -18t57.5 -51l-33 -37q-14 24 -44 39t-65 15q-56 0 -89.5 -37.5t-34.5 -106.5q15 27 49.5 42.5t72.5 15.5q36 0 66 -10.5t52.5 -29t35 -43.5t12.5 -53z M210 446q24 0 44.5 7t36.5 19.5t25 28.5t9 34t-9 34.5t-25 28.5t-37 19t-45 7t-45 -7t-37 -19t-25 -28t-9 -34t9.5 -34.5t25.5 -29t37 -19.5t45 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 365,
    d: "M271 755h-246v55h334l-239 -405h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 405,
    d: "M368 519q0 -27 -13.5 -49t-36.5 -37.5t-53 -24.5t-64 -9q-36 0 -66 9.5t-52 26t-34.5 39t-12.5 47.5q0 19 7.5 35t20 28.5t29 22t33.5 15.5q-29 11 -51.5 31t-22.5 51q0 24 13.5 44t34.5 33.5t48 21t54 7.5t54 -7.5t48 -21t34.5 -33t13.5 -43.5q0 -30 -21.5 -51 t-53.5 -32q39 -14 65 -39.5t26 -63.5zM312 525q0 17 -10 30.5t-25.5 22.5t-35.5 14t-39 5q-21 0 -41 -5t-35 -14.5t-24.5 -23t-9.5 -29.5q0 -17 10 -30t26 -22t35.5 -14t39.5 -5t39.5 5t35 14.5t25 22.5t9.5 29zM108 700q0 -14 8.5 -24.5t22 -18t30 -11t33.5 -3.5q16 0 33 4 t31 11t22.5 17.5t8.5 24.5q0 13 -8 24t-21.5 18t-30.5 11t-35 4q-38 0 -66 -15.5t-28 -41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 409,
    d: "M31 669q0 30 13 55.5t36 44.5t53.5 30t66.5 11q76 0 123.5 -47t47.5 -132q0 -118 -48.5 -177t-129.5 -59q-45 0 -83 18.5t-58 51.5l34 36q14 -25 43.5 -39.5t65.5 -14.5q55 0 89 37.5t35 106.5q-15 -26 -50 -42t-73 -16q-35 0 -65.5 10.5t-52.5 29t-34.5 43t-12.5 53.5z M199 759q-24 0 -44.5 -7t-36.5 -19.5t-25 -28.5t-9 -34t9.5 -34t25 -28t36.5 -19t45 -7t44.5 7t36.5 19t25 27.5t9 33.5t-9.5 34.5t-25 29t-36.5 19.5t-45 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 467,
    d: "M234 -85q-49 0 -86 19t-62 49t-37.5 66.5t-12.5 70.5q0 37 14 73.5t39.5 66t62 48t82.5 18.5q49 0 85.5 -19.5t61.5 -50t37.5 -67t12.5 -69.5q0 -37 -13.5 -73.5t-39 -66t-62 -47.5t-82.5 -18zM93 120q0 -26 9 -53t27 -48.5t44 -35t61 -13.5q36 0 62.5 14.5t44 37 t26 48.5t8.5 50q0 27 -9.5 53.5t-27.5 48.5t-44 35.5t-60 13.5q-36 0 -62.5 -14.5t-44 -37t-26 -49t-8.5 -50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 301,
    d: "M281 -26v-54h-232v54h91v295q-6 -7 -18 -15.5t-27 -16t-31.5 -12.5t-29.5 -5v55q18 0 36.5 8.5t34 18.5t25.5 19t10 10h56v-357h85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 400,
    d: "M34 -80q0 39 7.5 68.5t23 51.5t40 38.5t57.5 29.5q23 9 47 17.5t43.5 19.5t32 26t12.5 37q0 30 -24.5 49.5t-72.5 19.5q-24 0 -43.5 -5t-35.5 -13t-27.5 -17.5t-19.5 -18.5l-36 40q5 7 18.5 18.5t34.5 22.5t50.5 19t66.5 8q75 0 113 -34.5t38 -89.5q0 -32 -14 -53 t-34.5 -35.5t-44.5 -23.5t-44 -15q-31 -10 -50.5 -23t-30.5 -27t-15 -28.5t-4 -27.5h238v-54h-326z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 395,
    d: "M190 -85q-63 0 -105.5 22.5t-52.5 63.5l32 37q1 -11 10.5 -22.5t26 -22t39 -17t49.5 -6.5q47 0 79.5 17.5t32.5 47.5q0 33 -40 51t-109 18h-23v50h23q63 0 99 15t36 47q0 30 -30.5 47t-69.5 17q-41 0 -70 -15t-45 -39l-37 43q20 29 62 45.5t90 16.5q34 0 63 -8.5 t50.5 -23.5t33.5 -35t12 -44q0 -35 -23.5 -57.5t-68.5 -31.5q48 -7 75.5 -36t27.5 -68q0 -27 -13.5 -48t-37 -35.5t-53.5 -21.5t-63 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 391,
    d: "M249 -80v100h-226v53l243 253h38v-252h59v-54h-59v-100h-55zM80 74h171v180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 380,
    d: "M193 180q33 0 61.5 -9.5t49.5 -26.5t33 -41t12 -53q0 -30 -13 -55t-35.5 -42.5t-53.5 -27.5t-66 -10q-51 0 -91.5 20t-60.5 53l35 34q19 -25 50 -40t70 -15q46 0 77 23t31 62q0 21 -9 37t-24 26.5t-33.5 16t-37.5 5.5q-29 0 -56.5 -13t-42.5 -34h-50q4 21 12 54.5 t16.5 68.5t15.5 66t10 47h229v-55h-188l-30 -117q16 12 38.5 19t50.5 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 410,
    d: "M379 55q0 -29 -13 -54.5t-36 -44.5t-54 -30t-67 -11q-76 0 -123 47t-47 132q0 117 48.5 176t129.5 59q45 0 82.5 -18t57.5 -51l-33 -37q-14 25 -44 39.5t-65 14.5q-56 0 -89.5 -37.5t-34.5 -106.5q15 27 49.5 42.5t72.5 15.5q36 0 66 -10.5t52.5 -29t35 -43.5t12.5 -53z M211 -35q24 0 44.5 7t36.5 19.5t25 28.5t9 34t-9 34.5t-25 28.5t-37 19t-45 7t-45 -7t-37 -19t-25 -28t-9 -34t9.5 -34.5t25.5 -29t37 -19.5t45 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 365,
    d: "M272 271h-247v55h334l-239 -406h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 405,
    d: "M368 35q0 -27 -13.5 -49t-36.5 -37.5t-53 -24.5t-64 -9q-36 0 -66 9.5t-52 26t-34.5 39t-12.5 47.5q0 19 7.5 35t20 28.5t29 22t33.5 15.5q-29 11 -51.5 31t-22.5 51q0 24 13.5 44t34.5 33.5t48 21t54 7.5t54 -7.5t48 -21t34.5 -33t13.5 -43.5q0 -30 -21.5 -51t-53.5 -32 q39 -14 65 -39.5t26 -63.5zM312 41q0 17 -10 30.5t-25.5 22.5t-35.5 14t-39 5q-21 0 -41 -5t-35 -15t-24.5 -23.5t-9.5 -29.5q0 -17 10 -30t26 -22t35.5 -13.5t39.5 -4.5t39.5 5t35 14.5t25 22.5t9.5 29zM108 215q0 -14 8.5 -24.5t22 -17.5t30 -11t33.5 -4q16 0 33 4 t31 11.5t22.5 18t8.5 24.5q0 13 -8 23.5t-21.5 18t-30.5 11.5t-35 4q-38 0 -66 -15.5t-28 -42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 411,
    d: "M32 189q0 29 13 54.5t36 44.5t53.5 30t66.5 11q76 0 123.5 -47t47.5 -132q0 -118 -48.5 -176.5t-129.5 -58.5q-45 0 -83 18t-58 51l34 37q14 -25 43.5 -39.5t65.5 -14.5q55 0 89 37t35 106q-15 -26 -50 -42t-73 -16q-35 0 -65.5 10.5t-52.5 29t-34.5 43.5t-12.5 54z M200 278q-24 0 -44.5 -7t-36.5 -19.5t-25 -28.5t-9 -34t9.5 -34t25 -28t36.5 -19t45 -7t44.5 7t36.5 19t25 28t9 34t-9.5 34t-25 28.5t-36.5 19.5t-45 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colonmonetary",
    unicode: "\u20A1",
    horizAdvX: 557,
    d: "M228 0q-43 12 -78 37.5t-60 60t-38.5 76.5t-13.5 88t13 87.5t38 76t60 59t79 36.5v124h44v-116q8 1 15.5 1.5t15.5 0.5h14.5t14.5 -2v116h44v-123q51 -14 88 -44.5t59 -73.5l-86 -27q-20 37 -56 57.5t-80 20.5q-36 0 -68 -14.5t-55 -40.5t-36.5 -61t-13.5 -77 q0 -41 14 -77t37.5 -62.5t55 -41.5t67.5 -15q23 0 45.5 6.5t41 17.5t32.5 25.5t20 31.5l86 -26q-18 -44 -57.5 -76t-93.5 -46v-119h-44v112q-7 -1 -14 -1.5t-14 -0.5q-8 0 -16 0.5t-16 1.5v-112h-44v120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "franc",
    unicode: "\u20A3",
    horizAdvX: 612,
    d: "M120 0v127h-91v68h91v515h469v-80h-379v-237h319v-75h-319v-123h118v-68h-118v-127h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lira",
    unicode: "\u20A4",
    horizAdvX: 500,
    d: "M51 404h72q-18 33 -33 66.5t-15 71.5q0 36 15 67.5t40.5 55t60 37t73.5 13.5q57 0 107 -28t82 -77l-49 -54q-24 39 -63 62.5t-79 23.5q-23 0 -42 -8.5t-33.5 -22.5t-22.5 -34t-8 -42q0 -34 16 -65t34 -66h194v-52h-170q11 -29 15 -59h155v-52h-155q-4 -42 -26 -81.5 t-70 -90.5q37 10 74 10q40 0 72.5 -9t67.5 -9q20 0 39.5 4.5t45.5 13.5l22 -67q-26 -13 -54.5 -20t-56.5 -7q-23 0 -43.5 4t-41.5 8.5t-42.5 8.5t-44.5 4q-25 0 -56 -5t-58 -13l-22 64q58 55 85.5 98t32.5 87h-118v52h116q-2 16 -7 30.5t-11 28.5h-98v52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A6",
    unicode: "\u20A6",
    horizAdvX: 854,
    d: "M816 376h-88v-59h88v-52h-88v-265h-76l-213 265h-221v-265h-90v265h-91v52h91v59h-91v52h91v282h70l224 -282h216v281h90v-281h88v-52zM218 317h180l-47 59h-133v-59zM511 317h127v59h-174zM218 428h91l-91 114v-114zM638 157v108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 1136,
    d: "M38 357h161l-29 69h-132v52h110l-96 232h97l92 -232h238l-91 228h85l94 -247l95 247h85l-91 -228h238l92 232h98l-97 -232h110v-52h-132l-29 -69h161v-52h-183l-127 -305h-78l-141 335l-142 -335h-78l-128 305h-182v52zM746 104l79 201h-163zM390 104l83 201h-163z M624 397l16 -40h206l27 69h-238zM499 426h-237l27 -69h205l17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 795,
    d: "M135 422q10 57 36.5 109.5t69 93t99.5 65t128 24.5q95 0 163 -43t101 -112l-71 -46q-16 34 -38.5 57t-49 37t-54.5 20t-55 6q-50 0 -89.5 -17.5t-69.5 -46.5t-49.5 -67t-28.5 -80h315l-22 -52h-299v-14q0 -24 3 -45h283l-22 -52h-249q13 -39 35 -73t52 -58.5t66.5 -38.5 t77.5 -14q28 0 57.5 7t56.5 22.5t50.5 39t38.5 56.5l75 -41q-17 -40 -47.5 -70.5t-69 -51.5t-81.5 -32t-84 -11q-60 0 -111.5 21.5t-92.5 57.5t-70.5 84t-44.5 102h-111l22 52h78q-3 24 -3 49v10h-73l22 52h56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 499,
    d: "M462 537h-106q3 -14 5 -27t2 -27q0 -37 -10.5 -71.5t-30 -62.5t-47 -48t-61.5 -29l172 -272h-102l-212 335h77q28 0 50.5 12t38.5 32.5t25 47.5t9 56q0 26 -10 54h-220v52h189q-17 19 -40 30t-48 11h-101v80h420v-52h-180q17 -15 30.5 -32t23.5 -37h126v-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 329,
    d: "M213 73q12 0 27 3.5t29 8.5l14 -71q-22 -9 -52 -15t-53 -6q-52 0 -81 29t-29 81v507q0 28 10.5 51.5t28.5 41t42.5 27.5t53.5 10q57 0 91.5 -36t34.5 -94q0 -39 -15.5 -89.5t-41 -101.5t-58.5 -98t-68 -80v-106q0 -29 18 -45.5t49 -16.5zM258 604q0 32 -14 49.5t-40 17.5 t-42 -17t-16 -44v-277q22 27 42 62.5t35.5 73t25 73t9.5 62.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1157,
    d: "M175 542v-542h-90v710h70l440 -553v552h90v-709h-76zM957 344q-41 0 -74.5 15t-57.5 40t-37 58.5t-13 69.5q0 37 13 70.5t37 59t57.5 40t74.5 14.5t74.5 -14.5t57.5 -40t37 -59t13 -70.5q0 -36 -13 -69.5t-37 -58.5t-57.5 -40t-74.5 -15zM847 526q0 -26 8.5 -48t23.5 -38 t35 -25.5t43 -9.5t43 9.5t35 26t23.5 39t8.5 48.5t-8.5 48t-23.5 38.5t-35 25.5t-43 9t-43 -9.5t-35 -26t-23.5 -39t-8.5 -48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "servicemark",
    unicode: "\u2120",
    horizAdvX: 739,
    d: "M584 710h86v-290h-60v208l-78 -166h-49l-78 166v-208h-60v290h85l77 -178zM261 632q-11 11 -34 21t-51 10q-54 0 -54 -29q0 -13 12 -22t54 -18q51 -11 81 -31t30 -65q0 -43 -34 -62.5t-85 -19.5q-73 0 -129 42l28 45q13 -13 40.5 -23.5t61.5 -10.5q54 0 54 25 q0 16 -15 25t-58 20q-51 12 -76.5 30t-25.5 59q0 42 33 64.5t84 22.5q33 0 59.5 -9t47.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 760,
    d: "M313 652h-95v-232h-60v232h-95v60h250v-60zM598 710h86v-290h-60v208l-78 -166h-49l-78 166v-208h-60v290h85l77 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 760,
    d: "M44 79h179q-78 44 -123.5 118.5t-45.5 167.5q0 69 25 132.5t68.5 111.5t103 77t129.5 29t129.5 -29t103 -77t68.5 -111.5t25 -132.5q0 -93 -45.5 -167.5t-123.5 -118.5h179v-79h-289v79q43 14 78 43.5t59.5 68.5t37.5 84t13 90q0 50 -16.5 98t-47 86t-74 61t-97.5 23 t-97.5 -23t-74 -61t-47 -86t-16.5 -98q0 -45 13 -90t37.5 -84t59.5 -68.5t78 -43.5v-79h-289v79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    horizAdvX: 599,
    d: "M305 27q69 0 114.5 22t74.5 52l26 -28q-35 -35 -87.5 -59t-127.5 -24q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59.5t54 -87.5t19.5 -107h-420v-150q29 -36 69 -57t87 -21zM305 494q-47 0 -87 -21.5t-69 -58.5v-119 h314v118q-29 38 -69.5 59.5t-88.5 21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 889,
    d: "M686 -5q-63 0 -105.5 22.5t-52.5 63.5l32 37q1 -11 10.5 -22.5t26 -22t39 -17t49.5 -6.5q47 0 79.5 17.5t32.5 47.5q0 33 -40 51t-109 18h-23v50h23q63 0 99 15t36 47q0 30 -30.5 47t-69.5 17q-41 0 -70 -15t-45 -39l-37 43q20 29 62 45.5t90 16.5q34 0 63 -8.5 t50.5 -23.5t33.5 -35t12 -44q0 -35 -23.5 -57.5t-68.5 -31.5q48 -7 75.5 -36t27.5 -68q0 -27 -13.5 -48t-37 -35.5t-53.5 -21.5t-63 -7zM271 375v-55h-210v55h80v294q-5 -6 -16 -14.5t-24.5 -16t-28 -13t-26.5 -5.5v55q16 0 32.5 8.5t30.5 18.5t23 19t9 10h56v-356h74z M112 33l280 337l268 345l43 -37l-277 -335l-272 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 899,
    d: "M697 -5q-63 0 -105.5 22.5t-52.5 63.5l32 37q1 -11 10.5 -22.5t26 -22t39 -17t49.5 -6.5q47 0 79.5 17.5t32.5 47.5q0 33 -40 51t-109 18h-23v50h23q63 0 99 15t36 47q0 30 -30.5 47t-69.5 17q-41 0 -70 -15t-45 -39l-37 43q20 29 62 45.5t90 16.5q34 0 63 -8.5 t50.5 -23.5t33.5 -35t12 -44q0 -35 -23.5 -57.5t-68.5 -31.5q48 -7 75.5 -36t27.5 -68q0 -27 -13.5 -48t-37 -35.5t-53.5 -21.5t-63 -7zM42 320q0 39 7 68.5t22 51.5t38 38.5t55 29.5q22 9 45.5 17.5t43 20t31.5 26.5t12 37q0 29 -23.5 48.5t-70.5 19.5q-23 0 -42 -5 t-34 -13t-26.5 -17.5t-19.5 -17.5l-34 39q4 7 17 18.5t33.5 22.5t49 19t64.5 8q72 0 108.5 -34.5t36.5 -88.5q0 -32 -13.5 -53.5t-33.5 -36t-43.5 -23.5t-42.5 -15q-30 -10 -48.5 -23t-29 -27t-14.5 -28.5t-4 -27.5h223v-54h-307zM163 33l280 337l268 345l43 -37l-277 -335 l-272 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 887,
    d: "M852 115q0 -27 -13.5 -49t-36.5 -37.5t-53 -24.5t-64 -9q-36 0 -66 9.5t-52 26t-34.5 39t-12.5 47.5q0 19 7.5 35t20 28.5t29 22t33.5 15.5q-29 11 -51.5 31t-22.5 51q0 24 13.5 44t34.5 33.5t48 21t54 7.5t54 -7.5t48 -21t34.5 -33t13.5 -43.5q0 -30 -21.5 -51 t-53.5 -32q39 -14 65 -39.5t26 -63.5zM796 121q0 17 -10 30.5t-25.5 22.5t-35.5 14t-39 5q-21 0 -41 -5t-35 -15t-24.5 -23.5t-9.5 -29.5q0 -17 10 -30t26 -22t35.5 -13.5t39.5 -4.5t39.5 5t35 14.5t25 22.5t9.5 29zM592 295q0 -14 8.5 -24.5t22 -17.5t30 -11t33.5 -4 q16 0 33 4t31 11.5t22.5 18t8.5 24.5q0 13 -8 23.5t-21.5 18t-30.5 11.5t-35 4q-38 0 -66 -15.5t-28 -42.5zM270 375v-55h-210v55h80v294q-5 -6 -16 -14.5t-24.5 -16t-28 -13t-26.5 -5.5v55q16 0 32.5 8.5t30.5 18.5t23 19t9 10h56v-356h74zM124 33l280 337l268 345l43 -37 l-277 -335l-272 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 892,
    d: "M199 314q-63 0 -105.5 23t-52.5 63l32 38q1 -11 10.5 -22.5t26 -22t39 -17t49.5 -6.5q47 0 79.5 17.5t32.5 47.5q0 33 -40 50.5t-109 17.5h-23v51h23q63 0 99 15t36 47q0 30 -30.5 47t-69.5 17q-41 0 -70 -15t-45 -39l-37 43q20 29 62 45.5t90 16.5q34 0 63 -8.5 t50.5 -23.5t33.5 -35.5t12 -44.5q0 -35 -23.5 -57t-68.5 -31q48 -7 75.5 -36t27.5 -68q0 -27 -13.5 -48.5t-37 -35.5t-53.5 -21.5t-63 -7.5zM857 115q0 -27 -13.5 -49t-36.5 -37.5t-53 -24.5t-64 -9q-36 0 -66 9.5t-52 26t-34.5 39t-12.5 47.5q0 19 7.5 35t20 28.5t29 22 t33.5 15.5q-29 11 -51.5 31t-22.5 51q0 24 13.5 44t34.5 33.5t48 21t54 7.5t54 -7.5t48 -21t34.5 -33t13.5 -43.5q0 -30 -21.5 -51t-53.5 -32q39 -14 65 -39.5t26 -63.5zM801 121q0 17 -10 30.5t-25.5 22.5t-35.5 14t-39 5q-21 0 -41 -5t-35 -15t-24.5 -23.5t-9.5 -29.5 q0 -17 10 -30t26 -22t35.5 -13.5t39.5 -4.5t39.5 5t35 14.5t25 22.5t9.5 29zM597 295q0 -14 8.5 -24.5t22 -17.5t30 -11t33.5 -4q16 0 33 4t31 11.5t22.5 18t8.5 24.5q0 13 -8 23.5t-21.5 18t-30.5 11.5t-35 4q-38 0 -66 -15.5t-28 -42.5zM150 33l280 337l268 345l43 -37 l-277 -335l-272 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 899,
    d: "M864 115q0 -27 -13.5 -49t-36.5 -37.5t-53 -24.5t-64 -9q-36 0 -66 9.5t-52 26t-34.5 39t-12.5 47.5q0 19 7.5 35t20 28.5t29 22t33.5 15.5q-29 11 -51.5 31t-22.5 51q0 24 13.5 44t34.5 33.5t48 21t54 7.5t54 -7.5t48 -21t34.5 -33t13.5 -43.5q0 -30 -21.5 -51 t-53.5 -32q39 -14 65 -39.5t26 -63.5zM808 121q0 17 -10 30.5t-25.5 22.5t-35.5 14t-39 5q-21 0 -41 -5t-35 -15t-24.5 -23.5t-9.5 -29.5q0 -17 10 -30t26 -22t35.5 -13.5t39.5 -4.5t39.5 5t35 14.5t25 22.5t9.5 29zM604 295q0 -14 8.5 -24.5t22 -17.5t30 -11t33.5 -4 q16 0 33 4t31 11.5t22.5 18t8.5 24.5q0 13 -8 23.5t-21.5 18t-30.5 11.5t-35 4q-38 0 -66 -15.5t-28 -42.5zM199 584q33 0 61.5 -9.5t49.5 -26.5t33 -41t12 -52q0 -30 -13 -55t-35.5 -43t-53.5 -28t-66 -10q-51 0 -91.5 20t-60.5 54l35 34q19 -26 50 -40.5t70 -14.5 q46 0 77 22.5t31 61.5q0 21 -9 37t-24 26.5t-33.5 16t-37.5 5.5q-29 0 -56.5 -13t-42.5 -34h-50q4 21 12 54.5t16.5 68.5t15.5 66t10 47h229v-55h-188l-30 -117q16 12 38.5 19t50.5 7zM146 33l280 337l268 345l43 -37l-277 -335l-272 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 874,
    d: "M838 115q0 -27 -13.5 -49t-36.5 -37.5t-53 -24.5t-64 -9q-36 0 -66 9.5t-52 26t-34.5 39t-12.5 47.5q0 19 7.5 35t20 28.5t29 22t33.5 15.5q-29 11 -51.5 31t-22.5 51q0 24 13.5 44t34.5 33.5t48 21t54 7.5t54 -7.5t48 -21t34.5 -33t13.5 -43.5q0 -30 -21.5 -51 t-53.5 -32q39 -14 65 -39.5t26 -63.5zM782 121q0 17 -10 30.5t-25.5 22.5t-35.5 14t-39 5q-21 0 -41 -5t-35 -15t-24.5 -23.5t-9.5 -29.5q0 -17 10 -30t26 -22t35.5 -13.5t39.5 -4.5t39.5 5t35 14.5t25 22.5t9.5 29zM578 295q0 -14 8.5 -24.5t22 -17.5t30 -11t33.5 -4 q16 0 33 4t31 11.5t22.5 18t8.5 24.5q0 13 -8 23.5t-21.5 18t-30.5 11.5t-35 4q-38 0 -66 -15.5t-28 -42.5zM76 33l280 337l268 345l43 -37l-277 -335l-272 -348zM287 675h-246v55h334l-239 -405h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 562,
    d: "M245 -10q-48 0 -88 16t-69.5 43.5t-45.5 65t-16 80.5q0 47 19.5 90.5t53.5 76.5t78 52.5t94 19.5q57 0 98.5 -25.5t56.5 -68.5q2 22 3 42t1 37q0 62 -10 104t-29 67.5t-46 36.5t-60 11q-42 0 -81 -14.5t-59 -37.5l-49 53q32 37 84.5 56.5t112.5 19.5q109 0 164.5 -74 t55.5 -242q0 -101 -19.5 -177.5t-55 -128t-84.5 -77.5t-109 -26zM247 66q33 0 62.5 13t52 35.5t35.5 52t13 61.5q0 28 -10.5 53t-29 43t-43.5 28.5t-54 10.5q-32 0 -61.5 -13t-52 -35t-36 -51t-13.5 -62q0 -29 10.5 -53.5t29 -43t43.5 -29t54 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 618,
    d: "M610 67v-67h-602v67l265 643h74zM511 80l-201 526l-202 -526h403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 725,
    d: "M528 630h-331v-720h-85v720h-80v80h661v-80h-80v-720h-85v720z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 546,
    d: "M497 637h-338v-4l191 -264l-212 -285v-4h374v-80h-480v63l223 293l-216 298v56h458v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 537,
    d: "M67 269v72h403v-72h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 599,
    d: "M-9 38l566 677l52 -43l-566 -677z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 202,
    d: "M64 245v124h74v-124h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 464,
    d: "M10 365h157l63 -288l112 713h84l-152 -790h-94l-86 301h-84v64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 686,
    d: "M203 517q28 0 49.5 -7.5t38 -20t29 -29t23.5 -35.5q11 19 23.5 35.5t29 29t37.5 20t50 7.5q36 0 65.5 -13t50.5 -35.5t32 -53t11 -64.5t-12 -64t-33.5 -52.5t-51 -35.5t-63.5 -13q-54 0 -85 24.5t-52 58.5q-20 -34 -52 -58.5t-90 -24.5q-30 0 -59 13t-51.5 35.5t-36 53 t-13.5 64.5t12 64t33.5 52.5t51 35.5t63.5 13zM203 256q21 0 37.5 7.5t30 20.5t24 30t20.5 36q-10 19 -20.5 36.5t-23.5 31t-29.5 21t-38.5 7.5q-16 0 -32 -5.5t-29 -16.5t-21 -29t-8 -43q0 -26 8 -44t21 -29.5t29 -17t32 -5.5zM483 256q16 0 32 5.5t28.5 17t20.5 29.5t8 44 q0 25 -8 43t-20.5 29t-28.5 16.5t-32 5.5q-23 0 -39.5 -8t-29 -21.5t-22.5 -32t-19 -38.5q19 -37 43.5 -63.5t66.5 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 316,
    d: "M97 710q-2 47 25.5 78.5t80.5 31.5q23 0 53 -6t53 -15l-21 -61q-14 5 -29 8.5t-26 3.5q-26 0 -42 -16.5t-14 -45.5l41 -745q3 -52 -25 -81t-80 -29q-23 0 -52.5 6t-52.5 15l21 61q14 -5 28.5 -8.5t25.5 -3.5q26 0 42 16.5t14 45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 435,
    d: "M372 335q-14 -19 -36 -32.5t-56 -13.5q-23 0 -39.5 6.5t-31 14.5t-28.5 14.5t-30 6.5q-20 0 -31.5 -8t-16.5 -18l-40 44q12 19 32.5 33t53.5 14q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q23 0 35.5 7t20.5 15zM372 198q-14 -17 -36 -29t-56 -12q-23 0 -39.5 6.5t-31 14.5 t-28.5 14.5t-30 6.5q-20 0 -31.5 -8t-16.5 -18l-40 44q12 19 32.5 33t53.5 14q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q23 0 35.5 6.5t20.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 481,
    d: "M88 373h180l67 122l38 -22l-55 -100h75v-60h-107l-41 -74h148v-60h-181l-66 -122l-38 22l54 100h-74v60h107l41 74h-148v60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 451,
    d: "M57 51v72h332v-72h-332zM56 390l330 163v-84l-202 -100l202 -97v-88l-330 160v46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 451,
    d: "M62 51v72h332v-72h-332zM395 344l-330 -160v88l202 97l-202 100v84l330 -163v-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 522,
    d: "M308 730l186 -364l-186 -366h-94l-186 366l186 364h94zM415 354l-155 308l-145 -287l154 -310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccent",
    unicode: "\uF6C3",
    horizAdvX: 168,
    d: "M63 -213l20 81h-25v84h78v-84l-30 -81h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s_t",
    unicode: "\uFB06",
    horizAdvX: 828,
    d: "M817 26q-8 -4 -21.5 -9.5t-30 -11t-35.5 -9t-38 -3.5q-50 0 -84.5 26.5t-34.5 82.5v351h-71v69h71q0 52 -3 86.5t-13 54.5t-27.5 28.5t-45.5 8.5q-30 0 -50.5 -7.5t-33 -20.5t-18.5 -30.5t-6 -37.5q0 -26 7 -49.5t16 -42.5t17.5 -32t11.5 -17l-39 -53q-35 33 -73 45 t-73 12q-23 0 -44 -4.5t-38 -14t-27 -26t-10 -40.5q0 -26 12.5 -42t32 -25t43 -13.5t45.5 -7.5q40 -6 76.5 -14.5t64 -24.5t43.5 -41.5t16 -64.5q0 -42 -17 -72t-45.5 -49.5t-65.5 -28.5t-76 -9q-64 0 -123.5 21.5t-98.5 52.5l36 60q92 -69 185 -69q22 0 44.5 4.5t40 14.5 t28.5 26.5t11 39.5q0 27 -13.5 42t-34.5 24t-46.5 13t-49.5 8q-41 7 -75 16t-59 25t-39 40t-14 61q0 42 17 73t44.5 50.5t62 29t69.5 9.5q31 0 65.5 -7t60.5 -24q-13 26 -21.5 49t-8.5 56q0 28 9 53.5t29 44.5t52 30t79 11q56 0 87.5 -14t47.5 -42t19.5 -69.5t3.5 -96.5h116 v-69h-116v-324q0 -29 17.5 -42t42.5 -13q24 0 46 8.5t30 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B.sc",
    horizAdvX: 584,
    d: "M542 142q0 -33 -14 -59t-38 -44.5t-56.5 -28.5t-69.5 -10h-285v551h301q31 0 56.5 -12t43 -32t27 -45.5t9.5 -51.5q0 -41 -22 -75.5t-63 -51.5q51 -14 81 -51t30 -90zM461 157q0 18 -7 34t-19 28t-29 19.5t-36 7.5h-211v-177h205q20 0 38 7t31 19t20.5 28t7.5 34z M159 481v-170h188q38 0 64 24.5t26 60.5q0 37 -24 61t-61 24h-193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C.sc",
    horizAdvX: 594,
    d: "M40 280q0 50 19.5 99t56 88t90 63t122.5 24q81 0 139 -33t86 -87l-63 -42q-13 25 -32 42.5t-41 28t-46 15t-46 4.5q-50 0 -88 -18t-64 -47.5t-39 -66.5t-13 -74q0 -41 15.5 -79t43 -67t65 -46t82.5 -17q23 0 48 5.5t47.5 17t42 29t32.5 42.5l67 -38q-15 -31 -41 -54.5 t-59 -40t-69.5 -25t-71.5 -8.5q-62 0 -114 24.5t-89.5 65t-58.5 91.5t-21 104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A.sc",
    horizAdvX: 588,
    d: "M13 0l248 551h66l247 -551h-85l-70 155h-250l-70 -155h-86zM294 452l-107 -227h212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D.sc",
    horizAdvX: 625,
    d: "M79 0v551h211q73 0 127.5 -21.5t91.5 -58.5t55.5 -87t18.5 -107q0 -63 -21 -114t-59 -87.5t-92.5 -56t-120.5 -19.5h-211zM501 277q0 45 -14 82t-41 64t-66 42t-90 15h-131v-409h131q52 0 91.5 15.5t66 43t40 65.5t13.5 82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E.sc",
    horizAdvX: 530,
    d: "M491 71v-71h-412v551h404v-71h-324v-166h282v-66h-282v-177h332z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F.sc",
    horizAdvX: 511,
    d: "M79 0v551h400v-71h-320v-172h270v-67h-270v-241h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.alt",
    horizAdvX: 730,
    d: "M381 -5q-75 0 -137.5 30.5t-108 81t-70.5 116t-25 135.5q0 69 24.5 133.5t69.5 114t107.5 79.5t137.5 30q90 0 159.5 -41.5t111.5 -110.5l-71 -57q-13 22 -32.5 45t-45 41.5t-57.5 30t-70 11.5q-56 0 -101 -24t-76.5 -63.5t-48.5 -90t-17 -102.5q0 -51 17 -101 t48.5 -89.5t76.5 -63.5t101 -24q46 0 85.5 17t69.5 45t50 64t27 75h-192v80h290v-9t-0.5 -15t-0.5 -15.5v-9.5q-5 -63 -30.5 -119.5t-67.5 -99.5t-99 -68.5t-125 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.sc",
    horizAdvX: 619,
    d: "M500 71q-78 -75 -180 -75q-60 0 -111 24t-88.5 63t-59 90t-21.5 105q0 56 21 106t58.5 88t89 60.5t112.5 22.5q86 0 143 -33t86 -87l-62 -44q-26 47 -70.5 69.5t-99.5 22.5q-45 0 -81.5 -17.5t-62 -46t-39.5 -66.5t-14 -78q0 -42 15.5 -80t43.5 -66t65 -44.5t81 -16.5 q94 0 174 84v65h-129v60h197v-277h-68v71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H.sc",
    horizAdvX: 646,
    d: "M567 551v-551h-80v246h-328v-246h-80v551h80v-233h328v233h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I.sc",
    horizAdvX: 238,
    d: "M79 0v551h80v-551h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J.sc",
    horizAdvX: 429,
    d: "M39 91q16 -10 45 -19t66 -9q42 0 67.5 13.5t38.5 39.5t17 65t4 90v280h80v-280q0 -63 -6.5 -114.5t-28 -88t-62.5 -56.5t-110 -20q-78 0 -132 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K.sc",
    horizAdvX: 572,
    d: "M79 0v551h80v-295l307 295h87l-242 -243l255 -308h-86l-218 261l-103 -93v-168h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L.sc",
    horizAdvX: 492,
    d: "M79 0v551h80v-480h317v-71h-397z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.alt",
    horizAdvX: 232,
    d: "M106 609l-58 20l58 101h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M.sc",
    horizAdvX: 759,
    d: "M600 0v409l-198 -311h-45l-198 311v-409h-80v551h85l216 -345l216 345h84v-551h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N.sc",
    horizAdvX: 670,
    d: "M159 402v-402h-80v551h62l370 -410v410h80v-551h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O.sc",
    horizAdvX: 650,
    d: "M325 -4q-64 0 -116.5 24t-90 63t-58 89.5t-20.5 103.5q0 55 21.5 105t60 88.5t90.5 61.5t114 23q64 0 116 -24t89.5 -63.5t58 -90t20.5 -102.5q0 -55 -21.5 -105t-59.5 -88.5t-90.5 -61.5t-113.5 -23zM121 275q0 -40 14.5 -77.5t41.5 -66t64.5 -46t84.5 -17.5t84.5 18 t63.5 47.5t40 67t14 75.5q0 40 -14.5 77.5t-41.5 66t-64.5 45.5t-82.5 17q-47 0 -85 -18t-64.5 -47.5t-40.5 -66.5t-14 -75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P.sc",
    horizAdvX: 546,
    d: "M79 0v551h252q40 0 74 -15.5t59 -41t38.5 -57t13.5 -64.5q0 -35 -13 -67t-36.5 -57t-56.5 -40t-73 -15h-178v-194h-80zM159 265h173q47 0 75 31t28 77q0 23 -8.5 42.5t-23.5 34t-34.5 22.5t-41.5 8h-168v-215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q.sc",
    horizAdvX: 649,
    d: "M486 45q-34 -23 -74.5 -36t-86.5 -13q-64 0 -116.5 24t-90 63t-58 89.5t-20.5 103.5q0 55 21.5 105.5t60 89t90.5 61.5t114 23q64 0 116 -24.5t89.5 -64t58 -90t20.5 -102.5q0 -54 -21 -104t-59 -88l76 -82h-78zM326 68q32 0 59 8.5t50 23.5l-80 87h79l44 -49 q24 29 37 65t13 73q0 40 -14.5 77.5t-41.5 66t-64.5 46t-82.5 17.5q-47 0 -85 -18t-64.5 -47.5t-40.5 -67t-14 -75.5q0 -40 14.5 -77.5t41.5 -66t64.5 -46t84.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R.sc",
    horizAdvX: 576,
    d: "M79 0v551h260q40 0 74 -15.5t58.5 -41t38 -57t13.5 -64.5q0 -28 -9 -54t-25.5 -48t-39.5 -38t-51 -23l146 -210h-92l-136 194h-157v-194h-80zM159 265h180q23 0 42 8.5t32.5 23.5t21 34.5t7.5 41.5t-8.5 41.5t-23.5 34t-34.5 23t-41.5 8.5h-175v-215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S.sc",
    horizAdvX: 525,
    d: "M428 427q-23 23 -65.5 40t-95.5 17q-68 0 -99.5 -22t-31.5 -61q0 -20 9.5 -34t28.5 -24t48.5 -17.5t68.5 -16.5q46 -10 83 -22t63 -29.5t40 -43.5t14 -63q0 -41 -17 -71t-46 -49t-68.5 -28t-85.5 -9q-69 0 -130.5 19.5t-112.5 56.5l38 68q29 -28 83.5 -50t123.5 -22 q60 0 94.5 19.5t34.5 57.5q0 22 -11 37t-33 26t-53.5 19.5t-72.5 17.5q-45 10 -79 22t-56.5 29t-34 41t-11.5 57q0 40 16.5 70.5t45 51t67.5 31t85 10.5q60 0 109 -17t87 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T.sc",
    horizAdvX: 537,
    d: "M516 480h-207v-480h-80v480h-208v71h495v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U.sc",
    horizAdvX: 653,
    d: "M326 68q51 0 85 17.5t54.5 46t28.5 65.5t8 75v279h80v-279q0 -56 -14 -106.5t-44.5 -88t-79 -59.5t-117.5 -22q-71 0 -120 23t-79 61.5t-43.5 88.5t-13.5 103v279h80v-279q0 -39 8.5 -76t29 -65.5t54 -45.5t83.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V.sc",
    d: "M99 551l197 -439l196 439h85l-247 -551h-69l-247 551h85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.alt",
    horizAdvX: 1077,
    d: "M1059 710l-225 -710h-94l-204 563l-199 -563h-94l-225 710h101l179 -577l188 577h98l195 -577l178 577h102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.sc",
    horizAdvX: 908,
    d: "M299 548h75l79 -189l80 189h75l-105 -243l99 -208l205 454h88l-253 -551h-69l-119 252l-119 -252h-70l-252 551h87l206 -454l97 208z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X.sc",
    horizAdvX: 560,
    d: "M99 551l181 -222l181 222h89l-227 -279l220 -272h-88l-175 214l-174 -214h-89l220 272l-227 279h89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y.sc",
    horizAdvX: 567,
    d: "M102 551l181 -281l182 281h88l-230 -352v-199h-80v200l-228 351h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z.sc",
    horizAdvX: 556,
    d: "M36 62l386 418h-378v71h472v-62l-379 -418h379v-71h-480v62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    horizAdvX: 625,
    d: "M285 -10q-55 0 -100.5 22t-78.5 59t-51 86t-18 103q0 56 18.5 105.5t51 86t76 58t94.5 21.5q63 0 112.5 -31.5t77.5 -82.5v100h88v-517h-88v99q-28 -50 -74.5 -79.5t-107.5 -29.5zM467 330q-21 54 -65.5 89.5t-99.5 35.5q-39 0 -71 -17t-55 -45t-35.5 -63t-12.5 -71 q0 -39 13 -74t36.5 -61.5t56 -42t71.5 -15.5q57 0 98.5 33t63.5 83v148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt2",
    horizAdvX: 549,
    d: "M399 0v79q-34 -46 -85.5 -67.5t-108.5 -21.5q-37 0 -69 12.5t-55.5 34.5t-37 51.5t-13.5 64.5q0 41 19 71.5t50.5 50.5t70.5 29.5t80 9.5q51 0 88.5 -8.5t57.5 -17.5v42q0 63 -36 100t-102 37q-79 0 -166 -61l-29 57q45 30 95.5 49t107.5 19q53 0 93.5 -15t68.5 -42.5 t42 -66.5t14 -86v-321h-85zM377 120q19 21 19 39v77q-32 13 -66.5 19t-66.5 6q-26 0 -52.5 -5.5t-48 -18t-35 -31.5t-13.5 -46q0 -23 9 -42.5t25 -33t36.5 -21t43.5 -7.5q20 0 41.5 4t41.5 11.5t37 19.5t29 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c_t",
    horizAdvX: 901,
    d: "M890 26q-16 -8 -50 -20.5t-77 -12.5q-24 0 -45 6.5t-37 20t-25.5 34t-9.5 48.5v351h-71v69h71q0 42 -1.5 75.5t-11 56t-30 34.5t-58.5 12q-51 0 -73.5 -30t-22.5 -72q0 -25 9 -53.5t21 -55.5t24 -49.5t18 -35.5l-86 -27q-23 40 -58.5 59t-80.5 19q-39 0 -70.5 -16.5 t-53.5 -44t-34 -62.5t-12 -72q0 -40 13.5 -75t37 -61.5t55.5 -42t69 -15.5q19 0 40.5 5.5t41 16t35 25.5t21.5 34l86 -26q-12 -31 -35 -55t-53 -41t-65 -26t-71 -9q-60 0 -109 23t-83.5 60.5t-53.5 86t-19 100.5q0 53 18 102t52 86.5t82.5 60t110.5 22.5q49 0 83 -11.5 t63 -31.5q-14 24 -26 53t-12 61q0 63 41 102.5t120 39.5q62 0 96 -17.5t49.5 -47.5t18 -70.5t2.5 -86.5h116v-69h-116v-324q2 -29 19 -42t40 -13q26 0 47.5 9t29.5 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d.alt",
    horizAdvX: 624,
    d: "M465 0v92q-29 -47 -75.5 -74.5t-103.5 -27.5q-54 0 -100 22t-79 59t-51.5 86t-18.5 103q0 55 17.5 104.5t49 86.5t75 58.5t94.5 21.5q64 0 112.5 -32.5t79.5 -80.5v312h88v-730h-88zM465 333q-9 26 -27 48t-40.5 38.5t-48.5 26t-51 9.5q-38 0 -69.5 -16.5t-54 -44 t-34.5 -63t-12 -72.5q0 -39 14 -74.5t38 -61.5t56.5 -41.5t70.5 -15.5q24 0 50 9t48.5 25t39 37.5t20.5 45.5v150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum",
    horizAdvX: 598,
    d: "M549 201q0 -48 -20.5 -86.5t-55 -65.5t-80 -42t-96.5 -15q-53 0 -98.5 16.5t-78.5 45t-52 67.5t-19 84q0 33 12 61t30.5 50t42.5 38.5t48 25.5q-22 9 -42 23.5t-35 33t-23.5 40.5t-8.5 47q0 45 20.5 79.5t53 58.5t72.5 36t80 12t80.5 -12t73 -35.5t53 -58t20.5 -79.5 q0 -50 -33 -88t-78 -57q27 -11 51.5 -28t42.5 -39.5t29 -50.5t11 -61zM460 207q0 32 -14.5 57.5t-37.5 43t-52 26.5t-58 9q-30 0 -58.5 -9.5t-51 -27.5t-36 -43.5t-13.5 -56.5q0 -32 14.5 -57t37.5 -42t51.5 -26.5t57.5 -9.5q30 0 58.5 10t51 28t36.5 43t14 55zM162 521 q0 -27 12.5 -47.5t32.5 -34.5t44 -21t48 -7t48 7.5t44 21.5t32.5 35t12.5 48q0 25 -11.5 45t-30.5 34t-44 21.5t-52 7.5t-51.5 -7.5t-43 -22t-30 -35t-11.5 -45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum",
    horizAdvX: 558,
    d: "M286 453q49 0 91.5 -16.5t73.5 -46.5t49 -71.5t18 -91.5q0 -53 -19.5 -96.5t-53 -75t-79.5 -48.5t-99 -17q-76 0 -136.5 36t-92.5 97l55 48q28 -47 74.5 -74.5t100.5 -27.5q34 0 63.5 11.5t51 32t33.5 49t12 63.5q0 33 -12 61t-32.5 48.5t-48.5 31.5t-60 11 q-42 0 -80 -19t-61 -54h-80q1 5 5 25.5t10 50t13 65.5t14 73q17 86 38 192h345v-81h-280l-43 -226q45 50 130 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum",
    horizAdvX: 577,
    d: "M361 0v181h-334v79l361 450h61v-449h88v-80h-88v-181h-88zM119 261h251v314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j.alt",
    horizAdvX: 230,
    d: "M71 517h88v-730h-88v730zM71 722h88v-102h-88v102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l.alt",
    horizAdvX: 240,
    d: "M76 730h88v-730h-88v730z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum",
    horizAdvX: 606,
    d: "M44 470q0 51 19.5 96t54 78t80.5 52t100 19q57 0 104.5 -21t81.5 -60t52.5 -95.5t18.5 -128.5q0 -105 -19 -184t-54 -131.5t-84 -78.5t-109 -26q-69 0 -125.5 33.5t-88.5 93.5l54 53q22 -47 65 -74.5t96 -27.5q82 0 131.5 72.5t50.5 204.5q-22 -52 -71 -83t-112 -31 q-51 0 -96 18.5t-78 51t-52 76t-19 93.5zM297 640q-35 0 -65.5 -13.5t-53 -36.5t-36 -54t-13.5 -65q0 -35 13.5 -65.5t36.5 -53t53.5 -36t65.5 -13.5q34 0 65 13.5t54 36t36.5 53t13.5 64.5t-13.5 65t-37 54.5t-54.5 37t-65 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum",
    horizAdvX: 441,
    d: "M419 80v-80h-353v80h136v545q-8 -12 -26.5 -26.5t-41 -28t-47 -22.5t-44.5 -9v82q27 0 54.5 14.5t50.5 32.5t38 33t16 17h90v-638h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q.alt",
    horizAdvX: 623,
    d: "M271 -10q-52 0 -95 22t-74 59.5t-48 86.5t-17 103q0 55 19 104t52.5 86t78.5 58.5t97 21.5q61 0 111 -30t79 -78v99h78v-735h-88v316q-72 -113 -193 -113zM301 66q56 0 96.5 32.5t66.5 79.5v150q-5 25 -21 48.5t-38.5 40.5t-49 27.5t-52.5 10.5q-39 0 -71 -16.5 t-55.5 -44t-36.5 -63t-13 -72.5q0 -39 13 -74.5t36 -61.5t55 -41.5t70 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum",
    horizAdvX: 534,
    d: "M396 629h-364v81h504l-358 -710h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum",
    horizAdvX: 606,
    d: "M562 235q0 -51 -19.5 -95.5t-54 -78t-80.5 -52.5t-100 -19q-57 0 -104.5 21t-81.5 60.5t-52.5 96t-18.5 128.5q0 105 19 183.5t54 131t84 78.5t109 26q69 0 125.5 -33t88.5 -93l-54 -53q-22 47 -65 74.5t-96 27.5q-41 0 -74 -18.5t-57 -54.5t-37 -87.5t-14 -117.5 q22 52 71 83t112 31q51 0 96 -18.5t78 -51t52 -76t19 -93.5zM309 66q34 0 65 13.5t54 36.5t36.5 53.5t13.5 65.5q0 34 -13.5 65t-36.5 53.5t-54 36t-65 13.5q-35 0 -65.5 -13.5t-53.5 -36t-36.5 -53.5t-13.5 -65q0 -35 13.5 -65.5t36.5 -53.5t53.5 -36.5t65.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t.alt",
    horizAdvX: 336,
    d: "M104 0v442h-77v80h77v174h90v-174h123v-80h-123v-442h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum",
    horizAdvX: 585,
    d: "M281 -9q-46 0 -85.5 11t-70.5 31.5t-51.5 49.5t-27.5 65l50 53q2 -22 16 -45t37.5 -41.5t56.5 -30t74 -11.5q34 0 64 9t52.5 25t35 39t12.5 51q0 62 -59 95.5t-162 33.5h-34v75h34q93 0 147.5 29t54.5 89q0 28 -12 51t-32.5 38.5t-47 24t-54.5 8.5q-32 0 -59.5 -7.5 t-49.5 -20.5t-37.5 -30.5t-24.5 -36.5l-59 61q15 26 39.5 47t54.5 35.5t64.5 22t70.5 7.5q52 0 96 -15t76 -41.5t50 -62t18 -77.5q0 -61 -36 -100.5t-102 -55.5q35 -6 63.5 -23t49 -41t31.5 -54t11 -63q0 -47 -21 -83t-56 -61t-81 -38t-96 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum",
    horizAdvX: 590,
    d: "M46 0q0 70 12 121t36 89t59.5 66t82.5 51q33 16 69 31.5t65 35t48 47t19 69.5q0 26 -8.5 49t-25.5 40.5t-42.5 27.5t-60.5 10t-65 -9.5t-54 -24t-42.5 -31t-30.5 -31.5l-57 57q8 10 28.5 30t53 40.5t76.5 35.5t100 15t98 -16.5t70.5 -44.5t43 -66t14.5 -80 q0 -50 -18 -85.5t-46.5 -61.5t-64.5 -45.5t-73 -36.5q-51 -24 -84.5 -46t-54 -45.5t-28.5 -50.5t-8 -61h378v-80h-490z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u.alt",
    horizAdvX: 596,
    d: "M440 0v107q-30 -56 -85 -86.5t-117 -30.5q-50 0 -83.5 17t-53 47t-27.5 70t-8 85v313h88v-296q0 -33 5 -62.5t18 -51t35 -34t57 -12.5q27 0 53 10t48 27t39 41t28 51v327h88v-522h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w.alt",
    horizAdvX: 842,
    d: "M547 0l-126 387l-127 -387h-93l-183 522h92l141 -414l128 414h84l128 -414l141 414h91l-182 -522h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y.alt",
    horizAdvX: 547,
    d: "M528 522l-281 -735h-100q1 1 8 19.5t18.5 48t26.5 67t33 78.5l-221 522h92l177 -443l163 443h84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum",
    horizAdvX: 690,
    d: "M345 -10q-74 1 -129.5 35t-93 86.5t-56.5 115.5t-19 123q0 64 20.5 128.5t59.5 116t94 83.5t124 32q74 0 129.5 -34.5t93 -87.5t56.5 -116.5t19 -121.5q0 -65 -20.5 -129t-59.5 -115t-94 -83t-124 -33zM138 350q1 -49 14.5 -98.5t39.5 -89.5t64 -65.5t89 -25.5 q53 0 92 27t64.5 68t38 90.5t12.5 93.5q0 49 -14 98.5t-40 89.5t-65 65.5t-88 25.5q-53 0 -92 -27t-64.5 -68.5t-38 -90.5t-12.5 -93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelow",
    horizAdvX: 180,
    d: "M50 -182v106h80v-106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    horizAdvX: 467,
    d: "M234 319q-49 0 -86 19t-62 49t-37.5 66.5t-12.5 70.5q0 37 14 73.5t39.5 66t62 48t82.5 18.5q49 0 85.5 -19.5t61.5 -50t37.5 -67t12.5 -69.5q0 -37 -13.5 -73.5t-39 -66t-62 -47.5t-82.5 -18zM93 524q0 -26 9 -53t27 -48.5t44 -35t61 -13.5q36 0 62.5 14.5t44 37 t26 48.5t8.5 50q0 27 -9.5 53.5t-27.5 48.5t-44 35.5t-60 13.5q-36 0 -62.5 -14.5t-44 -37t-26 -49t-8.5 -50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    horizAdvX: 280,
    d: "M259 375v-55h-210v55h80v294q-5 -6 -16 -14.5t-24.5 -16t-28 -13t-26.5 -5.5v55q16 0 32.5 8.5t30.5 18.5t23 19t9 10h56v-356h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    horizAdvX: 396,
    d: "M34 320q0 39 7.5 68.5t23 51.5t39.5 38.5t57 29.5q23 9 47.5 17.5t44 20t32 26.5t12.5 37q0 29 -24.5 48.5t-72.5 19.5t-79 -18t-47 -35l-36 39q5 7 18 18.5t34.5 22.5t51 19t66.5 8q75 0 113 -34.5t38 -88.5q0 -32 -14 -53.5t-35 -36t-45 -23.5t-44 -15 q-31 -10 -50.5 -23t-30.5 -27t-15 -28.5t-4 -27.5h231v-54h-318z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    horizAdvX: 394,
    d: "M190 314q-63 0 -105.5 23t-52.5 63l32 38q1 -11 10.5 -22.5t26 -22t39 -17t49.5 -6.5q47 0 79.5 17.5t32.5 47.5q0 33 -40 50.5t-109 17.5h-23v51h23q63 0 99 15t36 47q0 30 -30.5 47t-69.5 17q-41 0 -70 -15t-45 -39l-37 43q20 29 62 45.5t90 16.5q34 0 63 -8.5 t50.5 -23.5t33.5 -35.5t12 -44.5q0 -35 -23.5 -57t-68.5 -31q48 -7 75.5 -36t27.5 -68q0 -27 -13.5 -48.5t-37 -35.5t-53.5 -21.5t-63 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    horizAdvX: 392,
    d: "M249 325v99h-226v53l243 253h38v-252h59v-54h-59v-99h-55zM80 478h171v180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    horizAdvX: 380,
    d: "M193 584q33 0 61.5 -9.5t49.5 -26.5t33 -41t12 -52q0 -30 -13 -55t-35.5 -43t-53.5 -28t-66 -10q-51 0 -91.5 20t-60.5 54l35 34q19 -26 50 -40.5t70 -14.5q46 0 77 22.5t31 61.5q0 21 -9 37t-24 26.5t-33.5 16t-37.5 5.5q-29 0 -56.5 -13t-42.5 -34h-50q4 21 12 54.5 t16.5 68.5t15.5 66t10 47h229v-55h-188l-30 -117q16 12 38.5 19t50.5 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    horizAdvX: 409,
    d: "M378 456q0 -30 -13 -55.5t-36 -44.5t-54 -30t-67 -11q-76 0 -123 47t-47 132q0 118 48.5 177t129.5 59q45 0 82.5 -18t57.5 -51l-33 -37q-14 24 -44 39t-65 15q-56 0 -89.5 -37.5t-34.5 -106.5q15 27 49.5 42.5t72.5 15.5q36 0 66 -10.5t52.5 -29t35 -43.5t12.5 -53z M210 366q24 0 44.5 7t36.5 19.5t25 28.5t9 34t-9 34.5t-25 28.5t-37 19t-45 7t-45 -7t-37 -19t-25 -28t-9 -34t9.5 -34.5t25.5 -29t37 -19.5t45 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    horizAdvX: 365,
    d: "M271 675h-246v55h334l-239 -405h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    horizAdvX: 405,
    d: "M368 439q0 -27 -13.5 -49t-36.5 -37.5t-53 -24.5t-64 -9q-36 0 -66 9.5t-52 26t-34.5 39t-12.5 47.5q0 19 7.5 35t20 28.5t29 22t33.5 15.5q-29 11 -51.5 31t-22.5 51q0 24 13.5 44t34.5 33.5t48 21t54 7.5t54 -7.5t48 -21t34.5 -33t13.5 -43.5q0 -30 -21.5 -51 t-53.5 -32q39 -14 65 -39.5t26 -63.5zM312 445q0 17 -10 30.5t-25.5 22.5t-35.5 14t-39 5q-21 0 -41 -5t-35 -14.5t-24.5 -23t-9.5 -29.5q0 -17 10 -30t26 -22t35.5 -14t39.5 -5t39.5 5t35 14.5t25 22.5t9.5 29zM108 620q0 -14 8.5 -24.5t22 -18t30 -11t33.5 -3.5q16 0 33 4 t31 11t22.5 17.5t8.5 24.5q0 13 -8 24t-21.5 18t-30.5 11t-35 4q-38 0 -66 -15.5t-28 -41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    horizAdvX: 409,
    d: "M31 589q0 30 13 55.5t36 44.5t53.5 30t66.5 11q76 0 123.5 -47t47.5 -132q0 -118 -48.5 -177t-129.5 -59q-45 0 -83 18.5t-58 51.5l34 36q14 -25 43.5 -39.5t65.5 -14.5q55 0 89 37.5t35 106.5q-15 -26 -50 -42t-73 -16q-35 0 -65.5 10.5t-52.5 29t-34.5 43t-12.5 53.5z M199 679q-24 0 -44.5 -7t-36.5 -19.5t-25 -28.5t-9 -34t9.5 -34t25 -28t36.5 -19t45 -7t44.5 7t36.5 19t25 27.5t9 33.5t-9.5 34.5t-25 29t-36.5 19.5t-45 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    horizAdvX: 467,
    d: "M234 -5q-49 0 -86 19t-62 49t-37.5 66.5t-12.5 70.5q0 37 14 73.5t39.5 66t62 48t82.5 18.5q49 0 85.5 -19.5t61.5 -50t37.5 -67t12.5 -69.5q0 -37 -13.5 -73.5t-39 -66t-62 -47.5t-82.5 -18zM93 200q0 -26 9 -53t27 -48.5t44 -35t61 -13.5q36 0 62.5 14.5t44 37t26 48.5 t8.5 50q0 27 -9.5 53.5t-27.5 48.5t-44 35.5t-60 13.5q-36 0 -62.5 -14.5t-44 -37t-26 -49t-8.5 -50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    horizAdvX: 302,
    d: "M281 54v-54h-232v54h91v295q-6 -7 -18 -15.5t-27 -16t-31.5 -12.5t-29.5 -5v55q18 0 36.5 8.5t34 18.5t25.5 19t10 10h56v-357h85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    horizAdvX: 400,
    d: "M34 0q0 39 7.5 68.5t23 51.5t40 38.5t57.5 29.5q23 9 47 17.5t43.5 19.5t32 26t12.5 37q0 30 -24.5 49.5t-72.5 19.5q-24 0 -43.5 -5t-35.5 -13t-27.5 -17.5t-19.5 -18.5l-36 40q5 7 18.5 18.5t34.5 22.5t50.5 19t66.5 8q75 0 113 -34.5t38 -89.5q0 -32 -14 -53 t-34.5 -35.5t-44.5 -23.5t-44 -15q-31 -10 -50.5 -23t-30.5 -27t-15 -28.5t-4 -27.5h238v-54h-326z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    horizAdvX: 395,
    d: "M190 -5q-63 0 -105.5 22.5t-52.5 63.5l32 37q1 -11 10.5 -22.5t26 -22t39 -17t49.5 -6.5q47 0 79.5 17.5t32.5 47.5q0 33 -40 51t-109 18h-23v50h23q63 0 99 15t36 47q0 30 -30.5 47t-69.5 17q-41 0 -70 -15t-45 -39l-37 43q20 29 62 45.5t90 16.5q34 0 63 -8.5 t50.5 -23.5t33.5 -35t12 -44q0 -35 -23.5 -57.5t-68.5 -31.5q48 -7 75.5 -36t27.5 -68q0 -27 -13.5 -48t-37 -35.5t-53.5 -21.5t-63 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    horizAdvX: 392,
    d: "M249 0v100h-226v53l243 253h38v-252h59v-54h-59v-100h-55zM80 154h171v180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    horizAdvX: 380,
    d: "M193 260q33 0 61.5 -9.5t49.5 -26.5t33 -41t12 -53q0 -30 -13 -55t-35.5 -42.5t-53.5 -27.5t-66 -10q-51 0 -91.5 20t-60.5 53l35 34q19 -25 50 -40t70 -15q46 0 77 23t31 62q0 21 -9 37t-24 26.5t-33.5 16t-37.5 5.5q-29 0 -56.5 -13t-42.5 -34h-50q4 21 12 54.5 t16.5 68.5t15.5 66t10 47h229v-55h-188l-30 -117q16 12 38.5 19t50.5 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    horizAdvX: 410,
    d: "M379 135q0 -29 -13 -54.5t-36 -44.5t-54 -30t-67 -11q-76 0 -123 47t-47 132q0 117 48.5 176t129.5 59q45 0 82.5 -18t57.5 -51l-33 -37q-14 25 -44 39.5t-65 14.5q-56 0 -89.5 -37.5t-34.5 -106.5q15 27 49.5 42.5t72.5 15.5q36 0 66 -10.5t52.5 -29t35 -43.5t12.5 -53z M211 45q24 0 44.5 7t36.5 19.5t25 28.5t9 34t-9 34.5t-25 28.5t-37 19t-45 7t-45 -7t-37 -19t-25 -28t-9 -34t9.5 -34.5t25.5 -29t37 -19.5t45 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    horizAdvX: 365,
    d: "M272 351h-247v55h334l-239 -406h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    horizAdvX: 405,
    d: "M368 115q0 -27 -13.5 -49t-36.5 -37.5t-53 -24.5t-64 -9q-36 0 -66 9.5t-52 26t-34.5 39t-12.5 47.5q0 19 7.5 35t20 28.5t29 22t33.5 15.5q-29 11 -51.5 31t-22.5 51q0 24 13.5 44t34.5 33.5t48 21t54 7.5t54 -7.5t48 -21t34.5 -33t13.5 -43.5q0 -30 -21.5 -51 t-53.5 -32q39 -14 65 -39.5t26 -63.5zM312 121q0 17 -10 30.5t-25.5 22.5t-35.5 14t-39 5q-21 0 -41 -5t-35 -15t-24.5 -23.5t-9.5 -29.5q0 -17 10 -30t26 -22t35.5 -13.5t39.5 -4.5t39.5 5t35 14.5t25 22.5t9.5 29zM108 295q0 -14 8.5 -24.5t22 -17.5t30 -11t33.5 -4 q16 0 33 4t31 11.5t22.5 18t8.5 24.5q0 13 -8 23.5t-21.5 18t-30.5 11.5t-35 4q-38 0 -66 -15.5t-28 -42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    horizAdvX: 411,
    d: "M32 269q0 29 13 54.5t36 44.5t53.5 30t66.5 11q76 0 123.5 -47t47.5 -132q0 -118 -48.5 -176.5t-129.5 -58.5q-45 0 -83 18t-58 51l34 37q14 -25 43.5 -39.5t65.5 -14.5q55 0 89 37t35 106q-15 -26 -50 -42t-73 -16q-35 0 -65.5 10.5t-52.5 29t-34.5 43.5t-12.5 54z M200 358q-24 0 -44.5 -7t-36.5 -19.5t-25 -28.5t-9 -34t9.5 -34t25 -28t36.5 -19t45 -7t44.5 7t36.5 19t25 28t9 34t-9.5 34t-25 28.5t-36.5 19.5t-45 7z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "y.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "w.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "Y.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "V.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "T.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "J.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "A.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0394",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0142",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "v",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0129",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "#",
    u2: "4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "y.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "w.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "Y.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "X.sc",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "V.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "A.sc",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "x",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "X",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0129",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "zero.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "six.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "four.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "Y.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "V.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "U.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u04B0",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u044A",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0447",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0442",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0431",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u03C0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0259",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u018F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012B",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0129",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "(",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ")",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "S.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "J.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "A.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0457",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0455",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u044F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u044D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0434",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0430",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0414",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0410",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0408",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0394",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0259",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0135",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012B",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0129",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF0",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xEF",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xEE",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "two.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "three.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "seven.lnum",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "one.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "zero.lnum",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "y.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "six.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "four.lnum",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "five.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "eight.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "U.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "S.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "J.sc",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "A.sc",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04B0",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0455",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044F",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044D",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044A",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0445",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0442",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0437",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0436",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0434",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0431",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0430",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u042F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0425",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0424",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0414",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0410",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0408",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03BC",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0394",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0259",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u012B",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0129",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEF",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "X",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "6",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "4",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "3",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 267
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\xB0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\\\\\\\\",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ")",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xF7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\\\\\\\\",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "+",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    g2: "W.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xB0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\\\\\\\\",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "V",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    g2: "W.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xB0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\\\\\\\\",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xF7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xB0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\\\\\\\\",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "+",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xF7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "+",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2212",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xF7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xD7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xB7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xA2",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "=",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "/",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "+",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    g2: "W.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\xB0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\\\\\\\\",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "\u0166",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0166",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    g2: "seven.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "Y.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "V.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "T.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0166",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0104",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "A.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u02BC",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "v",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u012B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0129",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Z.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "S.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "J.sc",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "A.sc",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u02BC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0259",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u018F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0135",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0131",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012B",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0129",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEE",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "@",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "5",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "3",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012B",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0129",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0104",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xEF",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0104",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "J.sc",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "A.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u02BC",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0259",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0129",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: " ",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u01FC",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u01FA",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0141",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0126",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0110",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0102",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0100",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD0",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC6",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC4",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC3",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC2",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "A",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0129",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_l",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_i",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0159",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0135",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0131",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012B",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0129",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEF",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEE",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xED",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE3",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xDF",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0129",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "y.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "t.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "Z.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "U.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "S.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "J.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "A.sc",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u02BC",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0259",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0135",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0131",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012D",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEF",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xDF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAE",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xA9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "8",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "4",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0159",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0135",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0131",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012D",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012B",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0129",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEF",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xDF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "y.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "w.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "t.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "Y.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "W.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "U.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2122",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0259",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u018F",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0131",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012D",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012B",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0104",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEF",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xAE",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xA9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\\\\\\\",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: " ",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0159",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0131",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012D",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012B",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0129",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEF",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xED",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xDF",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0135",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0131",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u012B",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0129",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xEE",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u012B",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0129",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "zero.lnum",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "y.alt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "w.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "Y.sc",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.alt",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "V.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "U.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "T.sc",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u04B0",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0447",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0442",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0431",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u042A",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0427",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0424",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0422",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0416",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u018F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0166",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0135",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012D",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012B",
    k: -89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0129",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEF",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEE",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEC",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u0135",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "W",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\u0129",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0135",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0129",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "j",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "W",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u02BC",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0259",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "@",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ")",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u02BC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0259",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u012B",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0129",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0135",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "j",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA3",
    g2: "four.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0135",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "j",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0166",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    g2: "four.lnum",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "9",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "4",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "seven.lnum",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "one.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0166",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "y.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "w.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "t.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "l.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Y.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.alt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "V.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "U.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "T.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "S.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "J.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "A.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0259",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u018F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0166",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0142",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0141",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0135",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0126",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0110",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xF0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xD0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "j",
    k: -79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0166",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0104",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0166",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0104",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0166",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0104",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0166",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0104",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0166",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0104",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0166",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0104",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    g2: "seven.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xDF",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "Y.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "X.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "J.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2122",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "x",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\\\\\\\\",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "?",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "*",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ")",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "w.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "t.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "W.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "x",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\\\\\\\\",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "X",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u2122",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "*",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\\\\\\\\",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "*",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "W.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "V",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "/",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "two.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "three.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "seven.lnum",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "one.lnum",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "7",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "4",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "3",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0166",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0104",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0166",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0104",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0166",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0104",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "j",
    k: -104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "t.alt",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "l.alt",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "j.alt",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2122",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2120",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201D",
    k: -71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201C",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2019",
    k: -71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2018",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0133",
    k: -67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xFE",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xAA",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xA6",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "}",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "|",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "t",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "l",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "k",
    k: -67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "j",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "i",
    k: -67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "h",
    k: -67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "b",
    k: -67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "]",
    k: -87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\\\\\\\\",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "?",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "*",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: ")",
    k: -89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "'",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\"",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "!",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\u01FC",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\xC6",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011D",
    u2: "j",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011F",
    u2: "j",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0121",
    u2: "j",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0123",
    u2: "j",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "w.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "u.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "q.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "d.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "a.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "Q.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "O.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "G.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "C.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\uFB06",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "f_f_l",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "f_f_i",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "f_l",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "f_i",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "f_f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u1EE4",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u1ECC",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u01FE",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u01F4",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u017C",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0172",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0170",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u016E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u016C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u016A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0168",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0153",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0152",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0150",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u014E",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u014C",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0126",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0122",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0121",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0120",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u011E",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u011C",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u010C",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u010A",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0108",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0106",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xF0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xE6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xDC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xDB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xDA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD8",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD6",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD4",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xC7",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "z",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "u",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "s",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "o",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "g",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "e",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "d",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "c",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "a",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "U",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "Q",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "O",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "G",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "C",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    g2: "j.alt",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2122",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u201D",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2019",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u0133",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "}",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "l",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "k",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "h",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "b",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "]",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\\\\\\\\",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "*",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: ")",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "'",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\"",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2122",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "}",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "]",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\\\\\\\\",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "*",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: ")",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012E",
    u2: "j",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\u0129",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "j",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\u2122",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "j",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "*",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u012B",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u0104",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0104",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0104",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u2122",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1EF8",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1EF2",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1E84",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1E82",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1E80",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1E6C",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u021A",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0178",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0176",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0174",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0166",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0164",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0162",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0104",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xDD",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "Y",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "W",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "V",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "T",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "l.alt",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "j.alt",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2122",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u201D",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u201C",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2019",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2018",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0133",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xFE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xA6",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "}",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "|",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "l",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "k",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "j",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "i",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "h",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "b",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "]",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\\\\\\\\",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "*",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: ")",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "'",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\"",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0104",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "x",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014A",
    u2: "j",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "j",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\u01FC",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\xC6",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "j",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_l",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_i",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xEE",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xDF",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "j",
    k: -109
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_l",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_i",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xDF",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u2122",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u201D",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u2019",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "}",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "]",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\\\\\\\\",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: ")",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "y.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "w.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "q.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "d.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt2",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Z.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "U.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "S.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "R.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Q.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "P.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "O.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "N.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "M.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "L.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "K.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "I.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "H.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "F.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "E.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "D.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "A.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "C.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "B.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\uFB06",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_l",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_i",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u203A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2039",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2014",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2013",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u1ECC",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FA",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01F4",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u018F",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0153",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0152",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0150",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014E",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0122",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0120",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011E",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010A",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0108",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0106",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0104",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0102",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0100",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE6",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xDF",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD8",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD6",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD5",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD4",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD3",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD2",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC7",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC5",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC4",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC1",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAD",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xA9",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "z",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "y",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "x",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "w",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "v",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "u",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "s",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "r",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "p",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "o",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "n",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "m",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "g",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "e",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "d",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "c",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "a",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "Q",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "O",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "G",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "A",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ";",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ":",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "/",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "-",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xDF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xDF",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xDF",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u012B",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F5",
    u2: "j",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0166",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0104",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_l",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_i",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xEE",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xDF",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021B",
    u2: "j",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "y.alt",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "w.alt",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "t.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "l.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Z.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Y.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "X.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "W.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "V.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "U.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "T.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "S.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "J.sc",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "A.sc",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "x",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "v",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03C0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\\\\\\\\",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BC",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C0",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u044A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0442",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0436",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u042A",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0427",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0425",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0422",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\\\\\\\\",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "*",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u044F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0431",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0425",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0414",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0455",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u044F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u044A",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0447",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0442",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0437",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0436",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0425",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0410",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0455",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u044F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u044D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0437",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0436",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0434",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0431",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0430",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0414",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0410",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0408",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "/",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u044A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0442",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u042A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0427",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0422",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\\\\\\\\",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "?",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "*",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B0",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0455",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0447",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0442",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0430",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042A",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0427",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0424",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0422",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0417",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0405",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\\\\\\\\",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "*",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u044A",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0447",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0442",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0437",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0436",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0425",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0414",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0410",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04B0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0455",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u044F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0447",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0437",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0436",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0434",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0431",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u042A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0425",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0422",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0416",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0457",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0458",
    k: -127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0447",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0442",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0431",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0424",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "/",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04B0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0455",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u044F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u044D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u044A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0442",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0436",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0434",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0425",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0416",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0414",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0410",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0457",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0455",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0434",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0430",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0425",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0417",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0416",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0414",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0410",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0408",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "/",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u044F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0431",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u042F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0425",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0424",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0414",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B1",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0457",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0455",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044F",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044D",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044A",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0447",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0445",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0442",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0437",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0436",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0434",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0431",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0430",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0424",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0414",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0410",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0408",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "/",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0457",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04B0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0445",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0436",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0434",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0430",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042D",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0425",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0422",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0417",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0416",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0414",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0410",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0408",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\\\\\\\\",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "/",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: ")",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0457",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044A",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0447",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0442",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0431",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0430",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u042D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0424",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0405",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\\\\\\\\",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0458",
    k: -127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0458",
    k: -127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u044A",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0442",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\\\\\\\\",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "*",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04B1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044D",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0445",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0442",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0437",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0436",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0434",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "?",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\\\\\\\\",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "?",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "*",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0458",
    k: -110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0431",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0436",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\\\\\\\\",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "*",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\\\\\\\\",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "*",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u044F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0434",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "/",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0431",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0458",
    k: -131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0458",
    k: -131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u0458",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u044A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u0442",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\\\\\\\\",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "*",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u044F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\\\\\\\\",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\u044F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "\u0457",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "*",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0458",
    u2: "\u0458",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\u044A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\u0442",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\\\\\\\\",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "*",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0457",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0457",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u04B1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u04B0",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044D",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044A",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0447",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0445",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0442",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0437",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0436",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0434",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0431",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0430",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u042F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0424",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0414",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0410",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\\\\\\\\",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "/",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: ")",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0434",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\xDF",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "j",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xDF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xDF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\xDF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECA",
    u2: "j",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECB",
    u2: "j",
    k: -68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0126",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xDF",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xDF",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0129",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0129",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0458",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0135",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "j",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0129",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0129",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0458",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0135",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "j",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0166",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "four.denominator",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "J.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u0129",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\xF0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "seven.lnum",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0149",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0135",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012D",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012B",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0129",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEF",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEE",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEC",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u0129",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u0129",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "X.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "V.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u2122",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u02BC",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\\\\\\\\",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "X.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u2122",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u02BC",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\\\\\\\\",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "V.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "S.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2122",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2120",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u02BC",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xBA",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\\\\\\\\",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "?",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "*",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "X.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2122",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u02BC",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\\\\\\\\",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "X",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "V",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "?",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "*",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: ")",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "V",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "S.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J.sc",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "\u02BC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "X",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: " ",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "V.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u02BC",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "x",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "X",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "V",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "/",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "V.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u2122",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u02BC",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\\\\\\\\",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "?",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "*",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\u02BC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\\\\\\\\",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: " ",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y.sc",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "V.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2122",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2120",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u02BC",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xBA",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xB7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAA",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\\\\\\\\",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "V",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "?",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "*",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: " ",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "X.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u02BC",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "X",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "/",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: ")",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "\xC6",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "V.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u2122",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u02BC",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\\\\\\\\",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "?",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "X.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u2122",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u02BC",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "\u02BC",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "@",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: " ",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\\\\\\\\",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "X",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "S.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "\u02BC",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "@",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "/",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: ")",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "U.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J.sc",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0259",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u018F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0135",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0131",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012B",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0129",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xF0",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xEF",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xEE",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xDF",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xAE",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xA9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "@",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "5",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "/",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "&",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: " ",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "S.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J.sc",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "@",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: ")",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "S.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "\u02BC",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "S.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "@",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: ")",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "\u02BC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u2122",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u02BC",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\\\\\\\\",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "V",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "?",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "*",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u02BC",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u0129",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lnum",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "\u0129",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "j",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u02BC",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xF7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xB0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\\\\\\\\",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "+",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q.alt",
    u2: "j",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "zero.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "six.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "seven.lnum",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "four.lnum",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\u2212",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xF7",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xD7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xB7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xA2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\\\\\\\\",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "=",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "/",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "+",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: ")",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "#",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u02BC",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u0259",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xF0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "/",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    g2: "four.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    u2: "\xF7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u0259",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xF0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\\\\\\\\",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "/",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u0259",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xF0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\\\\\\\\",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "X",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "V",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "@",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "/",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: ")",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "seven.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\\\\\\\\",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "/",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: ")",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.numerator",
    u2: "\u2044",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ampersand",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "apostrophe",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "asterisk",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "at",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "backslash",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "copyright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eight",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eth",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordfeminine",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordmasculine",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "question",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteleft,quotedblleft",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteright,quotedblright",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quotedbl,quotesingle",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "registered",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "schwa",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "seven",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "six",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "space",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "trademark",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "zero",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "servicemark",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Schwa",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "AE,AEacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "AE,AEacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "apostrophe",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "backslash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "AE,AEacute",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J,Jcircumflex",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "slash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "parenright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "U.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "apostrophe",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "eth",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE,AEacute",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,Jcircumflex",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "colon,semicolon",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotright,guilsinglright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "apostrophe",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "backslash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "v",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "AE,AEacute",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "AE,AEacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "apostrophe",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "eth",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "apostrophe",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "eth",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "AE,AEacute",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J,Jcircumflex",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "slash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "T.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "U.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "V.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "apostrophe",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "copyright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "eth",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "registered",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "space",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "t.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "v",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "zero",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Schwa",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "slash",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T.sc",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.alt",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.sc",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y.sc",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "apostrophe",
    k: 167
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "asterisk",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "backslash",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "copyright",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotleft,guilsinglleft",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordfeminine",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordmasculine",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteright,quotedblright",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quotedbl,quotesingle",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "registered",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "seven",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "space",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "trademark",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "v",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y.alt",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "servicemark",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "AE,AEacute",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "periodcentered",
    k: 202
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "apostrophe",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "backslash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "trademark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "AE,AEacute",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J,Jcircumflex",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "slash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "parenright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "guillemotleft,guilsinglleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "AE,AEacute",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J,Jcircumflex",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "apostrophe",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "eth",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "apostrophe",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "AE,AEacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "X.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "T.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "U.sc",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "V.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "W.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Y.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "apostrophe",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "at",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "copyright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eth",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "registered",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "schwa",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "six",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "space",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "v",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w.alt",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y.alt",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "zero",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "AE,AEacute",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A.sc",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J,Jcircumflex",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J.sc",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "slash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "X.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "x",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "colon,semicolon",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "S.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Z.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "five",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "four",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "nine",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "one",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "three",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "two",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "AE,AEacute",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "J,Jcircumflex",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "apostrophe",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J,Jcircumflex",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "slash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "four",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "U.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "apostrophe",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "at",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "copyright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eight",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eth",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "registered",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "schwa",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "six",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "space",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "zero",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Schwa",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A.sc",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Z.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "five",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "four",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "nine",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "one",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "three",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "two",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "AE,AEacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J,Jcircumflex",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotright,guilsinglright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "U.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "V.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "W.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ampersand",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "apostrophe",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "at",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "copyright",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eight",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eth",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "registered",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "schwa",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "six",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "space",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "v",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "zero",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Schwa",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "AE,AEacute",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A.sc",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "slash",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "colon,semicolon",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotright,guilsinglright",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "five",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "four",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "nine",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "one",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "three",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "two",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "U.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "apostrophe",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "copyright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "eth",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "registered",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "schwa",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "t.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Schwa",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "apostrophe",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "asterisk",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "backslash",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "ordmasculine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quotedbl,quotesingle",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "trademark",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "servicemark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "apostrophe",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "backslash",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "V",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W.alt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "apostrophe",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "asterisk",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "backslash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "ordmasculine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "question",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteleft,quotedblleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "trademark",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "servicemark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "X",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "J,Jcircumflex",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "slash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "parenright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "x",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "braceright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "bracketright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "V",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "apostrophe",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "asterisk",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "backslash",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "eth",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "guillemotleft,guilsinglleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "trademark",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "apostrophe",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "V",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "apostrophe",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "backslash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "trademark",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "AE,AEacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "J,Jcircumflex",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "parenright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "AE,AEacute",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "J,Jcircumflex",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "V",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W.alt",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "apostrophe",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "asterisk",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "backslash",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "eth",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotleft,guilsinglleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "schwa",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "space",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "trademark",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "X",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "J,Jcircumflex",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "slash",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "braceright",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "bracketright",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "AE,AEacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "apostrophe",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "asterisk",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "backslash",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "question",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "trademark",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "apostrophe",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "apostrophe",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "backslash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "eth",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "guillemotleft,guilsinglleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "schwa",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "apostrophe",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "asterisk",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "backslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "copyright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordfeminine",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordmasculine",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "question",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteleft,quotedblleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quotedbl,quotesingle",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "registered",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "space",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "trademark",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "servicemark",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "periodcentered",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "apostrophe",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "backslash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "question",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "trademark",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "V",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W.alt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "apostrophe",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "asterisk",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "backslash",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quotedbl,quotesingle",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "trademark",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "servicemark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "X",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "J,Jcircumflex",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "parenright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "x",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "apostrophe",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "eth",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "space",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "AE,AEacute",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "J,Jcircumflex",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "slash",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "apostrophe",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "backslash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "trademark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "AE,AEacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "backslash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "eth",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "schwa",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "AE,AEacute",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "J,Jcircumflex",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "apostrophe",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "backslash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "guillemotleft,guilsinglleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "AE,AEacute",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "J,Jcircumflex",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "apostrophe",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "backslash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "eth",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "space",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "AE,AEacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "parenright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "AE,AEacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "J,Jcircumflex",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "guillemotleft,guilsinglleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "V",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "apostrophe",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "at",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "backslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "eth",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "schwa",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "AE,AEacute",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "X",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "J,Jcircumflex",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "slash",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "parenright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "AE,AEacute",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "J,Jcircumflex",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "V",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "apostrophe",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "backslash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "schwa",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteleft,quotedblleft",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteright,quotedblright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quotedbl,quotesingle",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "AE,AEacute",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "AE,AEacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J,Jcircumflex",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "AE,AEacute",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J,Jcircumflex",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "AE,AEacute",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "apostrophe",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteleft,quotedblleft",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteright,quotedblright",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quotedbl,quotesingle",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "AE,AEacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "backslash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "question",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "trademark",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "AE,AEacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "slash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "parenright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "AE,AEacute",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J,Jcircumflex",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "AE,AEacute",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J,Jcircumflex",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J,Jcircumflex",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "AE,AEacute",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J,Jcircumflex",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "AE,AEacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J,Jcircumflex",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "AE,AEacute",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J,Jcircumflex",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotright,guilsinglright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "periodcentered",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "AE,AEacute",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "J,Jcircumflex",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni03A9,Omega",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0409,uni041B",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0404,uni041E,uni0421",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni043B,uni0459",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0443,uni045E",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quoteright,quotedblright",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quotedbl,quotesingle",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "AE,AEacute",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "AE,AEacute",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "J,Jcircumflex",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni03A9,Omega",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni0409,uni041B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni043B,uni0459",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni0452,uni045B",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quotedbl,quotesingle",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quoteright,quotedblright",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quotedbl,quotesingle",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "AE,AEacute",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0404,uni041E,uni0421",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0443,uni045E",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0402,uni040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni0402,uni040B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni0422",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni042A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "AE,AEacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "AE,AEacute",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0402,uni040B",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0422",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni042A",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni040E,uni0423",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni04B0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y.sc",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quoteright,quotedblright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quotedbl,quotesingle",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "v",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "AE,AEacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J,Jcircumflex",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni043B,uni0459",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0443,uni045E",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0402,uni040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0422",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni042A",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni040E,uni0423",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni04B0",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "pi",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0408",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0410",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0414",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0416",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0425",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0427",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni042F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0434",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0436",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0442",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0445",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni044A",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni044D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni04B1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J,Jcircumflex",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J.sc",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "x",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Z.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "three",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0443,uni045E",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0402,uni040B",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0422",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni042A",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni040E,uni0423",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni04B0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0408",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0425",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0427",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0437",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0442",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0445",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni044A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "quotedbl,quotesingle",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "AE,AEacute",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "quotedbl,quotesingle",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T.sc",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.alt",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteleft,quotedblleft",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteright,quotedblright",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quotedbl,quotesingle",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "seven",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y.alt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Schwa",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0404,uni041E,uni0421",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0443,uni045E",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0402,uni040B",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0422",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni042A",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni040E,uni0423",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni04B0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "pi",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0427",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0442",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni044A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0447",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "J,Jcircumflex",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "eth",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "schwa",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE,AEacute",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0409,uni041B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni043B,uni0459",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0408",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0410",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0414",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0434",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0394",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni044F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0455",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "at",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "eth",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotleft,guilsinglleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "space",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE,AEacute",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J,Jcircumflex",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "slash",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0409,uni041B",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni043B,uni0459",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0408",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0410",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0414",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0434",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni044D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni044F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0455",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "at",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "eth",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "schwa",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "space",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "AE,AEacute",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J,Jcircumflex",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "slash",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "five",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "nine",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0409,uni041B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni043B,uni0459",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0408",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0410",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0414",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0394",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni044F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0455",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four.lnum",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "AE,AEacute",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "J,Jcircumflex",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "AE,AEacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quoteright,quotedblright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "AE,AEacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "J,Jcircumflex",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "AE,AEacute",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "AE,AEacute",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "AE,AEacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "AE,AEacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "J,Jcircumflex",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "AE,AEacute",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "AE,AEacute",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "AE,AEacute",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0404,uni041E,uni0421",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "quoteright,quotedblright",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "quotedbl,quotesingle",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A9,Omega",
    g2: "backslash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "pi",
    g2: "guillemotleft,guilsinglleft",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "pi",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quoteleft,quotedblleft",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quoteright,quotedblright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quotedbl,quotesingle",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0443,uni045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0402,uni040B",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni040E,uni0423",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0404",
    g2: "uni0409,uni041B",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0404",
    g2: "uni0404,uni041E,uni0421",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0405",
    g2: "uni0409,uni041B",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0405",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0405",
    g2: "uni0443,uni045E",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni0409,uni041B",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni043B,uni0459",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quoteleft,quotedblleft",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quoteright,quotedblright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0443,uni045E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0402,uni040B",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni040E,uni0423",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quoteleft,quotedblleft",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quoteright,quotedblright",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quotedbl,quotesingle",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0404,uni041E,uni0421",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0443,uni045E",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0402,uni040B",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni040E,uni0423",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni0409,uni041B",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni0443,uni045E",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0409,uni041B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0443,uni045E",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0402,uni040B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni040E,uni0423",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "guillemotleft,guilsinglleft",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "slash",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "colon,semicolon",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "guillemotright,guilsinglright",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0409,uni041B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0404,uni041E,uni0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni043B,uni0459",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 157
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0443,uni045E",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0452,uni045B",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0408",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0410",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0414",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni042F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0434",
    k: 151
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0436",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0437",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0442",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0445",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044A",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044D",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni04B1",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0424",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0447",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044F",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0455",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0430",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0431",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "asterisk",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "backslash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0404,uni041E,uni0421",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0443,uni045E",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0402,uni040B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0422",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni042A",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni04B0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0427",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0442",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni044A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0424",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0447",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0431",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0404,uni041E,uni0421",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0442",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni044A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0424",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0447",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0431",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "guillemotleft,guilsinglleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0404,uni041E,uni0421",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0443,uni045E",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0409,uni041B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni043B,uni0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0443,uni045E",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni040E,uni0423",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0447",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni044F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0455",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0430",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "slash",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0404,uni041E,uni0421",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0443,uni045E",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0424",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0447",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0431",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni042D",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "backslash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "slash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "parenright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0409,uni041B",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni043B,uni0459",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0443,uni045E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0402,uni040B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0422",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042A",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni040E,uni0423",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni04B0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0408",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0410",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0414",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0425",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0434",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0436",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0430",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042D",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0417",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0456,uni0457,uni0458",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "guillemotleft,guilsinglleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni0409,uni041B",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni043B,uni0459",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0421",
    g2: "uni0409,uni041B",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0421",
    g2: "uni0404,uni041E,uni0421",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "guillemotleft,guilsinglleft",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "colon,semicolon",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "guillemotright,guilsinglright",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0409,uni041B",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0404,uni041E,uni0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni043B,uni0459",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0443,uni045E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0452,uni045B",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "guillemotleft,guilsinglleft",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "slash",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "colon,semicolon",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "guillemotright,guilsinglright",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0409,uni041B",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0404,uni041E,uni0421",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni043B,uni0459",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0443,uni045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0408",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0410",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0414",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni042F",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0434",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0436",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0437",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0442",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0445",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni044D",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni04B1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0424",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0447",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni044F",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0455",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0430",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0431",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni042D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0417",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0405",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni0409,uni041B",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni043B,uni0459",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni0443,uni045E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni0402,uni040B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni040E,uni0423",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0404,uni041E,uni0421",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0443,uni045E",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "asterisk",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "backslash",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "question",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quoteleft,quotedblleft",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quoteright,quotedblright",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quotedbl,quotesingle",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "parenright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0443,uni045E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0402,uni040B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0422",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni042A",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni040E,uni0423",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni04B0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0425",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni042F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0436",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0442",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0445",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni044A",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni04B1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "guillemotright,guilsinglright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0409,uni041B",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0404,uni041E,uni0421",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni043B,uni0459",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0443,uni045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quotedbl,quotesingle",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "uni0443,uni045E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0431",
    g2: "uni043B,uni0459",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0431",
    g2: "uni0443,uni045E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "guillemotleft,guilsinglleft",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "slash",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni043B,uni0459",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni0434",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "asterisk",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "backslash",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "guillemotleft,guilsinglleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0443,uni045E",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0442",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni044A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni04B1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0447",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0431",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "backslash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "parenright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni043B,uni0459",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0443,uni045E",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0434",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0436",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0442",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni044A",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "uni0443,uni045E",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0438,uni0439,uni043B,uni043C,uni043D,uni043F,uni0447,uni0448,uni044B,uni044F,uni045D,uni045F",
    g2: "backslash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "backslash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni044D",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0430",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0431",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "asterisk",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "backslash",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quotedbl,quotesingle",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "parenright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni043B,uni0459",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0443,uni045E",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0434",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0436",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0437",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0445",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni044A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni044D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni04B1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "guillemotleft,guilsinglleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni0443,uni045E",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "guillemotleft,guilsinglleft",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "uni043B,uni0459",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "backslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "guillemotleft,guilsinglleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "slash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "parenright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni043B,uni0459",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0434",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0437",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni044D",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni044F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0455",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0430",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "guillemotleft,guilsinglleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "asterisk",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "backslash",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "question",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quoteleft,quotedblleft",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quoteright,quotedblright",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quotedbl,quotesingle",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0443,uni045E",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni044A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni04B1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0447",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quoteleft,quotedblleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "uni0443,uni045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "uni0443,uni045E",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "uni0443,uni045E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quoteleft,quotedblleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "uni0443,uni045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "guillemotleft,guilsinglleft",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 10
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalewayMedium);
export default __webpack_public_path__ + "static/media/Raleway-Medium.de70e1e6712a2be206863e75234be737.svg";
export { ForwardRef as ReactComponent };